var _polygon, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _polygon2, _polygon3, _polygon4, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImage6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-73"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-73",
    cx: 250,
    cy: 318.12,
    rx: 239.21,
    ry: 138.11,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-73"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-73",
    d: "M446.87,281.13c-22.6-13.05-59.25-13.05-81.85,0s-22.6,34.2,0,47.25,59.25,13.05,81.85,0S469.47,294.18,446.87,281.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-73",
    d: "M39.69,434.91l65.68,37.92a6.38,6.38,0,0,0,5.8,0l96.34-55.6c1.6-.93,1.6-2.43,0-3.35L141.82,376a6.38,6.38,0,0,0-5.8,0l-96.33,55.6C38.08,432.48,38.08,434,39.69,434.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-73",
    d: "M270.83,430.56l132.75-76.64c1.56-.9,1.56-2.37,0-3.28L228.24,249.41a6.31,6.31,0,0,0-5.68,0L89.82,326.05c-1.57.91-1.57,2.38,0,3.28L265.16,430.56A6.23,6.23,0,0,0,270.83,430.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-73",
    d: "M354.55,470.19a10.54,10.54,0,0,1-5.21-1.3L299.24,440a5.78,5.78,0,0,1,0-10.41l89.41-51.62a11.07,11.07,0,0,1,10.41,0l50.1,28.93a5.77,5.77,0,0,1,0,10.41l-89.41,51.62A10.53,10.53,0,0,1,354.55,470.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-73",
    d: "M16.48,290.47l71-41a3.41,3.41,0,0,1,3.11,0l51.74,29.87c.86.5.86,1.3,0,1.79l-70.95,41a3.45,3.45,0,0,1-3.1,0L16.48,292.26C15.62,291.77,15.62,291,16.48,290.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-73",
    d: "M477,344.32c-15.06-8.7-39.49-8.7-54.56,0s-15.07,22.8,0,31.5,39.5,8.7,54.56,0S492,353,477,344.32Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chartacter--inject-73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-73"
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "389.66 300.65 384.88 298.82 386.51 295.68 389.42 298.4 389.66 300.65"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M394.78,292.31s.14,3,.16,4-4.23,3.86-5.28,4.34l-.24-2.25A17.58,17.58,0,0,0,387,302c-.83,1.35-1.91,3.92-4.16,5.64-3.35,2.56-8.52,3.8-13.78,3.9s-8.24-1.19-9.71-2.32-1.93-2.43-1.53-3.72S394.78,292.31,394.78,292.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.9,281.72l0-1.76c-1,0-1.13,2.5-2.58,4.72a45.74,45.74,0,0,1-7.55,9.05c-5.4,4.63-10.21,7.51-12.62,9.59-3.23,2.78,2.29,7.38,10.87,7.05,4.25-.16,11.85-2.12,14-4.52s3.54-6.19,5.27-7.93,5.41-3.48,6.51-5.61c.6-1.17.34-3.94,0-6.29-.28-2.15-.29-5.45-1.55-5.2l-.1,1.1c-.53.93-1.74,2.47-5.18,3C386.26,285.15,381.15,285.22,380.9,281.72Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.22,284.94c-1.63-.16-3.39-.72-4.05-2.16l0,0A3.94,3.94,0,0,1,380,286.1c-1.56,1.72-11.45,13.83-11.45,13.83s9.18-10,10.94-11.85c2.6-2.78,3.42-3.1,5.76-3.14Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383,288.16a.52.52,0,0,0,1-.1.53.53,0,0,0-.57-.46A.52.52,0,0,0,383,288.16Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.45,290.83a.53.53,0,1,0,.47-.55A.51.51,0,0,0,380.45,290.83Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.88,293.5a.52.52,0,0,0,1-.09.52.52,0,0,0-.57-.46A.5.5,0,0,0,377.88,293.5Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.3,296.18a.51.51,0,0,0,.57.45.5.5,0,0,0,.47-.55.52.52,0,0,0-1,.1Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.72,298.85a.53.53,0,1,0,.48-.56A.53.53,0,0,0,372.72,298.85Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.56,288.31a.2.2,0,0,0,.14-.06.19.19,0,0,0,0-.28,8.67,8.67,0,0,0-5.89-2.37h0a.2.2,0,1,0,0,.4,8.47,8.47,0,0,1,5.57,2.25A.17.17,0,0,0,383.56,288.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381,291a.38.38,0,0,0,.13-.06.21.21,0,0,0,0-.29,8.74,8.74,0,0,0-5.89-2.37h0a.21.21,0,1,0,0,.41,8.39,8.39,0,0,1,5.57,2.25A.27.27,0,0,0,381,291Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.41,293.66a.2.2,0,0,0,.14-.06.21.21,0,0,0,0-.29,8.8,8.8,0,0,0-5.89-2.37h0a.21.21,0,0,0,0,.41,8.48,8.48,0,0,1,5.57,2.25A.23.23,0,0,0,378.41,293.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.83,296.33a.2.2,0,0,0,.14-.06.21.21,0,0,0,0-.29,8.74,8.74,0,0,0-5.89-2.37h0a.21.21,0,0,0-.2.22.2.2,0,0,0,.22.19,8.5,8.5,0,0,1,5.57,2.25A.18.18,0,0,0,375.83,296.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.26,299a.19.19,0,0,0,.13-.05.2.2,0,0,0,0-.29,8.69,8.69,0,0,0-5.89-2.37h0a.19.19,0,0,0-.19.21.21.21,0,0,0,.21.2,8.43,8.43,0,0,1,5.57,2.24A.19.19,0,0,0,373.26,299Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.78,315.77c.68,4,1.62,6.58,3.35,8.77s4.87,2.49,7.21,2a9.9,9.9,0,0,0,7.86-7.36c.79-2.73.31-5.88-.74-9.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.27,285.34c1.17,0,2.1,5.31,3.36,10.63,1.36,5.71,3.53,8.75,4.56,12.58,1.42,5.32,1.3,7.79-.3,11.26s-9.71,7.65-13.63,3.32c-3.21-3.54-3.79-7.76-4.13-13.19a136.29,136.29,0,0,0-1.26-13.78c-.68-4-1.4-7.93-.45-8.48.15.59.31,1.33.45,1.91s.47,2.62,1.12,2.58a8.72,8.72,0,0,0-.15-1.53,1.72,1.72,0,0,1,.17-1.34,2.22,2.22,0,0,1,1.22-.69,32.67,32.67,0,0,1,3.37-.87,17,17,0,0,1,1.72-.25,19.47,19.47,0,0,1,3-.19,1,1,0,0,1,.69.48,2.07,2.07,0,0,1,.13.61,4.52,4.52,0,0,0,.26,1.1c.06.15.2.34.36.28s.17-.21.15-.35c-.07-.65-.2-1.11-.32-1.87-.05-.35-.16-.82-.21-1.17S438.34,285.68,438.27,285.34Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.1,310.33a.4.4,0,0,1-.31.47.42.42,0,0,1-.48-.31.38.38,0,0,1,.31-.46A.4.4,0,0,1,442.1,310.33Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.3,306.64a.38.38,0,0,1-.31.46.4.4,0,0,1-.48-.3.39.39,0,0,1,.31-.47A.4.4,0,0,1,441.3,306.64Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.55,303.15a.4.4,0,0,1-.31.47.43.43,0,0,1-.49-.31.41.41,0,0,1,.32-.47A.42.42,0,0,1,440.55,303.15Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.81,299.71a.41.41,0,0,1-.8.16.39.39,0,0,1,.31-.46A.41.41,0,0,1,439.81,299.71Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.73,301.21a.39.39,0,0,1-.31.47.4.4,0,0,1-.48-.3.39.39,0,0,1,.31-.47A.4.4,0,0,1,430.73,301.21Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.48,304.68a.38.38,0,0,1-.31.46.4.4,0,0,1-.48-.3.39.39,0,0,1,.31-.47A.4.4,0,0,1,431.48,304.68Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.24,308.16a.41.41,0,0,1-.8.16.4.4,0,0,1,.32-.46A.41.41,0,0,1,432.24,308.16Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433,311.86a.4.4,0,0,1-.32.46.4.4,0,0,1-.48-.3.41.41,0,0,1,.32-.47A.42.42,0,0,1,433,311.86Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.63 313.27 430.65 287.53 432.13 287.34 436.63 313.27",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.75,310.61h-.07c-2.73-.3-7.25.44-8.94,1.47a.2.2,0,1,1-.22-.34c1.79-1.09,6.35-1.84,9.21-1.53a.2.2,0,0,1,.18.22A.21.21,0,0,1,441.75,310.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441,306.91a.14.14,0,0,1-.11,0c-2.14-.72-7,.31-8.9,1.49a.21.21,0,0,1-.28-.06.21.21,0,0,1,.06-.28c2-1.23,7-2.29,9.25-1.52a.19.19,0,0,1,.13.25A.18.18,0,0,1,441,306.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.19,303.43h-.11c-2.13-.72-7,.31-8.89,1.48a.22.22,0,0,1-.29-.06.2.2,0,0,1,.07-.28c2-1.23,7-2.28,9.25-1.52a.21.21,0,0,1,.13.26A.23.23,0,0,1,440.19,303.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.45,300a.21.21,0,0,1-.11,0c-2.14-.72-7,.31-8.9,1.48a.2.2,0,1,1-.21-.33c2-1.23,7-2.29,9.25-1.53a.2.2,0,0,1,.12.26A.18.18,0,0,1,439.45,300Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.61,154.42c2.29,33.1,3.4,78.16,3.4,78.16.21,2.51,2.57,13.26,3.67,25.66,1.16,13.09,1.93,37.58,1.93,37.58s-9.48,4.81-17.08,2.25c0,0-7.69-41.32-11.42-56.77-3.53-14.62-9-42.31-9-42.31l-4.28,27.29s.41,9.43.05,16c-.43,7.66-5.93,44.47-5.93,44.47s-10.31,5.74-18.17-.24c0,0-.76-50.86-.87-60.09-.22-18.11,2.38-53.17,3.35-76.54Z",
    style: {
      fill: "#263238"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M419.29,192.32q.93,11.91,2.1,23.79.57,5.94,1.19,11.88l.62,5.94.33,3c.1,1,.29,2,.44,3,1.25,7.86,3.14,22.13,4.52,30s2.83,15.67,4.41,23.48q-1.45-11.85-3.21-23.65c-1.17-7.87-3-22.15-4.27-30-.15-1-.35-2-.46-2.95l-.33-3-.7-5.93q-.71-5.92-1.45-11.84Q421,204.15,419.29,192.32Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M381.56,189.65c-.94,7.39-1.49,14.81-1.9,22.24s-.81,14.88-.61,22.31.14,19.9.34,27.34.45,14.87.82,22.3q.32-11.16.34-22.3c0-7.44.05-19.9,0-27.33l-.07-5.57,0-1.4,0-1.38.07-2.78.27-11.14.32-11.15C381.22,197.08,381.39,193.37,381.56,189.65Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M405.12,199,402,180.83s-9.24-1.41-13.93-5.59c0,0,3,5.49,11.7,7.73l3.11,16-2.05,27.27Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361.65,117.77s-13.4-10.48-17.85-13.39-3.8-6-5.24-9.34h0c-1.44-3.28-3.71-4.7-5.55-7.67s-2.3-4.9-3.76-3.35.32,5.64.55,6.58c.12.46.75,1.39.88,2s-.24,1-2.13.28c-3.78-1.4-9.7-8.19-11.22-9.57s-2.28.81-1.91,2.52-1.19,5.62-.57,8.46c.67,3,1.14,4.38,4.1,7.27A89.84,89.84,0,0,0,331,111.07c5,3,6.84,5,15.12,14.61,6.24,7.24,10.91,14.31,17.31,10.73Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.81,87.48a14.75,14.75,0,0,0-8.49,2.64c-1.72,1-3,2.3-6.62,6.19s-18.5,21.4-18.5,21.4,1.5,6.88,1.66,19.94c3.35.52,6.5-2.73,10.79-6.28,8.08-6.68,18-17.61,26.21-26.77Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.45,116c-1.16.08-1.66-.66-2.37-.2,0,0,1.26,3.38-.56,9.52s-6.19,7.53-6.19,7.53l-1.19-1.28s-.87,1,1,3.26,3.53,4,7,4.21,6.73-1.75,6.83-3.29,1.64-8.1-.5-14.79C364.2,117.2,362.67,115.89,361.45,116Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.92,116.27c3.05,4.07,3,11.78,1.39,17.44C364.43,129.51,366.13,121.16,360.92,116.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.86,125.43c.16,5-1.73,8.59-6.88,9.92C358.55,133.5,360.89,130.25,361.86,125.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M435.18,91.84s5.91,5,2.94,17.12a180.11,180.11,0,0,0-4.06,24c-.51,6.4-.05,28-.05,28-9.8,11.44-50.22,8-55.12-2.57,0,0-.09-40.93,3.74-55.38,2.17-8.18,5.14-12.92,8.28-15.21l13.78-3.09h12.5Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.8,48.68s2.71.07,4.67,3.39c1,1.67,1.79,4.76-.19,13.83A36.15,36.15,0,0,1,421.5,76,4.44,4.44,0,0,1,419,78.19l-.18-6.89V66.5s-3.29-4-3.8-7.47c-.66-4.41.18-6.27.18-6.27Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.74,48.86c-.87-3.83-6-8.18-15.5-8.19-7.77,0-12.16,2.9-14.62,7.56s-.37,10.41-.37,10.41l24.26-2.87Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.25,73c-2.62,1.53-5.25-.81-5.25-.81l.21,13.36s-.14,2.75-4.37,5.38c-6,3.72-8.63,4.68-11.1,8.46-2.31-6-4.72-9.31-1-14.15l-.15-2.39a22.79,22.79,0,0,1-4.29.09c-3.18-.34-5.29-2.74-6.41-6.1-1.65-5-2.62-13-1.17-21.75a7.38,7.38,0,0,1,2.39-4.36c6-5.17,13.16-2,18.54-.21a9.91,9.91,0,0,0,6.63-.37c-1.73,2.13-2.52,4.14-2.08,13.91a6,6,0,0,0,1.45,1.7c1.21.94,2-1.7,2.93-2.76a4,4,0,0,1,6.26,1.1A6.53,6.53,0,0,1,425.25,73Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.29,58.28l3.56,1.34a2,2,0,0,0-1.16-2.51A1.85,1.85,0,0,0,407.29,58.28Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.07,59.16l3.62-1.26a1.84,1.84,0,0,0-2.37-1.22A2,2,0,0,0,394.07,59.16Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.48,62a1.55,1.55,0,1,1-1.57-1.53A1.54,1.54,0,0,1,409.48,62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398,62a1.55,1.55,0,1,1-1.58-1.53A1.42,1.42,0,0,1,398,62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.63,58.83l-.76,9.91-5.3-1.64A23.12,23.12,0,0,1,403.63,58.83Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.24,63.22c-.31,6.75-2.64,7.22-5,7.62-3.18.52-4.75-1.19-10.43-1.19-3.45,0-4.53,1-6.49,1.83-1.45.6-2.63.42-3.18-.88A22.62,22.62,0,0,1,391,63.31a54.07,54.07,0,0,0,.28,11.07c.47,3.17,1.63,5.89,3.39,7.37,2.43,2.06,7.51,2.89,13.86,1.49s8.75-4,9.52-6.29c2.47-7.29,1.5-10.73,2.33-12.11S417.24,63.22,417.24,63.22Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.55,71.68c3.24-.07,4.3.51,4.46,2.74.23,3.18.07,4.25-1.15,4.41-1.43.2-2.48.29-2.53-.61a3.54,3.54,0,0,1,.21-2c.5-.61.32-.7-1.1-.67s-1.41.29-1,.73.29,1.41.28,2-.15,1-2.2.75c-1.79-.17-1.48-1.6-1.45-4.33C398.1,72.86,398.87,71.75,402.55,71.68Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.62,72.17l-5.29.73a2.63,2.63,0,0,0,2.95,2.36A2.79,2.79,0,0,0,405.62,72.17Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.93,73a3.39,3.39,0,0,1,.64,0,2.76,2.76,0,0,1-2.29,2.24,2.41,2.41,0,0,1-.85,0A2.44,2.44,0,0,1,404.93,73Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tie--inject-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M402.18,98.85s-2.3-4.46-2.29-6.2l2.85-2.89.83,7.25Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.18,98.85s-2.3-4.46-2.29-6.2l2.85-2.89.83,7.25Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.05 97.32 410.89 94.08 414.89 96.81 407.47 100.53 406.05 97.32",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.05 97.32 410.89 94.08 414.89 96.81 407.47 100.53 406.05 97.32",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.13,142c-2.43-13.76-2.72-35.32-2.41-39.09l-2.63-.27c-1.86,4.51-7.36,26.52-7.3,37.24-.16,3.74,4.59,13.79,7.11,13.89S408.53,144.25,408.13,142Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.13,142c-2.43-13.76-2.72-35.32-2.41-39.09l-2.63-.27c-1.86,4.51-7.36,26.52-7.3,37.24-.16,3.74,4.59,13.79,7.11,13.89S408.53,144.25,408.13,142Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.88,103.22c.08-.24.14-.39.21-.57h0l2.63.27h0c0,.32,0,.64,0,1.16A4.58,4.58,0,0,1,402.88,103.22Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.12,97a11.1,11.1,0,0,0-2.49-.12,6,6,0,0,0-1.45,2,9.08,9.08,0,0,0,.91,3.8,3.14,3.14,0,0,0,2.63.27,5.53,5.53,0,0,0,1.92-2.52A5,5,0,0,0,406.12,97Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.12,97a11.1,11.1,0,0,0-2.49-.12,6,6,0,0,0-1.45,2,9.08,9.08,0,0,0,.91,3.8,3.14,3.14,0,0,0,2.63.27,5.53,5.53,0,0,0,1.92-2.52A5,5,0,0,0,406.12,97Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.07,96.94c.08,0,.2.2.28.22,1.84-1,2.13-1.33,2.62-1.19.92.27,3.09,4.11,3.63,5.35s.45,1.23,2.14.11A30.24,30.24,0,0,0,422.43,94a22.69,22.69,0,0,0,3.05-6.1s-1.93-2.67-2.5-3.69c-1.09-2-1.71-2.76-2.83-2.59l0,1.28c-.19,1.72-2,3.35-4.38,5.43s-6.29,4-7.21,4.93A18.2,18.2,0,0,0,406.07,96.94Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.35,98.4c.27.7,2.49-4.78,3.59-4.67.53,0,1.71,1.53,2.69,3.1l.75,0a16.71,16.71,0,0,1-1.13-4.18,51,51,0,0,1,.52-7.42l-.14-1.3-1,0a7.34,7.34,0,0,0-.95,1.28c-1.08,1.75-3.86,5-4.21,7.05A18.11,18.11,0,0,0,397.35,98.4Z",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "349.87 117.04 393.32 128.72 408.84 178.16 407.97 179.24 366.59 167.31 349 118.12 349.87 117.04",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.46 129.79 407.97 179.24 408.84 178.16 393.32 128.72 392.46 129.79",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349 118.12 392.46 129.79 407.97 179.24 366.59 167.31 349 118.12",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M362.54,127.45s-.21-.74-.48-1.66,2.26-.62,5.63.67l7.82,1.72c3.37,1.29,6.53,2.2,6.8,3.12l.48,1.66Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M359.44,120c-.17-.57.81-.53,2.19-.27l2.5.64s-1.18-2.37,4.7-1.25c6.48,1.23,6.86,4.39,6.86,4.39a27.21,27.21,0,0,0,3.13.87c2.16.53,2.42.92,2.64,1.5l.4,1L359.71,121S359.61,120.59,359.44,120Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362,123.07c2.06.76,2.93,1.14,3.33,2.55.47,1.61.6,2.29.6,2.29l11.57,3.57s-.8-2.37-1-3.16,1.27-.92,3.29-.17l-.62-2-18-5.15Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362,127.53s-.21-.75-.48-1.67,2.26-.61,5.63.67l7.82,1.73c3.37,1.28,6.54,2.19,6.8,3.11l.48,1.66Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.32,109.41c-2.11-13.06-5.95-15.25-13.28-16.69-6.65,10.35-2.58,25.76-2.58,25.76l4,21.4c-1.22,1-19.81,11.77-23,12.85-1.16.4-3.36,0-4.53-.43-3.14-1-5.33-.69-8.36-.52l1.35,4.31c-4.82,1.68-9.93,1.58-15,1.69-.48,0-1.07.08-1.26.53a1,1,0,0,0,.42,1.14,4.49,4.49,0,0,1,1,.86c.37.57.22,1.32.32,2a5.21,5.21,0,0,0,1.53,2.54,12.1,12.1,0,0,0,2.51,2.29c3.09,1.89,7.81,2.07,11.29,1.47a37.53,37.53,0,0,0,6.93-2.14c2.11-.81,15-4.78,16.56-5.33,11.39-4.13,27.06-9.21,27.92-14.64S450.53,123.15,448.32,109.41Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.18,91.84c8.61,3.5,9.94,3.85,12.26,10.51,2.25,6.45,7.13,35.59,6.82,43.27-5.07-4.28-12-5.69-17.78-5.74L432,118.65C430.67,112.86,427.51,100.84,435.18,91.84Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.82,137.11c-.5.25.27,1,0,2s-1.47,1.47-1.26,2c0,0,6.91-.79,11.48,2.68s4.35,7.14,4.35,7.14l-1,.67s1.29,1.92,3.34-.19,3-6.11,2.57-9.46,0-4.93-1.6-5.46S442.3,134,435.82,137.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.69,139.41h0c1.81-1.2,9.55-2.15,13.89,1.23-2-2.57-7.27-4.5-13.75-2.25h0a1.8,1.8,0,0,1,0,.76A2,2,0,0,1,435.69,139.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.12,147.41c-1.16-3.32-5.37-6.54-9.51-7.34C448.6,140.66,452.28,142.62,453.12,147.41Z",
    style: {
      fill: "#e0e0e0"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Symbols--inject-73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--question-marks--inject-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.75,47a10.7,10.7,0,0,1,2.9.82A8.24,8.24,0,0,1,354,49.36a6.57,6.57,0,0,1,1.52,2.27,5.72,5.72,0,0,1,.3,2.88,5.94,5.94,0,0,1-.7,2.19,7.24,7.24,0,0,1-1.26,1.57,11.17,11.17,0,0,1-1.56,1.2l-1.56,1a8.84,8.84,0,0,0-1.32,1,2.72,2.72,0,0,0-.78,1.24,1.26,1.26,0,0,1-.37.58.75.75,0,0,1-.61.18l-2.45-.33a.92.92,0,0,1-.6-.34.74.74,0,0,1-.16-.65,5.77,5.77,0,0,1,.83-2.14,7.84,7.84,0,0,1,1.36-1.55,11.17,11.17,0,0,1,1.6-1.18q.84-.51,1.56-1a7,7,0,0,0,1.21-1,2,2,0,0,0,.59-1.19,2.45,2.45,0,0,0-.76-2.15,4.49,4.49,0,0,0-2.64-1.16A4.27,4.27,0,0,0,343.84,53a1.88,1.88,0,0,1-.41.48.82.82,0,0,1-.63.1l-2.61-.35a.72.72,0,0,1-.47-.26.68.68,0,0,1-.14-.54,5.11,5.11,0,0,1,1-2.22,8.15,8.15,0,0,1,2.06-1.89,9.69,9.69,0,0,1,2.82-1.21A8.42,8.42,0,0,1,348.75,47Zm-1.16,18.49a.89.89,0,0,1,.58.34.85.85,0,0,1,.17.65L348,69.28a.88.88,0,0,1-1,.75l-2.78-.37a.88.88,0,0,1-.75-1l.38-2.83a.82.82,0,0,1,.34-.58.85.85,0,0,1,.65-.18Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.58,79.31a.68.68,0,0,1,.4.38.7.7,0,0,1,0,.55l-.87,2.18a.69.69,0,0,1-.38.39.7.7,0,0,1-.55,0L361.06,82a.69.69,0,0,1-.39-.38.7.7,0,0,1,0-.55l.87-2.18a.69.69,0,0,1,.38-.39.7.7,0,0,1,.55,0Zm4.6-14.44a8.54,8.54,0,0,1,2.14,1.22,6.74,6.74,0,0,1,1.57,1.73,5.25,5.25,0,0,1,.75,2.1,4.66,4.66,0,0,1-.33,2.35,4.6,4.6,0,0,1-1,1.59,5.63,5.63,0,0,1-1.31,1,10.23,10.23,0,0,1-1.48.65l-1.44.48a7.86,7.86,0,0,0-1.24.55,2.18,2.18,0,0,0-.87.83,1,1,0,0,1-.4.38.62.62,0,0,1-.53,0L363.17,77a.73.73,0,0,1-.4-.39.59.59,0,0,1,0-.55,4.66,4.66,0,0,1,1.08-1.53,6.4,6.4,0,0,1,1.39-1,8.79,8.79,0,0,1,1.5-.62c.52-.16,1-.32,1.44-.48a5.42,5.42,0,0,0,1.16-.54,1.69,1.69,0,0,0,.7-.82,2,2,0,0,0-.18-1.86A3.58,3.58,0,0,0,368,67.84a3.49,3.49,0,0,0-3.93.87,1.27,1.27,0,0,1-.42.3.67.67,0,0,1-.51,0l-2-.8a.61.61,0,0,1-.33-.3.57.57,0,0,1,0-.46A4.25,4.25,0,0,1,362,65.85a6.71,6.71,0,0,1,2-1.09,8,8,0,0,1,2.48-.4A6.86,6.86,0,0,1,369.18,64.87Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M364.58,79.31a.68.68,0,0,1,.4.38.7.7,0,0,1,0,.55l-.87,2.18a.69.69,0,0,1-.38.39.7.7,0,0,1-.55,0L361.06,82a.69.69,0,0,1-.39-.38.7.7,0,0,1,0-.55l.87-2.18a.69.69,0,0,1,.38-.39.7.7,0,0,1,.55,0Zm4.6-14.44a8.54,8.54,0,0,1,2.14,1.22,6.74,6.74,0,0,1,1.57,1.73,5.25,5.25,0,0,1,.75,2.1,4.66,4.66,0,0,1-.33,2.35,4.6,4.6,0,0,1-1,1.59,5.63,5.63,0,0,1-1.31,1,10.23,10.23,0,0,1-1.48.65l-1.44.48a7.86,7.86,0,0,0-1.24.55,2.18,2.18,0,0,0-.87.83,1,1,0,0,1-.4.38.62.62,0,0,1-.53,0L363.17,77a.73.73,0,0,1-.4-.39.59.59,0,0,1,0-.55,4.66,4.66,0,0,1,1.08-1.53,6.4,6.4,0,0,1,1.39-1,8.79,8.79,0,0,1,1.5-.62c.52-.16,1-.32,1.44-.48a5.42,5.42,0,0,0,1.16-.54,1.69,1.69,0,0,0,.7-.82,2,2,0,0,0-.18-1.86A3.58,3.58,0,0,0,368,67.84a3.49,3.49,0,0,0-3.93.87,1.27,1.27,0,0,1-.42.3.67.67,0,0,1-.51,0l-2-.8a.61.61,0,0,1-.33-.3.57.57,0,0,1,0-.46A4.25,4.25,0,0,1,362,65.85a6.71,6.71,0,0,1,2-1.09,8,8,0,0,1,2.48-.4A6.86,6.86,0,0,1,369.18,64.87Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coins--inject-73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--coins--inject-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M480.91,349.31a21.64,21.64,0,0,0-8-7.37c-13-7.53-34.17-7.53-47.21,0a21.6,21.6,0,0,0-8,7.37H416v6.82h0c.24,4.74,3.49,9.44,9.76,13.06,13,7.53,34.17,7.53,47.2,0,6.27-3.62,9.54-8.32,9.78-13.06h0v-6.82Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M480.91,349.31a21.64,21.64,0,0,0-8-7.37c-13-7.53-34.17-7.53-47.21,0a21.6,21.6,0,0,0-8,7.37H416v6.82h0c.24,4.74,3.49,9.44,9.76,13.06,13,7.53,34.17,7.53,47.2,0,6.27-3.62,9.54-8.32,9.78-13.06h0v-6.82Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M449.33,336.29c-8.54,0-17.09,1.88-23.6,5.65a21.56,21.56,0,0,0-8,7.37H416v6.82h0c.24,4.74,3.49,9.44,9.76,13.06,6.51,3.77,15.06,5.65,23.6,5.65Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.1,339.42a35.78,35.78,0,0,0-5.37,2.52,21.56,21.56,0,0,0-8,7.37H416v6.82h0c.24,4.74,3.49,9.44,9.76,13.06a35.78,35.78,0,0,0,5.37,2.52Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.56,339.42a37.29,37.29,0,0,1,5.37,2.52,21.52,21.52,0,0,1,8,7.37h1.81v6.82h0c-.24,4.74-3.51,9.44-9.78,13.06a36.25,36.25,0,0,1-5.37,2.52Z",
    style: {
      fill: "#E4A13E",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.93,335.69c-13-7.53-34.17-7.53-47.21,0s-13,19.73,0,27.25,34.17,7.53,47.2,0S486,343.21,472.93,335.69Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.93,335.69c-13-7.53-34.17-7.53-47.21,0s-13,19.73,0,27.25,34.17,7.53,47.2,0S486,343.21,472.93,335.69Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.7,340.67a37.76,37.76,0,0,0-30.74,0c-4.37,2.24-6.78,5.32-6.78,8.65s2.41,6.39,6.78,8.63a37.55,37.55,0,0,0,30.74,0c4.36-2.24,6.77-5.3,6.77-8.63S469.06,342.91,464.7,340.67Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.7,340.67a37.76,37.76,0,0,0-30.74,0c-4.37,2.24-6.78,5.32-6.78,8.65s2.41,6.39,6.78,8.63a37.55,37.55,0,0,0,30.74,0c4.36-2.24,6.77-5.3,6.77-8.63S469.06,342.91,464.7,340.67Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.21,337c-6.09-3.52-14.22-5.46-22.88-5.46s-16.79,1.94-22.88,5.46c-5.84,3.37-9.05,7.76-9.05,12.37s3.21,9,9.05,12.37c6.09,3.5,14.21,5.44,22.88,5.44s16.79-1.94,22.88-5.44c5.83-3.37,9.05-7.77,9.05-12.37S478,340.32,472.21,337Zm-7.51,21A37.55,37.55,0,0,1,434,358c-4.37-2.24-6.78-5.3-6.78-8.63s2.41-6.41,6.78-8.65a37.76,37.76,0,0,1,30.74,0c4.36,2.24,6.77,5.32,6.77,8.65S469.06,355.71,464.7,358Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.21,337c-6.09-3.52-14.22-5.46-22.88-5.46s-16.79,1.94-22.88,5.46c-5.84,3.37-9.05,7.76-9.05,12.37s3.21,9,9.05,12.37c6.09,3.5,14.21,5.44,22.88,5.44s16.79-1.94,22.88-5.44c5.83-3.37,9.05-7.77,9.05-12.37S478,340.32,472.21,337Zm-7.51,21A37.55,37.55,0,0,1,434,358c-4.37-2.24-6.78-5.3-6.78-8.63s2.41-6.41,6.78-8.65a37.76,37.76,0,0,1,30.74,0c4.36,2.24,6.77,5.32,6.77,8.65S469.06,355.71,464.7,358Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.17,356.93c8.2-4.21,8.2-11,0-15.23s-21.49-4.21-29.69,0-8.2,11,0,15.23S456,361.14,464.17,356.93Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.17,356.93c8.2-4.21,8.2-11,0-15.23s-21.49-4.21-29.69,0-8.2,11,0,15.23S456,361.14,464.17,356.93Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.17,356.93c8.2-4.21,8.2-11,0-15.23s-21.49-4.21-29.69,0-8.2,11,0,15.23S456,361.14,464.17,356.93Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.17,344.55c-8.2-4.21-21.49-4.21-29.69,0-3.39,1.74-5.37,3.93-6,6.19.59,2.27,2.57,4.45,6,6.19,8.2,4.21,21.49,4.21,29.69,0,3.39-1.74,5.38-3.92,6-6.19C469.55,348.48,467.56,346.29,464.17,344.55Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.17,344.55c-8.2-4.21-21.49-4.21-29.69,0-3.39,1.74-5.37,3.93-6,6.19.59,2.27,2.57,4.45,6,6.19,8.2,4.21,21.49,4.21,29.69,0,3.39-1.74,5.38-3.92,6-6.19C469.55,348.48,467.56,346.29,464.17,344.55Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "451.32 341.86 451.32 344.94 450.26 346.05 448.32 348.08 448.32 344.88 451.32 341.86",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "451.32 341.86 451.32 344.94 450.26 346.05 448.32 348.08 448.32 344.88 451.32 341.86",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.32,344.88v1.81a16.64,16.64,0,0,1-3,.85,3.18,3.18,0,0,1-1.28-.05,3.14,3.14,0,0,1-.61-.25c-.74-.44-.86-1.1.55-1.91A4.91,4.91,0,0,1,448.32,344.88Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.32,344.88v1.81a16.64,16.64,0,0,1-3,.85,3.18,3.18,0,0,1-1.28-.05,3.14,3.14,0,0,1-.61-.25c-.74-.44-.86-1.1.55-1.91A4.91,4.91,0,0,1,448.32,344.88Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.26,353.62v2.66l-3.37,1.94-2.49-1.44a12.67,12.67,0,0,1-9.64.43v-2.66l1.53-1.51-1.53.42a9.84,9.84,0,0,1-7.51-.86c-1.51-.87-2.21-1.82-2.21-2.8v-2.59l.27-1.13-.92-.54v-2.66l2.49,1.44c-1.21.95-1.86,1.92-1.84,2.86v0c0,1,.73,1.88,2.21,2.73,3.27,1.89,6.52,1.27,9.49.32,2.76-.91,4.77-2,6.37-1.05,1,.58.69,1.27-.42,1.91a5.56,5.56,0,0,1-4.75.28l-3.18,3.15a10.66,10.66,0,0,0,1.76.52,13.06,13.06,0,0,0,7.88-.95l2.49,1.44Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437,347.18v0c0,1,.73,1.88,2.21,2.73,3.27,1.89,6.52,1.27,9.49.32,2.76-.91,4.77-2,6.37-1.05,1,.58.69,1.27-.42,1.91a5.56,5.56,0,0,1-4.75.28l-3.18,3.15a10.66,10.66,0,0,0,1.76.52,13.06,13.06,0,0,0,7.88-.95l2.49,1.44,3.37-1.94v2.66l-3.37,1.94-2.49-1.44a12.67,12.67,0,0,1-9.64.43v-2.66l1.53-1.51-1.53.42a9.84,9.84,0,0,1-7.51-.86c-1.51-.87-2.21-1.82-2.21-2.8v-2.59l.27-1.13",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.39,342.88v2.66l.92.54h0a5.34,5.34,0,0,1,1.57-1.77Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.7,351.88a3.23,3.23,0,0,1-.25,1.27l-1.69-1a3.29,3.29,0,0,0,1.91-2.56C461.69,350.35,461.7,351.81,461.7,351.88Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M461.7,351.88a3.23,3.23,0,0,1-.25,1.27l-1.69-1a3.29,3.29,0,0,0,1.91-2.56C461.69,350.35,461.7,351.81,461.7,351.88Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M461.69,353.3l-1.92-1.12a3.28,3.28,0,0,0,1.92-2.95,2.09,2.09,0,0,0,0-.26c-.09-.92-.76-1.81-2.16-2.61h0a8.82,8.82,0,0,0-4.47-1.17h-.43l-.4,0-.35,0h-.14l-.27,0a16.83,16.83,0,0,0-2.18.45c-.34.09-.68.19-1,.3l-1.41.46-.54.18a16.81,16.81,0,0,1-3,.85,3,3,0,0,1-1.29-.05,2.63,2.63,0,0,1-.6-.25c-.75-.43-.87-1.09.54-1.91a4.91,4.91,0,0,1,4.33-.45l3-3a12.84,12.84,0,0,0-9,.5l-2.49-1.43-3.4,2,2.5,1.43c-1.22.94-1.87,1.92-1.85,2.86v0c0,1,.73,1.88,2.21,2.73,3.27,1.9,6.52,1.27,9.49.31,2.76-.9,4.77-2,6.36-1,1,.57.7,1.27-.41,1.91a5.45,5.45,0,0,1-4.75.27l-3.19,3.17a12.77,12.77,0,0,0,1.76.51,12,12,0,0,0,3.08.23,14.22,14.22,0,0,0,4.81-1.18l2.49,1.45,3.36-1.95Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M461.69,353.3l-1.92-1.12a3.28,3.28,0,0,0,1.92-2.95,2.09,2.09,0,0,0,0-.26c-.09-.92-.76-1.81-2.16-2.61h0a8.82,8.82,0,0,0-4.47-1.17h-.43l-.4,0-.35,0h-.14l-.27,0a16.83,16.83,0,0,0-2.18.45c-.34.09-.68.19-1,.3l-1.41.46-.54.18a16.81,16.81,0,0,1-3,.85,3,3,0,0,1-1.29-.05,2.63,2.63,0,0,1-.6-.25c-.75-.43-.87-1.09.54-1.91a4.91,4.91,0,0,1,4.33-.45l3-3a12.84,12.84,0,0,0-9,.5l-2.49-1.43-3.4,2,2.5,1.43c-1.22.94-1.87,1.92-1.85,2.86v0c0,1,.73,1.88,2.21,2.73,3.27,1.9,6.52,1.27,9.49.31,2.76-.9,4.77-2,6.36-1,1,.57.7,1.27-.41,1.91a5.45,5.45,0,0,1-4.75.27l-3.19,3.17a12.77,12.77,0,0,0,1.76.51,12,12,0,0,0,3.08.23,14.22,14.22,0,0,0,4.81-1.18l2.49,1.45,3.36-1.95Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "456.4 354.12 456.4 356.78 458.89 358.22 458.89 355.56 456.4 354.12",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "456.4 354.12 456.4 356.78 458.89 358.22 458.89 355.56 456.4 354.12",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.39 342.89 439.79 340.93 442.28 342.36 439.81 341.33 436.39 342.89",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444,345.33a4.91,4.91,0,0,1,4.33-.45l3-3-3,2.71A4.55,4.55,0,0,0,444,345.33Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.75,354.56a12.77,12.77,0,0,0,1.76.51,12,12,0,0,0,3.08.23,10.84,10.84,0,0,1-4.33-.87l2.68-3Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "456.4 354.12 458.89 355.25 462.25 353.62 458.89 355.56 456.4 354.12",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.71,337.4c8.84-5.37,22.62-5.91,22.62-5.91-8.67,0-16.79,1.94-22.88,5.46-5.84,3.37-9.05,7.76-9.05,12.37C417.4,349.32,417.72,342.86,426.71,337.4Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.75,368.53c9.38.42,19-1.45,26.18-5.59,7.46-4.3,10.65-10.14,9.57-15.76,0,0,1.4,9.15-10.13,15.42S446.75,368.53,446.75,368.53Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.71,339.86a21.46,21.46,0,0,0-8-7.38c-13-7.52-34.17-7.52-47.21,0a21.54,21.54,0,0,0-8,7.38h-1.8v6.82h0c.24,4.74,3.48,9.44,9.75,13.06,13,7.52,34.17,7.52,47.21,0,6.27-3.62,9.54-8.32,9.78-13.06h0v-6.82Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M478.71,339.86a21.46,21.46,0,0,0-8-7.38c-13-7.52-34.17-7.52-47.21,0a21.54,21.54,0,0,0-8,7.38h-1.8v6.82h0c.24,4.74,3.48,9.44,9.75,13.06,13,7.52,34.17,7.52,47.21,0,6.27-3.62,9.54-8.32,9.78-13.06h0v-6.82Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M447.14,326.84c-8.55,0-17.09,1.88-23.61,5.64a21.54,21.54,0,0,0-8,7.38h-1.8v6.82h0c.24,4.74,3.48,9.44,9.75,13.06,6.52,3.76,15.06,5.64,23.61,5.64Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.91,330a36.34,36.34,0,0,0-5.38,2.51,21.54,21.54,0,0,0-8,7.38h-1.8v6.82h0c.24,4.74,3.48,9.44,9.75,13.06a36.34,36.34,0,0,0,5.38,2.51Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.37,330a36.22,36.22,0,0,1,5.37,2.51,21.46,21.46,0,0,1,8,7.38h1.81v6.82h0c-.24,4.74-3.51,9.44-9.78,13.06a36.22,36.22,0,0,1-5.37,2.51Z",
    style: {
      fill: "#E4A13E",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.74,326.23c-13-7.52-34.17-7.52-47.21,0s-13,19.73,0,27.26,34.17,7.52,47.21,0S483.78,333.76,470.74,326.23Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.74,326.23c-13-7.52-34.17-7.52-47.21,0s-13,19.73,0,27.26,34.17,7.52,47.21,0S483.78,333.76,470.74,326.23Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.51,331.22a37.65,37.65,0,0,0-30.74,0c-4.37,2.24-6.78,5.31-6.78,8.64s2.41,6.4,6.78,8.64a37.65,37.65,0,0,0,30.74,0c4.36-2.24,6.77-5.31,6.77-8.64S466.87,333.46,462.51,331.22Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.51,331.22a37.65,37.65,0,0,0-30.74,0c-4.37,2.24-6.78,5.31-6.78,8.64s2.41,6.4,6.78,8.64a37.65,37.65,0,0,0,30.74,0c4.36-2.24,6.77-5.31,6.77-8.64S466.87,333.46,462.51,331.22Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470,327.49C463.93,324,455.8,322,447.13,322s-16.78,1.94-22.87,5.45c-5.84,3.37-9.05,7.76-9.05,12.37s3.21,9,9.05,12.37c6.09,3.51,14.21,5.45,22.87,5.45s16.8-1.94,22.88-5.45c5.84-3.37,9.05-7.76,9.05-12.37S475.85,330.86,470,327.49Zm-7.5,21a37.65,37.65,0,0,1-30.74,0c-4.37-2.24-6.78-5.31-6.78-8.64s2.41-6.4,6.78-8.64a37.65,37.65,0,0,1,30.74,0c4.36,2.24,6.77,5.31,6.77,8.64S466.87,346.26,462.51,348.5Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470,327.49C463.93,324,455.8,322,447.13,322s-16.78,1.94-22.87,5.45c-5.84,3.37-9.05,7.76-9.05,12.37s3.21,9,9.05,12.37c6.09,3.51,14.21,5.45,22.87,5.45s16.8-1.94,22.88-5.45c5.84-3.37,9.05-7.76,9.05-12.37S475.85,330.86,470,327.49Zm-7.5,21a37.65,37.65,0,0,1-30.74,0c-4.37-2.24-6.78-5.31-6.78-8.64s2.41-6.4,6.78-8.64a37.65,37.65,0,0,1,30.74,0c4.36,2.24,6.77,5.31,6.77,8.64S466.87,346.26,462.51,348.5Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462,347.48c8.2-4.21,8.2-11,0-15.24s-21.49-4.21-29.69,0-8.2,11,0,15.24S453.78,351.68,462,347.48Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462,347.48c8.2-4.21,8.2-11,0-15.24s-21.49-4.21-29.69,0-8.2,11,0,15.24S453.78,351.68,462,347.48Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462,347.48c8.2-4.21,8.2-11,0-15.24s-21.49-4.21-29.69,0-8.2,11,0,15.24S453.78,351.68,462,347.48Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462,335.09c-8.2-4.2-21.49-4.2-29.69,0-3.39,1.74-5.37,3.93-6,6.19.59,2.27,2.57,4.46,6,6.2,8.2,4.2,21.49,4.2,29.69,0,3.39-1.74,5.38-3.93,6-6.2C467.36,339,465.37,336.83,462,335.09Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462,335.09c-8.2-4.2-21.49-4.2-29.69,0-3.39,1.74-5.37,3.93-6,6.19.59,2.27,2.57,4.46,6,6.2,8.2,4.2,21.49,4.2,29.69,0,3.39-1.74,5.38-3.93,6-6.2C467.36,339,465.37,336.83,462,335.09Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "449.12 332.4 449.12 335.48 448.07 336.59 446.13 338.63 446.13 335.42 449.12 332.4",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "449.12 332.4 449.12 335.48 448.07 336.59 446.13 338.63 446.13 335.42 449.12 332.4",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.13,335.42v1.82a17.52,17.52,0,0,1-3,.85,3.17,3.17,0,0,1-1.28,0,3.92,3.92,0,0,1-.61-.25c-.74-.45-.86-1.1.55-1.92A5,5,0,0,1,446.13,335.42Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.13,335.42v1.82a17.52,17.52,0,0,1-3,.85,3.17,3.17,0,0,1-1.28,0,3.92,3.92,0,0,1-.61-.25c-.74-.45-.86-1.1.55-1.92A5,5,0,0,1,446.13,335.42Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.06,344.16v2.66l-3.36,1.94-2.49-1.44a12.69,12.69,0,0,1-9.65.44V345.1l1.53-1.52-1.53.42a9.8,9.8,0,0,1-7.51-.86c-1.51-.87-2.21-1.82-2.2-2.8v-2.59l.27-1.13-.92-.53v-2.66l2.49,1.44c-1.21.94-1.86,1.91-1.84,2.85v0c0,1,.73,1.89,2.2,2.74,3.28,1.89,6.52,1.26,9.5.31,2.76-.9,4.77-2,6.37-1,1,.57.68,1.26-.43,1.91a5.49,5.49,0,0,1-4.74.27l-3.19,3.16a12,12,0,0,0,1.76.51,13.16,13.16,0,0,0,7.89-.94l2.49,1.44Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.85,337.72v0c0,1,.73,1.89,2.2,2.74,3.28,1.89,6.52,1.26,9.5.31,2.76-.9,4.77-2,6.37-1,1,.57.68,1.26-.43,1.91a5.49,5.49,0,0,1-4.74.27l-3.19,3.16a12,12,0,0,0,1.76.51,13.16,13.16,0,0,0,7.89-.94l2.49,1.44,3.36-1.95v2.66l-3.36,1.94-2.49-1.44a12.69,12.69,0,0,1-9.65.44V345.1l1.53-1.52-1.53.42a9.8,9.8,0,0,1-7.51-.86c-1.51-.87-2.21-1.82-2.2-2.8v-2.59l.27-1.13",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.2,333.43v2.66l.92.53h0a5.48,5.48,0,0,1,1.58-1.76Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.51,342.43a3.14,3.14,0,0,1-.25,1.26l-1.69-1a3.29,3.29,0,0,0,1.91-2.55C459.49,340.9,459.51,342.35,459.51,342.43Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M459.51,342.43a3.14,3.14,0,0,1-.25,1.26l-1.69-1a3.29,3.29,0,0,0,1.91-2.55C459.49,340.9,459.51,342.35,459.51,342.43Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M459.5,343.84l-1.93-1.12a3.28,3.28,0,0,0,1.93-3,2.11,2.11,0,0,0,0-.26c-.08-.92-.75-1.81-2.15-2.61h0a8.83,8.83,0,0,0-4.48-1.17h-.42l-.4,0c-.12,0-.24,0-.35,0l-.14,0a2,2,0,0,0-.27,0,18.69,18.69,0,0,0-2.18.45l-1,.3-1.41.46-.53.18a15.84,15.84,0,0,1-3,.85,3,3,0,0,1-1.28-.05,2.24,2.24,0,0,1-.6-.25c-.75-.43-.87-1.09.54-1.91a5,5,0,0,1,4.33-.45l3-3a12.87,12.87,0,0,0-9,.5l-2.49-1.43-3.4,2,2.5,1.43c-1.22.95-1.87,1.92-1.86,2.87v0c0,1,.74,1.89,2.21,2.74,3.28,1.89,6.53,1.26,9.5.31,2.76-.91,4.77-2,6.36-1.05,1,.58.69,1.27-.42,1.91a5.46,5.46,0,0,1-4.74.28l-3.19,3.16a12.45,12.45,0,0,0,1.76.52,11.53,11.53,0,0,0,3.07.22,14.34,14.34,0,0,0,4.81-1.17l2.5,1.44,3.36-1.94Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M459.5,343.84l-1.93-1.12a3.28,3.28,0,0,0,1.93-3,2.11,2.11,0,0,0,0-.26c-.08-.92-.75-1.81-2.15-2.61h0a8.83,8.83,0,0,0-4.48-1.17h-.42l-.4,0c-.12,0-.24,0-.35,0l-.14,0a2,2,0,0,0-.27,0,18.69,18.69,0,0,0-2.18.45l-1,.3-1.41.46-.53.18a15.84,15.84,0,0,1-3,.85,3,3,0,0,1-1.28-.05,2.24,2.24,0,0,1-.6-.25c-.75-.43-.87-1.09.54-1.91a5,5,0,0,1,4.33-.45l3-3a12.87,12.87,0,0,0-9,.5l-2.49-1.43-3.4,2,2.5,1.43c-1.22.95-1.87,1.92-1.86,2.87v0c0,1,.74,1.89,2.21,2.74,3.28,1.89,6.53,1.26,9.5.31,2.76-.91,4.77-2,6.36-1.05,1,.58.69,1.27-.42,1.91a5.46,5.46,0,0,1-4.74.28l-3.19,3.16a12.45,12.45,0,0,0,1.76.52,11.53,11.53,0,0,0,3.07.22,14.34,14.34,0,0,0,4.81-1.17l2.5,1.44,3.36-1.94Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "454.21 344.67 454.21 347.32 456.7 348.76 456.7 346.11 454.21 344.67",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "454.21 344.67 454.21 347.32 456.7 348.76 456.7 346.11 454.21 344.67",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "434.2 333.43 437.6 331.47 440.09 332.9 437.62 331.87 434.2 333.43",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.8,335.87a5,5,0,0,1,4.33-.45l3-3-3,2.71A4.55,4.55,0,0,0,441.8,335.87Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.56,345.1a12.45,12.45,0,0,0,1.76.52,11.53,11.53,0,0,0,3.07.22,11,11,0,0,1-4.33-.86l2.69-3Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "454.21 344.67 456.7 345.79 460.06 344.17 456.7 346.11 454.21 344.67",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.52,327.94c8.83-5.37,22.61-5.9,22.61-5.9-8.66,0-16.78,1.94-22.87,5.45-5.84,3.37-9.05,7.76-9.05,12.37C415.21,339.86,415.53,333.4,424.52,327.94Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.56,359.07c9.38.42,19-1.44,26.18-5.58,7.46-4.31,10.65-10.15,9.57-15.77,0,0,1.4,9.16-10.13,15.42S444.56,359.07,444.56,359.07Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.49,330.3a21.6,21.6,0,0,0-8-7.37c-13-7.53-34.17-7.53-47.21,0a21.52,21.52,0,0,0-8,7.37h-1.81v6.82h0c.24,4.74,3.48,9.44,9.75,13.06,13,7.53,34.17,7.53,47.21,0,6.26-3.62,9.53-8.32,9.77-13.06h0V330.3Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M483.49,330.3a21.6,21.6,0,0,0-8-7.37c-13-7.53-34.17-7.53-47.21,0a21.52,21.52,0,0,0-8,7.37h-1.81v6.82h0c.24,4.74,3.48,9.44,9.75,13.06,13,7.53,34.17,7.53,47.21,0,6.26-3.62,9.53-8.32,9.77-13.06h0V330.3Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M451.91,317.28c-8.54,0-17.08,1.88-23.6,5.65a21.52,21.52,0,0,0-8,7.37h-1.81v6.82h0c.24,4.74,3.48,9.44,9.75,13.06,6.52,3.77,15.06,5.65,23.6,5.65Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.68,320.41a36.25,36.25,0,0,0-5.37,2.52,21.52,21.52,0,0,0-8,7.37h-1.81v6.82h0c.24,4.74,3.48,9.44,9.75,13.06a36.25,36.25,0,0,0,5.37,2.52Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.14,320.41a36.37,36.37,0,0,1,5.38,2.52,21.6,21.6,0,0,1,8,7.37h1.8v6.82h0c-.24,4.74-3.51,9.44-9.77,13.06a36.37,36.37,0,0,1-5.38,2.52Z",
    style: {
      fill: "#E4A13E",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.52,316.68c-13-7.53-34.17-7.53-47.21,0s-13,19.73,0,27.25,34.17,7.53,47.21,0S488.55,324.2,475.52,316.68Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.52,316.68c-13-7.53-34.17-7.53-47.21,0s-13,19.73,0,27.25,34.17,7.53,47.21,0S488.55,324.2,475.52,316.68Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.28,321.66a37.65,37.65,0,0,0-30.74,0c-4.37,2.24-6.77,5.32-6.77,8.65s2.4,6.39,6.77,8.63a37.55,37.55,0,0,0,30.74,0c4.37-2.24,6.78-5.3,6.78-8.63S471.65,323.9,467.28,321.66Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.28,321.66a37.65,37.65,0,0,0-30.74,0c-4.37,2.24-6.77,5.32-6.77,8.65s2.4,6.39,6.77,8.63a37.55,37.55,0,0,0,30.74,0c4.37-2.24,6.78-5.3,6.78-8.63S471.65,323.9,467.28,321.66Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.79,317.94c-6.09-3.52-14.21-5.46-22.88-5.46s-16.78,1.94-22.87,5.46c-5.84,3.37-9.05,7.75-9.05,12.37s3.21,9,9.05,12.37c6.09,3.5,14.21,5.44,22.87,5.44s16.79-1.94,22.88-5.44c5.83-3.37,9-7.77,9-12.37S480.62,321.31,474.79,317.94Zm-7.51,21a37.55,37.55,0,0,1-30.74,0c-4.37-2.24-6.77-5.3-6.77-8.63s2.4-6.41,6.77-8.65a37.65,37.65,0,0,1,30.74,0c4.37,2.24,6.78,5.32,6.78,8.65S471.65,336.7,467.28,338.94Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.79,317.94c-6.09-3.52-14.21-5.46-22.88-5.46s-16.78,1.94-22.87,5.46c-5.84,3.37-9.05,7.75-9.05,12.37s3.21,9,9.05,12.37c6.09,3.5,14.21,5.44,22.87,5.44s16.79-1.94,22.88-5.44c5.83-3.37,9-7.77,9-12.37S480.62,321.31,474.79,317.94Zm-7.51,21a37.55,37.55,0,0,1-30.74,0c-4.37-2.24-6.77-5.3-6.77-8.63s2.4-6.41,6.77-8.65a37.65,37.65,0,0,1,30.74,0c4.37,2.24,6.78,5.32,6.78,8.65S471.65,336.7,467.28,338.94Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.76,337.92c8.2-4.21,8.2-11,0-15.24s-21.49-4.2-29.69,0-8.2,11,0,15.24S458.56,342.13,466.76,337.92Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.76,337.92c8.2-4.21,8.2-11,0-15.24s-21.49-4.2-29.69,0-8.2,11,0,15.24S458.56,342.13,466.76,337.92Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.76,337.92c8.2-4.21,8.2-11,0-15.24s-21.49-4.2-29.69,0-8.2,11,0,15.24S458.56,342.13,466.76,337.92Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.76,325.54c-8.2-4.21-21.49-4.21-29.69,0-3.39,1.74-5.38,3.93-6,6.19.58,2.26,2.57,4.45,6,6.19,8.2,4.21,21.49,4.21,29.69,0,3.39-1.74,5.37-3.93,6-6.19C472.13,329.47,470.15,327.28,466.76,325.54Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.76,325.54c-8.2-4.21-21.49-4.21-29.69,0-3.39,1.74-5.38,3.93-6,6.19.58,2.26,2.57,4.45,6,6.19,8.2,4.21,21.49,4.21,29.69,0,3.39-1.74,5.37-3.93,6-6.19C472.13,329.47,470.15,327.28,466.76,325.54Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "453.9 322.85 453.9 325.93 452.85 327.04 450.91 329.07 450.91 325.87 453.9 322.85",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "453.9 322.85 453.9 325.93 452.85 327.04 450.91 329.07 450.91 325.87 453.9 322.85",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.91,325.87v1.81a16.87,16.87,0,0,1-3,.85,3.17,3.17,0,0,1-1.28,0,2.7,2.7,0,0,1-.61-.25c-.74-.44-.86-1.1.55-1.91A4.91,4.91,0,0,1,450.91,325.87Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.91,325.87v1.81a16.87,16.87,0,0,1-3,.85,3.17,3.17,0,0,1-1.28,0,2.7,2.7,0,0,1-.61-.25c-.74-.44-.86-1.1.55-1.91A4.91,4.91,0,0,1,450.91,325.87Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.84,334.61v2.66l-3.37,1.94L459,337.77a12.71,12.71,0,0,1-9.64.43v-2.66l1.53-1.51-1.53.42a9.89,9.89,0,0,1-7.51-.86c-1.51-.87-2.21-1.82-2.21-2.81V328.2l.28-1.13-.92-.54v-2.66l2.49,1.44a3.85,3.85,0,0,0-1.85,2.86v0c0,.95.74,1.88,2.21,2.73,3.28,1.89,6.52,1.27,9.49.31,2.77-.9,4.78-2,6.37-1,1,.57.69,1.27-.42,1.91a5.56,5.56,0,0,1-4.75.28l-3.18,3.15a11,11,0,0,0,1.76.52,13.05,13.05,0,0,0,7.88-.95l2.49,1.44Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.62,328.17v0c0,.95.74,1.88,2.21,2.73,3.28,1.89,6.52,1.27,9.49.31,2.77-.9,4.78-2,6.37-1,1,.57.69,1.27-.42,1.91a5.56,5.56,0,0,1-4.75.28l-3.18,3.15a11,11,0,0,0,1.76.52,13.05,13.05,0,0,0,7.88-.95l2.49,1.44,3.37-1.94v2.66l-3.37,1.94L459,337.77a12.71,12.71,0,0,1-9.64.43v-2.66l1.53-1.51-1.53.42a9.89,9.89,0,0,1-7.51-.86c-1.51-.87-2.21-1.82-2.21-2.81V328.2l.28-1.13",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439,323.87v2.66l.92.54h0a5.58,5.58,0,0,1,1.58-1.76Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.28,332.87a3.06,3.06,0,0,1-.25,1.27l-1.68-1a3.31,3.31,0,0,0,1.91-2.56C464.27,331.34,464.28,332.8,464.28,332.87Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M464.28,332.87a3.06,3.06,0,0,1-.25,1.27l-1.68-1a3.31,3.31,0,0,0,1.91-2.56C464.27,331.34,464.28,332.8,464.28,332.87Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M464.28,334.29l-1.93-1.12a3.28,3.28,0,0,0,1.93-2.95,2,2,0,0,0,0-.26c-.08-.92-.76-1.81-2.15-2.61h0a8.86,8.86,0,0,0-4.48-1.17h-.43l-.4,0-.35,0h-.14l-.26,0a16.49,16.49,0,0,0-2.18.45c-.34.09-.69.19-1,.3l-1.41.46-.53.18a16.64,16.64,0,0,1-3,.85,3,3,0,0,1-1.28,0,2.9,2.9,0,0,1-.61-.25c-.75-.43-.86-1.09.55-1.91a4.91,4.91,0,0,1,4.33-.45l3-3a12.76,12.76,0,0,0-9,.5l-2.5-1.44-3.39,2,2.49,1.43c-1.22.94-1.87,1.92-1.85,2.86v0c0,1,.73,1.88,2.21,2.73,3.28,1.9,6.52,1.27,9.49.31,2.76-.9,4.77-2,6.37-1,1,.57.69,1.27-.42,1.91a5.48,5.48,0,0,1-4.75.27l-3.18,3.17a11.87,11.87,0,0,0,4.83.74,14.22,14.22,0,0,0,4.81-1.18l2.5,1.44,3.36-1.94Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M464.28,334.29l-1.93-1.12a3.28,3.28,0,0,0,1.93-2.95,2,2,0,0,0,0-.26c-.08-.92-.76-1.81-2.15-2.61h0a8.86,8.86,0,0,0-4.48-1.17h-.43l-.4,0-.35,0h-.14l-.26,0a16.49,16.49,0,0,0-2.18.45c-.34.09-.69.19-1,.3l-1.41.46-.53.18a16.64,16.64,0,0,1-3,.85,3,3,0,0,1-1.28,0,2.9,2.9,0,0,1-.61-.25c-.75-.43-.86-1.09.55-1.91a4.91,4.91,0,0,1,4.33-.45l3-3a12.76,12.76,0,0,0-9,.5l-2.5-1.44-3.39,2,2.49,1.43c-1.22.94-1.87,1.92-1.85,2.86v0c0,1,.73,1.88,2.21,2.73,3.28,1.9,6.52,1.27,9.49.31,2.76-.9,4.77-2,6.37-1,1,.57.69,1.27-.42,1.91a5.48,5.48,0,0,1-4.75.27l-3.18,3.17a11.87,11.87,0,0,0,4.83.74,14.22,14.22,0,0,0,4.81-1.18l2.5,1.44,3.36-1.94Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "458.98 335.11 458.98 337.77 461.48 339.21 461.48 336.55 458.98 335.11",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "458.98 335.11 458.98 337.77 461.48 339.21 461.48 336.55 458.98 335.11",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.98 323.88 442.37 321.92 444.87 323.35 442.39 322.31 438.98 323.88",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.58,326.32a4.91,4.91,0,0,1,4.33-.45l3-3-3,2.71A4.55,4.55,0,0,0,446.58,326.32Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.34,335.55a11.87,11.87,0,0,0,4.83.74,10.84,10.84,0,0,1-4.33-.87l2.68-3Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "458.98 335.11 461.48 336.24 464.84 334.61 461.48 336.55 458.98 335.11",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.29,318.38c8.84-5.36,22.62-5.9,22.62-5.9-8.66,0-16.78,1.94-22.87,5.46-5.84,3.37-9.05,7.75-9.05,12.37C420,330.31,420.31,323.85,429.29,318.38Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.34,349.52c9.38.42,19-1.45,26.18-5.59,7.46-4.31,10.65-10.14,9.57-15.76,0,0,1.39,9.15-10.14,15.42S449.34,349.52,449.34,349.52Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.44,322a21.46,21.46,0,0,0-8-7.38c-13-7.52-34.17-7.52-47.21,0a21.54,21.54,0,0,0-8,7.38h-1.8v6.82h0c.24,4.74,3.49,9.44,9.75,13.06,13,7.52,34.17,7.52,47.21,0,6.27-3.62,9.54-8.32,9.78-13.06h0V322Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M476.44,322a21.46,21.46,0,0,0-8-7.38c-13-7.52-34.17-7.52-47.21,0a21.54,21.54,0,0,0-8,7.38h-1.8v6.82h0c.24,4.74,3.49,9.44,9.75,13.06,13,7.52,34.17,7.52,47.21,0,6.27-3.62,9.54-8.32,9.78-13.06h0V322Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M444.87,308.93c-8.54,0-17.09,1.88-23.61,5.64a21.54,21.54,0,0,0-8,7.38h-1.8v6.82h0c.24,4.74,3.49,9.44,9.75,13.06,6.52,3.76,15.07,5.64,23.61,5.64Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.64,312.06a36.34,36.34,0,0,0-5.38,2.51,21.54,21.54,0,0,0-8,7.38h-1.8v6.82h0c.24,4.74,3.49,9.44,9.75,13.06a36.34,36.34,0,0,0,5.38,2.51Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.1,312.06a36.22,36.22,0,0,1,5.37,2.51,21.46,21.46,0,0,1,8,7.38h1.81v6.82h0c-.24,4.74-3.51,9.44-9.78,13.06a36.22,36.22,0,0,1-5.37,2.51Z",
    style: {
      fill: "#E4A13E",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.47,308.32c-13-7.52-34.17-7.52-47.21,0s-13,19.73,0,27.26,34.17,7.52,47.21,0S481.51,315.85,468.47,308.32Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.47,308.32c-13-7.52-34.17-7.52-47.21,0s-13,19.73,0,27.26,34.17,7.52,47.21,0S481.51,315.85,468.47,308.32Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.24,313.31a37.65,37.65,0,0,0-30.74,0c-4.37,2.24-6.78,5.31-6.78,8.64s2.41,6.4,6.78,8.64a37.65,37.65,0,0,0,30.74,0c4.36-2.24,6.77-5.31,6.77-8.64S464.6,315.55,460.24,313.31Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.24,313.31a37.65,37.65,0,0,0-30.74,0c-4.37,2.24-6.78,5.31-6.78,8.64s2.41,6.4,6.78,8.64a37.65,37.65,0,0,0,30.74,0c4.36-2.24,6.77-5.31,6.77-8.64S464.6,315.55,460.24,313.31Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.74,309.58c-6.08-3.51-14.21-5.45-22.87-5.45s-16.79,1.94-22.88,5.45c-5.84,3.37-9.05,7.76-9.05,12.37s3.21,9,9.05,12.37c6.09,3.51,14.21,5.45,22.88,5.45s16.79-1.94,22.87-5.45c5.84-3.37,9.05-7.76,9.05-12.37S473.58,313,467.74,309.58Zm-7.5,21a37.65,37.65,0,0,1-30.74,0c-4.37-2.24-6.78-5.31-6.78-8.64s2.41-6.4,6.78-8.64a37.65,37.65,0,0,1,30.74,0c4.36,2.24,6.77,5.31,6.77,8.64S464.6,328.35,460.24,330.59Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.74,309.58c-6.08-3.51-14.21-5.45-22.87-5.45s-16.79,1.94-22.88,5.45c-5.84,3.37-9.05,7.76-9.05,12.37s3.21,9,9.05,12.37c6.09,3.51,14.21,5.45,22.88,5.45s16.79-1.94,22.87-5.45c5.84-3.37,9.05-7.76,9.05-12.37S473.58,313,467.74,309.58Zm-7.5,21a37.65,37.65,0,0,1-30.74,0c-4.37-2.24-6.78-5.31-6.78-8.64s2.41-6.4,6.78-8.64a37.65,37.65,0,0,1,30.74,0c4.36,2.24,6.77,5.31,6.77,8.64S464.6,328.35,460.24,330.59Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.71,329.57c8.2-4.21,8.2-11,0-15.24s-21.49-4.21-29.69,0-8.2,11,0,15.24S451.51,333.78,459.71,329.57Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.71,329.57c8.2-4.21,8.2-11,0-15.24s-21.49-4.21-29.69,0-8.2,11,0,15.24S451.51,333.78,459.71,329.57Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.71,329.57c8.2-4.21,8.2-11,0-15.24s-21.49-4.21-29.69,0-8.2,11,0,15.24S451.51,333.78,459.71,329.57Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.71,317.19c-8.2-4.21-21.49-4.21-29.69,0-3.39,1.74-5.37,3.92-6,6.19.59,2.26,2.57,4.45,6,6.19,8.2,4.21,21.49,4.21,29.69,0,3.39-1.74,5.38-3.93,6-6.19C465.09,321.11,463.1,318.93,459.71,317.19Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.71,317.19c-8.2-4.21-21.49-4.21-29.69,0-3.39,1.74-5.37,3.92-6,6.19.59,2.26,2.57,4.45,6,6.19,8.2,4.21,21.49,4.21,29.69,0,3.39-1.74,5.38-3.93,6-6.19C465.09,321.11,463.1,318.93,459.71,317.19Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "446.86 314.5 446.86 317.57 445.8 318.68 443.86 320.72 443.86 317.51 446.86 314.5",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "446.86 314.5 446.86 317.57 445.8 318.68 443.86 320.72 443.86 317.51 446.86 314.5",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.86,317.51v1.82a17.52,17.52,0,0,1-3,.85,3.18,3.18,0,0,1-1.28-.05,3.14,3.14,0,0,1-.61-.25c-.74-.44-.86-1.1.55-1.91A4.92,4.92,0,0,1,443.86,317.51Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.86,317.51v1.82a17.52,17.52,0,0,1-3,.85,3.18,3.18,0,0,1-1.28-.05,3.14,3.14,0,0,1-.61-.25c-.74-.44-.86-1.1.55-1.91A4.92,4.92,0,0,1,443.86,317.51Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.8,326.26v2.65l-3.37,1.94-2.49-1.44a12.67,12.67,0,0,1-9.64.44v-2.66l1.53-1.52-1.53.42a9.82,9.82,0,0,1-7.52-.86c-1.51-.86-2.21-1.82-2.2-2.8v-2.59l.27-1.13-.92-.53v-2.66l2.49,1.44c-1.21.94-1.86,1.91-1.84,2.85v0c0,1,.73,1.89,2.2,2.74,3.28,1.89,6.52,1.27,9.5.31,2.76-.9,4.77-2,6.37-1,1,.57.69,1.27-.43,1.91a5.49,5.49,0,0,1-4.74.27l-3.18,3.16a11.61,11.61,0,0,0,1.75.52,13.16,13.16,0,0,0,7.89-.95l2.49,1.44Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.58,319.81v0c0,1,.73,1.89,2.2,2.74,3.28,1.89,6.52,1.27,9.5.31,2.76-.9,4.77-2,6.37-1,1,.57.69,1.27-.43,1.91a5.49,5.49,0,0,1-4.74.27l-3.18,3.16a11.61,11.61,0,0,0,1.75.52,13.16,13.16,0,0,0,7.89-.95l2.49,1.44,3.37-1.94v2.65l-3.37,1.94-2.49-1.44a12.67,12.67,0,0,1-9.64.44v-2.66l1.53-1.52-1.53.42a9.82,9.82,0,0,1-7.52-.86c-1.51-.86-2.21-1.82-2.2-2.8v-2.59l.27-1.13",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.93,315.52v2.66l.92.53h0a5.48,5.48,0,0,1,1.58-1.76Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.24,324.52a3.14,3.14,0,0,1-.25,1.26l-1.69-1a3.32,3.32,0,0,0,1.91-2.56C457.23,323,457.24,324.45,457.24,324.52Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M457.24,324.52a3.14,3.14,0,0,1-.25,1.26l-1.69-1a3.32,3.32,0,0,0,1.91-2.56C457.23,323,457.24,324.45,457.24,324.52Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M457.23,325.93l-1.92-1.12a3.28,3.28,0,0,0,1.92-2.95c0-.09,0-.17,0-.26-.09-.92-.76-1.81-2.16-2.61h0a8.82,8.82,0,0,0-4.48-1.16h-.42l-.4,0-.35,0-.14,0-.27,0a18.69,18.69,0,0,0-2.18.45l-1,.3-1.41.46-.53.19a16.64,16.64,0,0,1-3,.85,3.36,3.36,0,0,1-1.28-.05,3.16,3.16,0,0,1-.6-.25c-.75-.44-.87-1.1.54-1.91a4.91,4.91,0,0,1,4.33-.45l3-3a12.79,12.79,0,0,0-9,.5l-2.49-1.44-3.4,2,2.5,1.44a3.87,3.87,0,0,0-1.86,2.86v0c0,1,.74,1.89,2.21,2.74,3.28,1.89,6.53,1.27,9.5.31,2.76-.9,4.77-2,6.36-1.05,1,.58.69,1.27-.41,1.91a5.49,5.49,0,0,1-4.75.28l-3.19,3.16a12.45,12.45,0,0,0,1.76.52,11.53,11.53,0,0,0,3.07.22,14.22,14.22,0,0,0,4.82-1.17l2.49,1.44,3.36-1.94Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M457.23,325.93l-1.92-1.12a3.28,3.28,0,0,0,1.92-2.95c0-.09,0-.17,0-.26-.09-.92-.76-1.81-2.16-2.61h0a8.82,8.82,0,0,0-4.48-1.16h-.42l-.4,0-.35,0-.14,0-.27,0a18.69,18.69,0,0,0-2.18.45l-1,.3-1.41.46-.53.19a16.64,16.64,0,0,1-3,.85,3.36,3.36,0,0,1-1.28-.05,3.16,3.16,0,0,1-.6-.25c-.75-.44-.87-1.1.54-1.91a4.91,4.91,0,0,1,4.33-.45l3-3a12.79,12.79,0,0,0-9,.5l-2.49-1.44-3.4,2,2.5,1.44a3.87,3.87,0,0,0-1.86,2.86v0c0,1,.74,1.89,2.21,2.74,3.28,1.89,6.53,1.27,9.5.31,2.76-.9,4.77-2,6.36-1.05,1,.58.69,1.27-.41,1.91a5.49,5.49,0,0,1-4.75.28l-3.19,3.16a12.45,12.45,0,0,0,1.76.52,11.53,11.53,0,0,0,3.07.22,14.22,14.22,0,0,0,4.82-1.17l2.49,1.44,3.36-1.94Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "451.94 326.76 451.94 329.42 454.43 330.86 454.43 328.2 451.94 326.76",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "451.94 326.76 451.94 329.42 454.43 330.86 454.43 328.2 451.94 326.76",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "431.93 315.52 435.33 313.56 437.82 315 435.35 313.96 431.93 315.52",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.53,318a4.91,4.91,0,0,1,4.33-.45l3-3-3,2.7A4.53,4.53,0,0,0,439.53,318Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.29,327.19a12.45,12.45,0,0,0,1.76.52,11.53,11.53,0,0,0,3.07.22,10.7,10.7,0,0,1-4.32-.86l2.68-3Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "451.94 326.76 454.43 327.88 457.79 326.26 454.43 328.2 451.94 326.76",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.25,310c8.84-5.37,22.62-5.9,22.62-5.9-8.67,0-16.79,1.94-22.88,5.45-5.84,3.37-9.05,7.76-9.05,12.37C412.94,322,413.26,315.49,422.25,310Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.29,341.17c9.38.41,19-1.45,26.18-5.59,7.46-4.31,10.65-10.15,9.57-15.76,0,0,1.4,9.15-10.13,15.41S442.29,341.17,442.29,341.17Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.34,312.38a21.54,21.54,0,0,0-8-7.38c-13-7.52-34.17-7.52-47.21,0a21.46,21.46,0,0,0-8,7.38h-1.81v6.82h0c.24,4.74,3.48,9.44,9.75,13.06,13,7.52,34.17,7.52,47.21,0,6.27-3.62,9.53-8.32,9.77-13.06h0v-6.82Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M482.34,312.38a21.54,21.54,0,0,0-8-7.38c-13-7.52-34.17-7.52-47.21,0a21.46,21.46,0,0,0-8,7.38h-1.81v6.82h0c.24,4.74,3.48,9.44,9.75,13.06,13,7.52,34.17,7.52,47.21,0,6.27-3.62,9.53-8.32,9.77-13.06h0v-6.82Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M450.77,299.36c-8.55,0-17.09,1.88-23.61,5.64a21.46,21.46,0,0,0-8,7.38h-1.81v6.82h0c.24,4.74,3.48,9.44,9.75,13.06,6.52,3.76,15.06,5.64,23.61,5.64Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.53,302.49a36.22,36.22,0,0,0-5.37,2.51,21.46,21.46,0,0,0-8,7.38h-1.81v6.82h0c.24,4.74,3.48,9.44,9.75,13.06a36.22,36.22,0,0,0,5.37,2.51Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469,302.49a36.7,36.7,0,0,1,5.37,2.51,21.54,21.54,0,0,1,8,7.38h1.8v6.82h0c-.24,4.74-3.5,9.44-9.77,13.06a36.7,36.7,0,0,1-5.37,2.51Z",
    style: {
      fill: "#E4A13E",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.37,298.75c-13-7.52-34.17-7.52-47.21,0s-13,19.73,0,27.26,34.17,7.52,47.21,0S487.4,306.28,474.37,298.75Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.37,298.75c-13-7.52-34.17-7.52-47.21,0s-13,19.73,0,27.26,34.17,7.52,47.21,0S487.4,306.28,474.37,298.75Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.14,303.74a37.65,37.65,0,0,0-30.74,0c-4.37,2.24-6.78,5.31-6.78,8.64s2.41,6.4,6.78,8.64a37.65,37.65,0,0,0,30.74,0c4.36-2.24,6.77-5.31,6.77-8.64S470.5,306,466.14,303.74Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.14,303.74a37.65,37.65,0,0,0-30.74,0c-4.37,2.24-6.78,5.31-6.78,8.64s2.41,6.4,6.78,8.64a37.65,37.65,0,0,0,30.74,0c4.36-2.24,6.77-5.31,6.77-8.64S470.5,306,466.14,303.74Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.64,300c-6.08-3.51-14.21-5.45-22.88-5.45S434,296.5,427.89,300c-5.84,3.37-9.05,7.76-9.05,12.37s3.21,9,9.05,12.37c6.09,3.51,14.21,5.45,22.87,5.45s16.8-1.94,22.88-5.45c5.84-3.37,9.05-7.76,9.05-12.37S479.48,303.38,473.64,300Zm-7.5,21a37.65,37.65,0,0,1-30.74,0c-4.37-2.24-6.78-5.31-6.78-8.64s2.41-6.4,6.78-8.64a37.65,37.65,0,0,1,30.74,0c4.36,2.24,6.77,5.31,6.77,8.64S470.5,318.78,466.14,321Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.64,300c-6.08-3.51-14.21-5.45-22.88-5.45S434,296.5,427.89,300c-5.84,3.37-9.05,7.76-9.05,12.37s3.21,9,9.05,12.37c6.09,3.51,14.21,5.45,22.87,5.45s16.8-1.94,22.88-5.45c5.84-3.37,9.05-7.76,9.05-12.37S479.48,303.38,473.64,300Zm-7.5,21a37.65,37.65,0,0,1-30.74,0c-4.37-2.24-6.78-5.31-6.78-8.64s2.41-6.4,6.78-8.64a37.65,37.65,0,0,1,30.74,0c4.36,2.24,6.77,5.31,6.77,8.64S470.5,318.78,466.14,321Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.61,320c8.2-4.21,8.2-11,0-15.24s-21.49-4.21-29.69,0-8.2,11,0,15.24S457.41,324.21,465.61,320Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.61,320c8.2-4.21,8.2-11,0-15.24s-21.49-4.21-29.69,0-8.2,11,0,15.24S457.41,324.21,465.61,320Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.61,320c8.2-4.21,8.2-11,0-15.24s-21.49-4.21-29.69,0-8.2,11,0,15.24S457.41,324.21,465.61,320Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.61,307.62c-8.2-4.21-21.49-4.21-29.69,0-3.39,1.74-5.37,3.92-6,6.19.59,2.26,2.57,4.45,6,6.19,8.2,4.21,21.49,4.21,29.69,0,3.39-1.74,5.37-3.93,6-6.19C471,311.54,469,309.36,465.61,307.62Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.61,307.62c-8.2-4.21-21.49-4.21-29.69,0-3.39,1.74-5.37,3.92-6,6.19.59,2.26,2.57,4.45,6,6.19,8.2,4.21,21.49,4.21,29.69,0,3.39-1.74,5.37-3.93,6-6.19C471,311.54,469,309.36,465.61,307.62Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "452.75 304.93 452.75 308 451.7 309.11 449.76 311.15 449.76 307.94 452.75 304.93",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "452.75 304.93 452.75 308 451.7 309.11 449.76 311.15 449.76 307.94 452.75 304.93",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.76,307.94v1.82a17.78,17.78,0,0,1-3,.85,3.17,3.17,0,0,1-1.28-.05,2.9,2.9,0,0,1-.61-.25c-.74-.44-.86-1.1.55-1.91A4.92,4.92,0,0,1,449.76,307.94Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.76,307.94v1.82a17.78,17.78,0,0,1-3,.85,3.17,3.17,0,0,1-1.28-.05,2.9,2.9,0,0,1-.61-.25c-.74-.44-.86-1.1.55-1.91A4.92,4.92,0,0,1,449.76,307.94Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.69,316.69v2.65l-3.36,1.94-2.49-1.43a12.74,12.74,0,0,1-9.65.43v-2.66l1.53-1.52-1.53.42a9.84,9.84,0,0,1-7.51-.85c-1.51-.87-2.21-1.83-2.21-2.81v-2.59l.28-1.13-.92-.53V306l2.49,1.44a3.85,3.85,0,0,0-1.85,2.85v0c0,1,.74,1.89,2.21,2.74,3.28,1.89,6.52,1.27,9.49.31,2.77-.9,4.78-2,6.37-1,1,.57.69,1.27-.42,1.91a5.49,5.49,0,0,1-4.74.27l-3.19,3.16a12.08,12.08,0,0,0,1.76.52,13.17,13.17,0,0,0,7.89-.95l2.49,1.44Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.47,310.24v0c0,1,.74,1.89,2.21,2.74,3.28,1.89,6.52,1.27,9.49.31,2.77-.9,4.78-2,6.37-1,1,.57.69,1.27-.42,1.91a5.49,5.49,0,0,1-4.74.27l-3.19,3.16a12.08,12.08,0,0,0,1.76.52,13.17,13.17,0,0,0,7.89-.95l2.49,1.44,3.36-1.94v2.65l-3.36,1.94-2.49-1.43a12.74,12.74,0,0,1-9.65.43v-2.66l1.53-1.52-1.53.42a9.84,9.84,0,0,1-7.51-.85c-1.51-.87-2.21-1.83-2.21-2.81v-2.59l.28-1.13",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.83,306v2.66l.92.53h0a5.48,5.48,0,0,1,1.58-1.76Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.14,315a3,3,0,0,1-.26,1.26l-1.68-1a3.32,3.32,0,0,0,1.91-2.56C463.12,313.42,463.14,314.88,463.14,315Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M463.14,315a3,3,0,0,1-.26,1.26l-1.68-1a3.32,3.32,0,0,0,1.91-2.56C463.12,313.42,463.14,314.88,463.14,315Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M463.13,316.36l-1.93-1.12a3.28,3.28,0,0,0,1.93-2.95,2.28,2.28,0,0,0,0-.26c-.08-.91-.76-1.81-2.15-2.61h0a8.82,8.82,0,0,0-4.48-1.16h-.42l-.4,0-.35,0-.15,0-.26,0a18.69,18.69,0,0,0-2.18.45q-.51.13-1,.3l-1.41.46-.53.19a16.64,16.64,0,0,1-3,.85,3.36,3.36,0,0,1-1.28-.05,3.16,3.16,0,0,1-.6-.25c-.75-.44-.87-1.1.54-1.91a4.91,4.91,0,0,1,4.33-.45l3-3a12.76,12.76,0,0,0-9,.5l-2.5-1.44-3.39,2,2.49,1.44c-1.21.94-1.87,1.92-1.85,2.86v0c0,1,.74,1.89,2.21,2.74,3.28,1.89,6.53,1.27,9.5.31,2.76-.9,4.77-2,6.36-1.05,1,.58.69,1.27-.42,1.92a5.49,5.49,0,0,1-4.74.27l-3.19,3.16a12.08,12.08,0,0,0,1.76.52,11.53,11.53,0,0,0,3.07.22,14.22,14.22,0,0,0,4.81-1.17l2.5,1.44,3.36-1.94Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M463.13,316.36l-1.93-1.12a3.28,3.28,0,0,0,1.93-2.95,2.28,2.28,0,0,0,0-.26c-.08-.91-.76-1.81-2.15-2.61h0a8.82,8.82,0,0,0-4.48-1.16h-.42l-.4,0-.35,0-.15,0-.26,0a18.69,18.69,0,0,0-2.18.45q-.51.13-1,.3l-1.41.46-.53.19a16.64,16.64,0,0,1-3,.85,3.36,3.36,0,0,1-1.28-.05,3.16,3.16,0,0,1-.6-.25c-.75-.44-.87-1.1.54-1.91a4.91,4.91,0,0,1,4.33-.45l3-3a12.76,12.76,0,0,0-9,.5l-2.5-1.44-3.39,2,2.49,1.44c-1.21.94-1.87,1.92-1.85,2.86v0c0,1,.74,1.89,2.21,2.74,3.28,1.89,6.53,1.27,9.5.31,2.76-.9,4.77-2,6.36-1.05,1,.58.69,1.27-.42,1.92a5.49,5.49,0,0,1-4.74.27l-3.19,3.16a12.08,12.08,0,0,0,1.76.52,11.53,11.53,0,0,0,3.07.22,14.22,14.22,0,0,0,4.81-1.17l2.5,1.44,3.36-1.94Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "457.83 317.19 457.83 319.85 460.33 321.29 460.33 318.63 457.83 317.19",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "457.83 317.19 457.83 319.85 460.33 321.29 460.33 318.63 457.83 317.19",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.83 305.95 441.22 303.99 443.72 305.43 441.25 304.39 437.83 305.95",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.43,308.4a4.91,4.91,0,0,1,4.33-.45l3-3-3,2.7A4.53,4.53,0,0,0,445.43,308.4Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.19,317.62a12.08,12.08,0,0,0,1.76.52,11.53,11.53,0,0,0,3.07.22,10.76,10.76,0,0,1-4.33-.86l2.69-3Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "457.83 317.19 460.33 318.31 463.69 316.69 460.33 318.63 457.83 317.19",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.15,300.46c8.83-5.37,22.61-5.9,22.61-5.9-8.66,0-16.78,1.94-22.87,5.45-5.84,3.37-9.05,7.76-9.05,12.37C418.84,312.38,419.16,305.92,428.15,300.46Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.19,331.6c9.38.41,19-1.45,26.18-5.59,7.46-4.31,10.65-10.15,9.57-15.76,0,0,1.39,9.15-10.14,15.41S448.19,331.6,448.19,331.6Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cabinet--inject-73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--cabinet--inject-73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--cabinet--inject-73"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "69.78 316.2 24.96 290.32 24.96 149.85 69.78 175.73 69.78 316.2",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.78 175.73 133.8 138.77 133.81 279.23 69.78 316.2 69.78 175.73",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.8 138.77 69.78 175.73 24.96 149.85 88.98 112.89 133.8 138.77",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.18 266.77 127.4 237.2 127.4 272.8 128.58 273.48 77.36 303.05 76.18 302.37 76.18 266.77",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.36 267.45 128.58 237.88 128.58 273.48 77.36 303.05 77.36 267.45",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.05
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "77.36 267.45 128.58 237.88 128.58 273.48 77.36 303.05 77.36 267.45"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M97.44,261.89l8.71-5c1.13-.65,2-.35,2,.67a4.09,4.09,0,0,1-2,3l-8.72,5c-1.13.65-2,.35-2-.67A4.09,4.09,0,0,1,97.44,261.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.18 223.78 127.4 194.21 127.4 229.81 128.58 230.49 77.36 260.06 76.18 259.38 76.18 223.78",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.36 224.47 128.58 194.89 128.58 230.49 77.36 260.06 77.36 224.47",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.05
    }
  }, _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "77.36 224.47 128.58 194.89 128.58 230.49 77.36 260.06 77.36 224.47"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M97.44,218.91l8.71-5c1.13-.66,2-.36,2,.66a4.07,4.07,0,0,1-2,3l-8.72,5c-1.13.66-2,.36-2-.66A4.07,4.07,0,0,1,97.44,218.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.18 180.8 127.4 151.23 127.4 186.82 76.18 216.39 76.18 180.8",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Drawer--inject-73"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "153.01 172.03 124.59 155.64 124.59 187 153.01 203.4 153.01 172.03",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "153.01 172.03 124.59 155.64 124.59 187 153.01 203.4 153.01 172.03"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "126.58 154.49 124.59 155.63 153.01 172.03 155 170.89 126.58 154.49",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.58,158a.72.72,0,0,0-.27-.64l-.07,0-1.45-.84h0a.68.68,0,0,0-.7.07l-29,16.69-.84-3.4a.93.93,0,0,0-.42-.55h0l-1.51-.88h0a.87.87,0,0,0-.92,0L87.14,175.5a2.21,2.21,0,0,0-1,1.73V218.3a.72.72,0,0,0,.27.64h0l1.55.89h0a.72.72,0,0,0,.68-.08l45-26a2.2,2.2,0,0,0,1-1.73Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.58,158l0,34.11a2.23,2.23,0,0,1-1,1.74l-45.08,26a.59.59,0,0,1-.88-.51v-41.2a2.05,2.05,0,0,1,.29-1,2,2,0,0,1,.71-.74L101,169.27a.91.91,0,0,1,.9-.05l0,0h0a1,1,0,0,1,.42.55l.84,3.4.13.37a.88.88,0,0,0,1.34.53l29-16.72a.72.72,0,0,1,.65-.09l0,0h0A.71.71,0,0,1,134.58,158Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.58,158l0,34.11a2.23,2.23,0,0,1-1,1.74l-45.08,26a.59.59,0,0,1-.88-.51v-41.2a2.05,2.05,0,0,1,.29-1,2,2,0,0,1,.71-.74L101,169.27a.91.91,0,0,1,.9-.05l0,0h0a1,1,0,0,1,.42.55l.84,3.4.13.37a.88.88,0,0,0,1.34.53l29-16.72a.72.72,0,0,1,.65-.09l0,0h0A.71.71,0,0,1,134.58,158Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,219.85h0l-1.55-.9a.72.72,0,0,1-.27-.64V177.23a2,2,0,0,1,.29-1l1.5.87h0a2.08,2.08,0,0,0-.29,1v41.2A.57.57,0,0,0,88,219.85Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.41,160.76a.71.71,0,0,0-.28-.63l-.07,0-1.45-.85h0a.72.72,0,0,0-.71.07L108,176l-.85-3.4a.94.94,0,0,0-.41-.55h0l-1.5-.88h0a.9.9,0,0,0-.92,0L92,178.31a2.23,2.23,0,0,0-1,1.74v41.06a.72.72,0,0,0,.27.64h0l1.55.9h0a.7.7,0,0,0,.68-.09l45-25.95a2.21,2.21,0,0,0,1-1.74Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.68,172a.91.91,0,0,0-.9.05l-12.32,7.1a2.2,2.2,0,0,0-.7.75l-1.5-.87a2,2,0,0,1,.7-.75l12.32-7.11a.9.9,0,0,1,.91,0h0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.06,160.09a.74.74,0,0,0-.66.09l-29,16.72a.88.88,0,0,1-1.34-.53L108,176l28.94-16.69a.94.94,0,0,1,.45-.14.56.56,0,0,1,.26.07h0Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.41,160.76v34.11a2.2,2.2,0,0,1-1,1.74l-45.07,26a.59.59,0,0,1-.89-.51v-41.2a2,2,0,0,1,.29-1,2.14,2.14,0,0,1,.71-.75l12.32-7.11a.89.89,0,0,1,.9,0h0a1,1,0,0,1,.42.56L108,176l.13.37a.88.88,0,0,0,1.34.53l29-16.71a.72.72,0,0,1,.66-.1l0,0h0A.72.72,0,0,1,139.41,160.76Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.83,222.66h0l-1.55-.9a.75.75,0,0,1-.27-.64V180a2,2,0,0,1,.3-1l1.5.87h0a2,2,0,0,0-.3,1v41.2A.58.58,0,0,0,92.83,222.66Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.23,163.57a.71.71,0,0,0-.27-.63l-.07,0-1.45-.85h0a.7.7,0,0,0-.7.07l-28.95,16.7-.84-3.4a1,1,0,0,0-.42-.56h0L110,174h0a.9.9,0,0,0-.92,0l-12.31,7.1a2.23,2.23,0,0,0-1,1.74v41.07a.71.71,0,0,0,.27.63h0l1.55.9h0a.72.72,0,0,0,.68-.08l45-26a2.23,2.23,0,0,0,1-1.73Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.5,174.85a.89.89,0,0,0-.9,0L98.29,182a2.14,2.14,0,0,0-.71.75l-1.5-.88a2.05,2.05,0,0,1,.71-.75L109.1,174a.9.9,0,0,1,.92,0h0Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.89,162.9a.72.72,0,0,0-.66.1l-29,16.71a.87.87,0,0,1-1.33-.53l-.14-.36,28.95-16.7a.91.91,0,0,1,.44-.13.53.53,0,0,1,.26.06h0Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.23,163.57l0,34.12a2.21,2.21,0,0,1-1,1.73l-45.08,26a.58.58,0,0,1-.88-.51v-41.2a2,2,0,0,1,.29-1,2.14,2.14,0,0,1,.71-.75l12.31-7.11a.91.91,0,0,1,.9,0h0a1,1,0,0,1,.42.56l.84,3.4.14.36a.87.87,0,0,0,1.33.54l29-16.72a.73.73,0,0,1,.65-.1l0,0h0A.74.74,0,0,1,144.23,163.57Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.23,163.57l0,34.12a2.21,2.21,0,0,1-1,1.73l-45.08,26a.58.58,0,0,1-.88-.51v-41.2a2,2,0,0,1,.29-1,2.14,2.14,0,0,1,.71-.75l12.31-7.11a.91.91,0,0,1,.9,0h0a1,1,0,0,1,.42.56l.84,3.4.14.36a.87.87,0,0,0,1.33.54l29-16.72a.73.73,0,0,1,.65-.1l0,0h0A.74.74,0,0,1,144.23,163.57Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.65,225.48l0,0-1.55-.9a.71.71,0,0,1-.27-.63V182.86a2.05,2.05,0,0,1,.29-1l1.5.88h0a2,2,0,0,0-.29,1v41.2A.59.59,0,0,0,97.65,225.48Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.06,166.39a.72.72,0,0,0-.28-.64l-.07,0-1.45-.84h0a.7.7,0,0,0-.7.08l-28.95,16.69-.85-3.4a.88.88,0,0,0-.41-.55h0l-1.5-.87h0a.9.9,0,0,0-.92,0l-12.32,7.11a2.21,2.21,0,0,0-1,1.73v41.07a.7.7,0,0,0,.27.63h0l1.55.9h0a.74.74,0,0,0,.69-.08l44.95-26a2.19,2.19,0,0,0,1-1.73Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.33,177.66a.91.91,0,0,0-.9,0l-12.32,7.11a2,2,0,0,0-.7.75l-1.5-.88a2,2,0,0,1,.7-.74l12.32-7.11a.88.88,0,0,1,.91,0h0Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.71,165.71a.73.73,0,0,0-.65.1l-29,16.72a.88.88,0,0,1-1.34-.54l-.13-.36,28.94-16.7a.91.91,0,0,1,.45-.13.55.55,0,0,1,.26.06h0Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.06,166.39V200.5a2.17,2.17,0,0,1-1,1.73l-45.07,26a.6.6,0,0,1-.89-.51V186.54a2,2,0,0,1,.3-1,2.12,2.12,0,0,1,.7-.75l12.32-7.11a.91.91,0,0,1,.9,0l0,0h0a.91.91,0,0,1,.41.55l.85,3.4.13.37a.88.88,0,0,0,1.34.53l29-16.72a.79.79,0,0,1,.66-.1l0,0h0A.72.72,0,0,1,149.06,166.39Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.06,166.39V200.5a2.17,2.17,0,0,1-1,1.73l-45.07,26a.6.6,0,0,1-.89-.51V186.54a2,2,0,0,1,.3-1,2.12,2.12,0,0,1,.7-.75l12.32-7.11a.91.91,0,0,1,.9,0l0,0h0a.91.91,0,0,1,.41.55l.85,3.4.13.37a.88.88,0,0,0,1.34.53l29-16.72a.79.79,0,0,1,.66-.1l0,0h0A.72.72,0,0,1,149.06,166.39Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.77 199.31 77.36 182.91 77.35 214.27 105.77 230.67 105.77 199.31",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.34 181.76 77.35 182.9 105.77 199.31 107.76 198.16 79.34 181.76",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.2 197.55 156.42 167.98 156.42 203.58 105.2 233.15 105.2 197.55",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.28,192l8.71-5c1.13-.65,2-.35,2,.67a4.1,4.1,0,0,1-2,3l-8.71,5c-1.13.65-2,.36-2-.67A4.12,4.12,0,0,1,125.28,192Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.2 197.55 103.5 196.57 103.5 232.17 105.2 233.15 105.2 197.55",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.5 196.57 154.72 167 156.42 167.98 105.2 197.55 103.5 196.57",
    style: {
      fill: "#37474f"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161,100.11,150.82,106l4.06,9.11a.89.89,0,0,0,.39.44l3.5,2a.93.93,0,0,0,1.37-.54l4.4-14.91Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,100.11,150.82,106l4.06,9.11a.89.89,0,0,0,.39.44l3.5,2a.93.93,0,0,0,1.37-.54l4.4-14.91Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.34,108.05l4,9.11a.93.93,0,0,0,1.75-.11l4.4-14.91Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.43,37.21,133.26,61.55a2.13,2.13,0,0,0-1,1.68v52.33a2.1,2.1,0,0,0,1,1.67l3.47,2a2.2,2.2,0,0,0,1.94,0l42.17-24.35a2.13,2.13,0,0,0,1-1.68V40.81a2.1,2.1,0,0,0-1-1.67l-3.47-1.94A2.14,2.14,0,0,0,175.43,37.21Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.8,40.63c-.08-.48-.47-.66-1-.38L138.67,64.6a2,2,0,0,0-.68.72l-5.4-3.08a2,2,0,0,1,.67-.69l42.17-24.34a2.14,2.14,0,0,1,1.94,0l3.47,1.94A2.15,2.15,0,0,1,181.8,40.63Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.7,118.61V66.27a2.16,2.16,0,0,1,1-1.67l42.17-24.35c.54-.31,1-.06,1,.56V93.14a2.13,2.13,0,0,1-1,1.68l-42.17,24.35C138.14,119.47,137.7,119.22,137.7,118.61Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.67,119.17a2.24,2.24,0,0,1-1.94,0l-3.47-2a2.12,2.12,0,0,1-1-1.66V63.23a2,2,0,0,1,.31-1L138,65.32a1.91,1.91,0,0,0-.29,1V118.6C137.7,119.17,138.1,119.5,138.67,119.17Z",
    style: {
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M155.41,69.05c.05,1,.07,1.91.07,2.7s0,1.68-.07,2.67a14.6,14.6,0,0,1-1.74,6.3A10.88,10.88,0,0,1,149.58,85q-2.52,1.45-4.08.39c-1-.7-1.63-2.13-1.75-4.28,0-.93-.07-1.79-.07-2.59s0-1.72.07-2.78a14.51,14.51,0,0,1,1.66-6.3,10.87,10.87,0,0,1,4.17-4.38q2.67-1.53,4.18-.44T155.41,69.05Zm10.22-11.72a6.8,6.8,0,0,1,.53-1.08,2,2,0,0,1,.77-.72l3.74-2.16a.57.57,0,0,1,.63-.06c.16.11.23.33.23.67a1.89,1.89,0,0,1,0,.29,3.45,3.45,0,0,1-.11.4l-17.77,46.26a6.84,6.84,0,0,1-.52,1.08,2.1,2.1,0,0,1-.78.72l-3.74,2.16q-.39.24-.63.06a.79.79,0,0,1-.23-.67,1.89,1.89,0,0,1,0-.29,3.45,3.45,0,0,1,.11-.4ZM148.41,78.76a3.27,3.27,0,0,0,.31,1.38c.17.31.46.34.86.11a1.9,1.9,0,0,0,.87-1.11,6.36,6.36,0,0,0,.3-1.73c.09-2.11.09-4.11,0-6a3.33,3.33,0,0,0-.3-1.38c-.17-.3-.46-.34-.87-.11a2,2,0,0,0-.86,1.11,6.42,6.42,0,0,0-.31,1.73C148.32,74.76,148.32,76.76,148.41,78.76Zm27.52-1.93c0,1,.07,1.9.07,2.7s0,1.68-.07,2.67a14.63,14.63,0,0,1-1.74,6.3,10.88,10.88,0,0,1-4.09,4.32q-2.52,1.46-4.08.39c-1-.71-1.63-2.13-1.75-4.28,0-.93-.07-1.79-.07-2.59s0-1.72.07-2.78a14.51,14.51,0,0,1,1.66-6.3,10.87,10.87,0,0,1,4.17-4.38q2.67-1.53,4.18-.44T175.93,76.83Zm-7,9.71a3.27,3.27,0,0,0,.31,1.38c.17.31.46.34.86.11a2,2,0,0,0,.87-1.11,6.36,6.36,0,0,0,.3-1.73,59.38,59.38,0,0,0,0-6,3.29,3.29,0,0,0-.3-1.38c-.17-.3-.46-.34-.87-.11a2,2,0,0,0-.86,1.11,6.42,6.42,0,0,0-.31,1.73Q168.8,83.53,168.93,86.54Z",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Files--inject-73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--files--inject-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390.66,351.42A2.2,2.2,0,0,0,392,349.6c0-.66,0-2.82,0-2.82L236.4,258.71a7,7,0,0,0-6.34,0L107.73,329.34,268.39,422Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.66,351.42A2.2,2.2,0,0,0,392,349.6c0-.66,0-2.82,0-2.82L236.4,258.71a7,7,0,0,0-6.34,0L107.73,329.34,268.39,422Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.66,348.68c1.75-1,1.75-2.65,0-3.66L236.4,256a7,7,0,0,0-6.34,0L107.73,326.59l160.65,92.69Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.66,348.68c1.75-1,1.75-2.65,0-3.66L236.4,256a7,7,0,0,0-6.34,0L107.73,326.59l160.65,92.69Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.89,308.13l90.57-52.26a7,7,0,0,1,6.33,0l143.8,83L388.37,332v14l-.22.13c.39.86.08,1.8-1.09,2.48L283.34,408.45,122.68,315.76V300.52Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.06,333.35c1.75-1,1.75-2.65,0-3.66L232.79,240.63a7,7,0,0,0-6.33,0L122.68,300.52l160.66,92.69Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.34 393.21 283.34 408.44 122.68 315.75 122.68 300.52 283.34 393.21",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.66,387.26a4.37,4.37,0,0,0,1.17.4,3.69,3.69,0,0,0,1.87,0,1.7,1.7,0,0,0,.58-.22c1-.51.84-1.46-.26-2.08a4.07,4.07,0,0,0-1.64-.48,3.51,3.51,0,0,0-2,.33.38.38,0,0,0-.18.15C280.49,385.87,280.64,386.67,281.66,387.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.68,399.18a8.24,8.24,0,0,0,1.61,5.27,5.62,5.62,0,0,0,4.53,2.15h0a8.84,8.84,0,0,0,4.39-1.31c.25-.15.54-.3.8-.48l-1.79-1c-4.32,2.41-7.75.36-7.76-4.61a17.37,17.37,0,0,1,7.83-13.57c2.34-1.35,4.46-1.39,5.89-.29a4.16,4.16,0,0,1,1.61,2.34,3.69,3.69,0,0,0,1.87,0,6.6,6.6,0,0,0-1.32-2.78,5.69,5.69,0,0,0-4.54-2.12,8.86,8.86,0,0,0-4.42,1.32C269.52,386.85,265.68,393.51,265.68,399.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.22,384.78,392,325.28v2a3.5,3.5,0,0,1-1.58,2.75L270.22,387.54Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.22,384.78,392,325.28v2a3.5,3.5,0,0,1-1.58,2.75L270.22,387.54Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.66,327.09c1.75-1,1.75-2.65,0-3.66L236.4,234.37a7,7,0,0,0-6.34,0L107.73,293.11,268.38,385.8Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.66,327.09c1.75-1,1.75-2.65,0-3.66L236.4,234.37a7,7,0,0,0-6.34,0L107.73,293.11,268.38,385.8Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.38 422.02 107.73 329.33 107.73 293.06 268.38 385.81 268.38 422.02",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.53,398.76a5.7,5.7,0,0,0,4.56-2.16,8.34,8.34,0,0,0,1.61-5.27,19.11,19.11,0,0,0-8.76-15.16,8.83,8.83,0,0,0-4.42-1.32c-3.69,0-6.17,3-6.17,7.43a19.08,19.08,0,0,0,8.76,15.16,8.94,8.94,0,0,0,4.42,1.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.87,391.33c0,5-3.51,7-7.84,4.53a17.31,17.31,0,0,1-7.85-13.58c0-5,3.51-7,7.84-4.53A17.37,17.37,0,0,1,244.87,391.33Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.38,373.07v2.74c0,5.5-3.85,7.72-8.61,5l-80.65-46.57c-4.75-2.74-8.61-9.42-8.61-14.91v-2.75c0-5.49,3.86-7.71,8.61-5l80.65,46.56C212.53,360.9,216.38,367.58,216.38,373.07Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.27 420.94 270.27 384.89 268.38 385.81 268.38 422.02 270.27 420.94",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.27 420.94 270.27 384.89 268.38 385.81 268.38 422.02 270.27 420.94",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109,285.27a2.84,2.84,0,0,0,1.38,2.17l157.9,91.1a3.05,3.05,0,0,0,2.76,0l124.06-62.75V313l-160.6-92.72L110.42,283.09A2.86,2.86,0,0,0,109,285.27Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.14,313l-124,62.77a3.27,3.27,0,0,1-2.78,0L110.43,284.67a.84.84,0,0,1,0-1.59l124.12-62.76Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.14,313v2.76l-124,62.75a2.74,2.74,0,0,1-1.39.32v-2.75a2.73,2.73,0,0,0,1.39-.31Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.25 314.13 232.6 221.44 232.6 185.16 393.25 278.28 393.25 314.13",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.25 314.13 232.6 221.44 232.6 185.16 393.25 278.28 393.25 314.13",
    style: {
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.75,265.75a3.82,3.82,0,0,0-1.72,3v7.34a3.8,3.8,0,0,0,1.72,3L268,369.76a3.81,3.81,0,0,0,3.45,0l105.17-56.88V301.56L216,208.84Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216,208.84,110.75,265.75a1.05,1.05,0,0,0,0,2L268,358.44a3.81,3.81,0,0,0,3.45,0l105.17-56.88Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.18,302.48a3.94,3.94,0,0,0,1.17.4,3.54,3.54,0,0,0,1.86,0,1.56,1.56,0,0,0,.59-.22c.95-.51.84-1.46-.26-2.08a4.11,4.11,0,0,0-1.65-.48,3.46,3.46,0,0,0-2,.33.38.38,0,0,0-.18.15C362,301.09,362.15,301.89,363.18,302.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.7,358.83v11.33a3.62,3.62,0,0,1-1.75-.39L110.74,279.08a3.86,3.86,0,0,1-1.71-3v-7.36a3.8,3.8,0,0,1,1.32-2.66c-.52.51-.4,1.19.39,1.67L268,358.43A3.13,3.13,0,0,0,269.7,358.83Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.59,286.78c-2-1.21-4.56-1.07-7.13.41-4.3,2.49-8,8.21-9.74,14.43l2.35.34c1.6-5.51,4.87-10.61,8.56-12.74a6.19,6.19,0,0,1,3-.92,3.41,3.41,0,0,1,1.79.49c1.88,1.12,2.94,4.13,2.82,8-.22,7.51-4.52,16-9.59,18.93a5.64,5.64,0,0,1-3.55.88l-2.57,1.47.16.09a5.69,5.69,0,0,0,3,.81,8.19,8.19,0,0,0,4.13-1.23c5.79-3.34,10.52-12.51,10.77-20.88C385.69,292.05,384.25,288.37,381.59,286.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109,262.23a2.86,2.86,0,0,0,1.38,2.18l157.9,91.1a3.05,3.05,0,0,0,2.76,0l124.06-75.82v-2.76l-160.6-92.71L110.42,260.05A2.88,2.88,0,0,0,109,262.23Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.14,276.93l-124,75.83a2.74,2.74,0,0,1-1.39.32,2.62,2.62,0,0,1-1.39-.32L110.43,261.64a.85.85,0,0,1,0-1.6l124.12-75.82Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.14,276.93l-124,75.83a2.74,2.74,0,0,1-1.39.32,2.62,2.62,0,0,1-1.39-.32L110.43,261.64a.85.85,0,0,1,0-1.6l124.12-75.82Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.14,276.93v2.76l-124,75.82a2.76,2.76,0,0,1-1.39.32v-2.75a2.74,2.74,0,0,0,1.39-.32Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.14 313.03 395.14 277 393.25 278.28 393.25 314.13 395.14 313.03",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.14 313.03 395.14 277 393.25 278.28 393.25 314.13 395.14 313.03",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Form--inject-73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Paper--inject-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.62,346.83,384.07,279a2.21,2.21,0,0,0,1-1.74V276a2.21,2.21,0,0,0-1-1.74L239,190.49a2.22,2.22,0,0,0-2,0L119.5,258.3a2.26,2.26,0,0,0-1,1.75v1.31a2.23,2.23,0,0,0,1,1.74l145.11,83.73A2.22,2.22,0,0,0,266.62,346.83Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.29,258.46a1.72,1.72,0,0,0-.27.27l-.12.16a3.09,3.09,0,0,0-.29.54,1.66,1.66,0,0,0-.09.37,1.06,1.06,0,0,0,0,.25v1.3a2.19,2.19,0,0,0,1,1.74l145.1,83.74a2,2,0,0,0,1,.24v-3.63a2.07,2.07,0,0,1-1-.24L119.5,259.47C119,259.19,119,258.77,119.29,258.46Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.32,274.41c.29.32.21.72-.25,1L266.62,343.2a2,2,0,0,1-1,.24v3.63a2,2,0,0,0,1-.24L384.07,279a2.18,2.18,0,0,0,1-1.74V276A2.24,2.24,0,0,0,384.32,274.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Forms--inject-73"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "243.14 199.24 218.05 213.73 219.86 214.77 244.95 200.28 243.14 199.24",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.76 201.33 209.12 223.06 210.93 224.11 248.57 202.38 246.76 201.33",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.38 203.42 216.93 222.74 218.74 223.78 252.2 204.47 250.38 203.42",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.11 242.52 210.57 304.62 215.22 307.31 322.77 245.21 318.11 242.52",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.11 242.52 210.57 304.62 215.22 307.31 322.77 245.21 318.11 242.52",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.32,307.17l106.22-61.33,6.16,3.56L222.48,310.73l-6.16-3.56m-1.1.13,7,4.06,107.54-62.09-7-4.06L215.22,307.3Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.58 270.06 294.02 269.55 287.48 265.77 287.04 266.28 293.58 270.06",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.11 290.53 258.56 290.02 251.98 286.23 251.54 286.73 258.11 290.53",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.91,311l106.22-61.33,6.16,3.56L229.07,314.53,222.91,311m-1.09.13,7,4.05,107.54-62.09-7-4L221.82,311.11Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "300.17 273.86 300.62 273.35 294.07 269.58 293.63 270.08 300.17 273.86",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.7 294.34 265.15 293.83 258.57 290.03 258.13 290.54 264.7 294.34",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.5,314.78l106.22-61.32,6.16,3.55L235.66,318.34l-6.16-3.56m-1.09.14,7,4.05L343,256.88l-7-4.06-107.54,62.1Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.76 277.67 307.21 277.16 300.67 273.38 300.22 273.89 306.76 277.67",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.3 298.14 271.74 297.63 265.16 293.84 264.72 294.35 271.3 298.14",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.09,318.59l106.22-61.33,6.16,3.56L242.25,322.14l-6.16-3.55m-1.09.13,7,4.06,107.55-62.1-7-4.05L235,318.72Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.35 281.47 313.8 280.96 307.26 277.19 306.81 277.69 313.35 281.47",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.89 301.95 278.33 301.44 271.75 297.64 271.31 298.15 277.89 301.95",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,325.48l35.3-20.39,8.17,4.72L256.2,330.2,248,325.48m-1.23,0,9.31,5.38,36.62-21.15-9.31-5.38L246.8,325.53Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.44 266.38 305.11 297.75 309.03 300.02 363.36 268.65 359.44 266.38",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.55 230.65 142.22 262.02 146.14 264.28 200.48 232.91 196.55 230.65",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.64 260.13 181.08 287.59 185.74 290.28 233.3 262.82 228.64 260.13",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.64 260.13 181.08 287.59 185.74 290.28 233.3 262.82 228.64 260.13",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.27,290.89l-3.78,2.18-3.71-2.15,3.77-2.18Zm-3.72,1.7,2.88-1.67-2.94-1.7-2.88,1.67Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.2,294.89l-3.78,2.18-3.71-2.15,3.77-2.18Zm-3.72,1.7,2.88-1.67-2.94-1.7-2.88,1.67Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.13,298.89l-3.78,2.18-3.71-2.15,3.77-2.18Zm-3.72,1.7,2.88-1.67-2.94-1.7-2.88,1.67Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.74,266.38a.37.37,0,0,1-.13.12l-37.56,21.69a.28.28,0,0,1-.41-.1.34.34,0,0,1,.17-.43L235.36,266a.29.29,0,0,1,.42.1A.34.34,0,0,1,235.74,266.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.5,267.4a.37.37,0,0,1-.13.12L199.81,289.2a.28.28,0,0,1-.41-.09.35.35,0,0,1,.17-.44L237.12,267a.29.29,0,0,1,.42.1A.35.35,0,0,1,237.5,267.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.67,270.38a.37.37,0,0,1-.13.12L205,292.19a.28.28,0,0,1-.41-.1.34.34,0,0,1,.16-.43L242.29,270a.29.29,0,0,1,.42.1A.34.34,0,0,1,242.67,270.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.43,271.4a.37.37,0,0,1-.13.12L206.74,293.2a.28.28,0,0,1-.41-.09.35.35,0,0,1,.17-.44L244.05,271a.29.29,0,0,1,.42.1A.35.35,0,0,1,244.43,271.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.6,274.39a.47.47,0,0,1-.13.11l-37.56,21.69a.28.28,0,0,1-.41-.1.34.34,0,0,1,.16-.43L249.22,274a.3.3,0,0,1,.42.1A.37.37,0,0,1,249.6,274.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.36,275.4a.37.37,0,0,1-.13.12l-37.56,21.69a.29.29,0,0,1-.41-.1.34.34,0,0,1,.16-.43L251,275a.29.29,0,0,1,.42.1A.34.34,0,0,1,251.36,275.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.63 225.5 241.06 252.96 245.72 255.65 293.28 228.19 288.63 225.5",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.63 225.5 241.06 252.96 245.72 255.65 293.28 228.19 288.63 225.5",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.26,256.25l-3.78,2.19-3.72-2.15,3.78-2.18Zm-3.72,1.7,2.88-1.66-2.94-1.7-2.88,1.67Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.19,260.26l-3.78,2.18-3.72-2.15,3.78-2.18ZM261.47,262l2.88-1.66-2.94-1.7-2.88,1.67Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.11,264.26l-3.77,2.18-3.72-2.15,3.78-2.18ZM268.4,266l2.88-1.66-2.94-1.7-2.88,1.67Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.72,231.75a.3.3,0,0,1-.13.12L258,253.55a.29.29,0,0,1-.42-.09.36.36,0,0,1,.17-.44l37.56-21.68a.28.28,0,0,1,.41.1A.29.29,0,0,1,295.72,231.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.48,232.77a.38.38,0,0,1-.13.12L259.8,254.57a.29.29,0,0,1-.42-.1.36.36,0,0,1,.17-.43l37.56-21.68a.28.28,0,0,1,.41.09A.31.31,0,0,1,297.48,232.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.65,235.75a.3.3,0,0,1-.13.12L265,257.56a.29.29,0,0,1-.42-.1.35.35,0,0,1,.17-.43l37.56-21.69a.28.28,0,0,1,.41.1A.29.29,0,0,1,302.65,235.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.41,236.77a.3.3,0,0,1-.13.12l-37.55,21.68a.29.29,0,0,1-.42-.1.35.35,0,0,1,.17-.43L304,236.36a.28.28,0,0,1,.41.09A.31.31,0,0,1,304.41,236.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.58,239.75a.3.3,0,0,1-.13.12L271.9,261.56a.29.29,0,0,1-.42-.1.35.35,0,0,1,.17-.43l37.56-21.69a.28.28,0,0,1,.41.1A.29.29,0,0,1,309.58,239.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.34,240.77a.3.3,0,0,1-.13.12l-37.55,21.68a.29.29,0,0,1-.42-.09.36.36,0,0,1,.17-.44L311,240.36a.28.28,0,0,1,.41.1A.3.3,0,0,1,311.34,240.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.36 215.53 163.82 277.62 168.47 280.31 276.02 218.22 271.36 215.53",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.36 215.53 163.82 277.62 168.47 280.31 276.02 218.22 271.36 215.53",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.38,251.72a.34.34,0,0,1-.12.12l-51,29.46a.28.28,0,0,1-.41-.09.36.36,0,0,1,.16-.44l51-29.46a.28.28,0,0,1,.41.1A.29.29,0,0,1,225.38,251.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.9,223.4a.37.37,0,0,1-.13.12L177,282.88a.29.29,0,0,1-.42-.1.35.35,0,0,1,.17-.43L279.52,223a.29.29,0,0,1,.42.09A.37.37,0,0,1,279.9,223.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.47,224.88a.49.49,0,0,1-.13.12L179.52,284.36a.28.28,0,0,1-.41-.1.35.35,0,0,1,.17-.43l102.81-59.36a.28.28,0,0,1,.41.1A.32.32,0,0,1,282.47,224.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.46,241.38a.51.51,0,0,1-.13.12l-51,29.46a.29.29,0,0,1-.42-.1.35.35,0,0,1,.17-.43l51-29.46a.28.28,0,0,1,.41.09A.31.31,0,0,1,207.46,241.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,213.05a.49.49,0,0,1-.13.12L159,272.53a.28.28,0,0,1-.41-.1.35.35,0,0,1,.17-.43L261.6,212.64a.28.28,0,0,1,.41.1A.32.32,0,0,1,262,213.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.54,214.53a.3.3,0,0,1-.13.12L161.6,274a.29.29,0,0,1-.42-.1.36.36,0,0,1,.17-.43l102.82-59.36a.28.28,0,0,1,.41.1A.29.29,0,0,1,264.54,214.53Z",
    style: {
      fill: "#e0e0e0"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Laptop--inject-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.79,431.59c0,1.49,1.11,2.45,2.49,3.24l56.32,32.52a5.53,5.53,0,0,0,5,0l90.85-52.46c1.38-.79,2.49-1.81,2.49-3.3s-1.11-2.41-2.49-3.21l-56.32-32.51a5.45,5.45,0,0,0-5,0L49.28,428.32C47.9,429.12,46.79,430.11,46.79,431.59Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.28,431.2l56.32,32.51a5.47,5.47,0,0,0,5,0l90.85-52.45c1.38-.8,1.38-2.08,0-2.88l-56.32-32.51a5.45,5.45,0,0,0-5,0L49.28,428.32C47.9,429.12,47.9,430.4,49.28,431.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.09,464.31v3.63a5,5,0,0,1-2.49-.59L49.28,434.83c-1.38-.79-2.49-1.75-2.49-3.24s1-2.36,2.29-3.15a1.53,1.53,0,0,0,.2,2.76l56.32,32.52A5.15,5.15,0,0,0,108.09,464.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,428.75l83.5-48.21a2.61,2.61,0,0,1,2.34,0l3,1.71a.71.71,0,0,1,0,1.35L62.34,431.8a2.63,2.63,0,0,1-2.35,0l-3-1.7A.71.71,0,0,1,57,428.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.16,433.58l83.5-48.2a2.36,2.36,0,0,1,2.14-.12l21.73,12.55c.54.31.45.86-.2,1.24l-83.4,48.14a2.43,2.43,0,0,1-2.14.12L65,434.82C64.42,434.51,64.51,434,65.16,433.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.51,405.62l2.62-1.5c.11-.07.12-.17,0-.22l-2.5-1.45a.42.42,0,0,0-.38,0L134.65,404c-.11.07-.12.17,0,.22l2.5,1.45A.43.43,0,0,0,137.51,405.62Zm-3.82-5.22-2.61,1.51c-.11.07-.12.16,0,.22l2.5,1.44a.4.4,0,0,0,.38,0l2.61-1.51c.11-.06.12-.16,0-.22l-2.51-1.44A.42.42,0,0,0,133.69,400.4Zm-8.44,4.88-4.43,2.55c-.11.07-.12.16,0,.22l2.5,1.45a.43.43,0,0,0,.38,0l4.43-2.55c.11-.07.12-.16,0-.22l-2.5-1.44A.4.4,0,0,0,125.25,405.28Zm4.62-2.67-2.61,1.51c-.11.06-.12.16,0,.22l2.5,1.44a.42.42,0,0,0,.38,0l2.61-1.51c.11-.07.12-.16,0-.22l-2.5-1.44A.4.4,0,0,0,129.87,402.61Zm-10.25,5.92L117,410c-.11.06-.12.16,0,.22l2.5,1.44a.42.42,0,0,0,.38,0l2.62-1.51c.11-.06.12-.16,0-.22l-2.5-1.44A.42.42,0,0,0,119.62,408.53Zm-3.82,2.2-2.62,1.51c-.11.07-.12.17,0,.22l2.5,1.45a.43.43,0,0,0,.38,0l2.62-1.5c.11-.07.12-.17,0-.22l-2.5-1.45A.46.46,0,0,0,115.8,410.73Zm9.8,5.9,2.61-1.51c.12-.07.13-.16,0-.22l-2.5-1.45a.43.43,0,0,0-.38,0L122.74,415c-.11.06-.12.16,0,.22l2.5,1.44A.42.42,0,0,0,125.6,416.63Zm-3.82,2.2,2.61-1.51c.12-.06.12-.16,0-.22l-2.5-1.44a.42.42,0,0,0-.38,0l-2.62,1.51c-.11.07-.12.17,0,.22l2.5,1.45A.43.43,0,0,0,121.78,418.83ZM118,421l2.61-1.51c.11-.06.12-.16,0-.22l-2.51-1.44a.42.42,0,0,0-.38,0l-2.61,1.51c-.11.06-.12.16,0,.22l2.5,1.44A.42.42,0,0,0,118,421Zm-3.82,2.2,2.61-1.5c.11-.07.12-.17,0-.22l-2.5-1.45a.43.43,0,0,0-.38,0l-2.61,1.5c-.11.07-.12.17,0,.22l2.5,1.45A.43.43,0,0,0,114.14,423.24Zm19.55-15.41,2.62-1.51c.11-.06.12-.16,0-.22l-2.5-1.44a.42.42,0,0,0-.38,0l-2.62,1.51c-.11.06-.12.16,0,.22l2.5,1.44A.42.42,0,0,0,133.69,407.83Zm-4.27,6.59,5.83-3.37c.11-.06.12-.16,0-.22l-6.08-3.5a.42.42,0,0,0-.38,0l-3,1.74c-.12.07-.13.16,0,.22l3.22,1.86c.1.06.09.15,0,.22l-2.42,1.39c-.11.06-.12.16,0,.22l2.5,1.44A.4.4,0,0,0,129.42,414.42ZM112,412.94l-2.62,1.51c-.11.06-.12.16,0,.22l2.5,1.44a.42.42,0,0,0,.38,0l2.61-1.51c.12-.06.13-.16,0-.22l-2.5-1.44A.42.42,0,0,0,112,412.94Zm-3.82,2.21-2.62,1.51c-.11.06-.12.16,0,.22l2.5,1.44a.42.42,0,0,0,.38,0L111,416.8c.12-.07.12-.17,0-.22l-2.5-1.45A.43.43,0,0,0,108.16,415.15ZM87,438.7a.42.42,0,0,0,.38,0L90,437.18c.11-.07.12-.17,0-.22l-2.5-1.45a.43.43,0,0,0-.38,0L84.53,437c-.11.06-.12.16,0,.22Zm-9.42-5.91L75,434.3c-.11.07-.12.17,0,.22l2.5,1.45a.43.43,0,0,0,.38,0l2.62-1.51c.11-.06.12-.16,0-.21L78,432.78A.42.42,0,0,0,77.59,432.79Zm4.84,4.43a.43.43,0,0,0,.38,0l2.62-1.51c.11-.06.12-.16,0-.21L83,434a.42.42,0,0,0-.38,0L80,435.55c-.12.07-.13.17,0,.22ZM93,439.59l2.61-1.51c.11-.07.12-.16,0-.22l-2.5-1.44a.4.4,0,0,0-.38,0l-2.61,1.51c-.11.06-.12.16,0,.22l2.5,1.44A.42.42,0,0,0,93,439.59Zm-4.2,2.22a.43.43,0,0,0,.38,0l2.61-1.51c.11-.06.12-.16,0-.21l-2.5-1.45a.42.42,0,0,0-.38,0l-2.61,1.51c-.11.07-.12.17,0,.22Zm-7.37-11.22L78.8,432.1c-.12.06-.13.16,0,.22l2.5,1.44a.42.42,0,0,0,.38,0l2.62-1.51c.11-.07.12-.16,0-.22l-2.5-1.44A.4.4,0,0,0,81.41,430.59Zm19.1-11-2.61,1.51c-.11.06-.12.16,0,.22l2.5,1.44a.42.42,0,0,0,.38,0l2.61-1.51c.11-.06.12-.16,0-.22l-2.5-1.44A.4.4,0,0,0,100.51,419.56Zm-15.28,8.82-2.61,1.51c-.11.07-.12.16,0,.22l2.51,1.45a.41.41,0,0,0,.37,0L88.09,430c.11-.06.12-.16,0-.22l-2.5-1.44A.42.42,0,0,0,85.23,428.38Zm19.1-11-2.61,1.51c-.11.07-.12.16,0,.22l2.5,1.45a.43.43,0,0,0,.38,0l2.61-1.51c.11-.06.12-.16,0-.22l-2.51-1.44A.42.42,0,0,0,104.33,417.35Zm-7.64,4.41-2.61,1.51c-.11.07-.12.17,0,.22l2.5,1.45a.43.43,0,0,0,.38,0l2.61-1.51c.11-.06.12-.16,0-.21l-2.5-1.45A.42.42,0,0,0,96.69,421.76ZM92.87,424l-2.61,1.51c-.11.06-.12.16,0,.22l2.5,1.44a.42.42,0,0,0,.38,0l2.61-1.51c.11-.06.12-.16,0-.22L93.25,424A.42.42,0,0,0,92.87,424Zm-3.82,2.21-2.61,1.51c-.11.06-.12.16,0,.22l2.51,1.44a.42.42,0,0,0,.38,0l2.61-1.51c.11-.07.12-.17,0-.22l-2.5-1.45A.43.43,0,0,0,89.05,426.18Zm17.45,1.48,2.61-1.51c.11-.07.12-.17,0-.22l-2.5-1.45a.43.43,0,0,0-.38,0L103.64,426c-.11.06-.12.16,0,.22l2.5,1.44A.42.42,0,0,0,106.5,427.66Zm35.64-32.13-2.61,1.5c-.11.07-.12.17,0,.22L142,398.7a.4.4,0,0,0,.37,0l2.62-1.51c.11-.07.12-.17,0-.22l-2.5-1.45A.43.43,0,0,0,142.14,395.53Zm-4.62,2.67-2.62,1.51c-.11.06-.12.16,0,.21l2.5,1.45a.42.42,0,0,0,.38,0l2.61-1.51c.11-.07.12-.17,0-.22l-2.5-1.45A.43.43,0,0,0,137.52,398.2Zm8.44-4.88-2.61,1.51c-.11.06-.12.16,0,.22l2.51,1.44a.42.42,0,0,0,.38,0l2.61-1.51c.11-.06.12-.16,0-.22l-2.5-1.44A.42.42,0,0,0,146,393.32Zm-21.12,19.62,2.62-1.51c.11-.06.12-.16,0-.22l-2.5-1.44a.42.42,0,0,0-.38,0L122,411.29c-.11.06-.12.16,0,.22l2.5,1.44A.42.42,0,0,0,124.84,412.94Zm25.32-21.84a.42.42,0,0,0-.38,0l-2.61,1.51c-.11.07-.12.17,0,.22l2.5,1.45a.43.43,0,0,0,.38,0l2.61-1.51c.11-.06.12-.16,0-.22Zm-39.84,34.35,2.61-1.51c.11-.06.12-.16,0-.22l-2.5-1.44a.42.42,0,0,0-.38,0l-2.61,1.51c-.11.06-.12.16,0,.22l2.5,1.44A.42.42,0,0,0,110.32,425.45Zm46.85-27.05,2.62-1.51c.11-.06.12-.16,0-.22l-2.5-1.44a.42.42,0,0,0-.38,0l-2.62,1.51c-.11.06-.12.16,0,.22l2.5,1.44A.42.42,0,0,0,157.17,398.4Zm-7.39.14,2.61-1.51c.11-.06.12-.16,0-.22l-2.51-1.44a.42.42,0,0,0-.38,0l-2.61,1.51c-.11.07-.12.16,0,.22l2.5,1.45A.43.43,0,0,0,149.78,398.54Zm4-5.38a.43.43,0,0,0-.38,0l-2.62,1.51c-.11.06-.12.16,0,.21l2.5,1.45a.42.42,0,0,0,.38,0l2.61-1.51c.11-.07.12-.17,0-.22Zm.8-.46,6.07,3.51a.43.43,0,0,0,.38,0l2.62-1.51c.11-.06.12-.16,0-.22l-6.07-3.5a.42.42,0,0,0-.38,0l-2.62,1.51C154.45,392.54,154.44,392.64,154.54,392.7Zm-8.83,4.89-2.61,1.51c-.11.06-.12.16,0,.22l2.5,1.44a.42.42,0,0,0,.38,0l2.61-1.51c.11-.07.12-.16,0-.22l-2.5-1.44A.4.4,0,0,0,145.71,397.59ZM117,414.19l-2.62,1.51c-.11.06-.12.16,0,.22l2.5,1.44a.42.42,0,0,0,.38,0l2.62-1.51c.11-.06.12-.16,0-.22l-2.5-1.44A.42.42,0,0,0,117,414.19Zm36-13.57a.43.43,0,0,0,.38,0l2.62-1.5c.11-.07.12-.17,0-.22l-2.5-1.45a.43.43,0,0,0-.38,0l-2.62,1.5c-.11.07-.12.17,0,.22ZM120.78,412l-2.62,1.5c-.11.07-.12.17,0,.22l2.5,1.45a.43.43,0,0,0,.38,0l2.62-1.5c.11-.07.12-.17,0-.22l-2.5-1.45A.43.43,0,0,0,120.78,412Zm-29.95,24.5a.42.42,0,0,0,.38,0L93.83,435c.11-.06.12-.16,0-.22l-2.5-1.44a.42.42,0,0,0-.38,0l-2.62,1.51c-.11.06-.12.16,0,.22Zm-4.44-4.65-2.61,1.51c-.11.06-.12.16,0,.22l2.5,1.44a.42.42,0,0,0,.38,0l2.62-1.51c.11-.07.12-.16,0-.22l-2.5-1.44A.4.4,0,0,0,86.39,431.84ZM95,434.27l2.62-1.5c.11-.07.12-.17,0-.22l-2.5-1.45a.46.46,0,0,0-.38,0l-2.61,1.51c-.12.07-.13.17,0,.22l2.5,1.45A.43.43,0,0,0,95,434.27Zm3.82-2.2,2.62-1.51c.11-.06.12-.16,0-.22L99,428.9a.4.4,0,0,0-.38,0L96,430.42c-.11.06-.12.16,0,.22l2.51,1.44A.4.4,0,0,0,98.85,432.07Zm3.83-2.21,2.61-1.51c.11-.06.12-.16,0-.22l-2.5-1.44a.42.42,0,0,0-.38,0l-2.61,1.51c-.11.07-.12.16,0,.22l2.51,1.45A.43.43,0,0,0,102.68,429.86Zm-12.47-.23-2.61,1.51c-.11.07-.12.16,0,.22l2.51,1.45a.43.43,0,0,0,.38,0l2.61-1.51c.11-.06.12-.16,0-.22l-2.5-1.44A.42.42,0,0,0,90.21,429.63Zm3.82-2.2-2.61,1.51c-.11.06-.12.16,0,.22l2.5,1.44a.42.42,0,0,0,.38,0l2.61-1.51c.11-.07.12-.17,0-.22l-2.5-1.45A.43.43,0,0,0,94,427.43Zm15.29-8.83-2.62,1.51c-.11.07-.12.16,0,.22l2.5,1.45a.43.43,0,0,0,.38,0l2.61-1.51c.11-.06.12-.16,0-.22l-2.5-1.44A.42.42,0,0,0,109.32,418.6Zm-3.83,2.21-2.61,1.51c-.11.06-.12.16,0,.22l2.5,1.44a.42.42,0,0,0,.38,0l2.61-1.51c.11-.06.12-.16,0-.22l-2.51-1.44A.4.4,0,0,0,105.49,420.81Zm7.65-4.41-2.62,1.51c-.11.06-.12.16,0,.22l2.5,1.44a.42.42,0,0,0,.38,0l2.61-1.51c.12-.07.13-.16,0-.22l-2.5-1.45A.43.43,0,0,0,113.14,416.4Zm-15.29,8.82-2.61,1.51c-.11.06-.12.16,0,.22l2.5,1.44a.42.42,0,0,0,.38,0l2.61-1.51c.11-.06.12-.16,0-.22l-2.5-1.44A.42.42,0,0,0,97.85,425.22Zm3.82-2.21-2.61,1.51c-.11.07-.12.17,0,.22l2.5,1.45a.43.43,0,0,0,.38,0l2.61-1.5c.11-.07.12-.17,0-.22l-2.5-1.45A.42.42,0,0,0,101.67,423ZM96.8,437.38l2.61-1.51c.11-.06.12-.16,0-.22l-2.5-1.44a.42.42,0,0,0-.38,0l-2.61,1.51c-.11.07-.12.16,0,.22l2.5,1.45A.43.43,0,0,0,96.8,437.38Zm-20.15-.95L74.15,435a.42.42,0,0,0-.38,0l-2.62,1.51c-.11.06-.12.16,0,.22l2.5,1.44a.42.42,0,0,0,.38,0l2.62-1.51C76.74,436.59,76.75,436.49,76.65,436.43Zm5,1.25-2.5-1.44a.42.42,0,0,0-.38,0l-4,2.32c-.11.07-.12.16,0,.22l2.51,1.45a.43.43,0,0,0,.38,0l4-2.32C81.72,437.84,81.73,437.74,81.63,437.68Zm-8.71-4.1-2.5-1.44a.4.4,0,0,0-.38,0L66.82,434c-.11.06-.12.16,0,.22l2.5,1.44a.42.42,0,0,0,.38,0l3.21-1.86C73,433.73,73,433.64,72.92,433.58Zm2.46-1.42a.43.43,0,0,0,.38,0l2.62-1.51c.11-.06.12-.16,0-.22L75.9,429a.42.42,0,0,0-.38,0l-2.62,1.51c-.11.07-.12.16,0,.22Zm10.83,7-2.5-1.44a.42.42,0,0,0-.38,0l-5,2.91c-.11.06-.12.16,0,.21l2.5,1.45a.42.42,0,0,0,.38,0l5-2.91C86.3,439.32,86.31,439.22,86.21,439.16ZM88,442.27l-2.5-1.44a.42.42,0,0,0-.38,0l-3.22,1.86c-.11.06-.12.16,0,.22l2.5,1.44a.42.42,0,0,0,.38,0L88,442.49C88.06,442.43,88.07,442.33,88,442.27Zm15.82-26.52a.4.4,0,0,0,.38,0l2.61-1.51c.12-.06.13-.16,0-.22l-2.5-1.44a.42.42,0,0,0-.38,0l-2.62,1.51c-.11.06-.12.16,0,.22Zm-7.64,4.42a.43.43,0,0,0,.38,0l2.61-1.51c.11-.06.12-.16,0-.22L96.66,417a.42.42,0,0,0-.38,0l-2.61,1.51c-.11.07-.12.16,0,.22ZM79.2,430a.42.42,0,0,0,.38,0l2.62-1.51c.11-.07.12-.17,0-.22l-2.5-1.45a.43.43,0,0,0-.38,0l-2.62,1.51c-.11.06-.12.16,0,.22ZM100,418a.42.42,0,0,0,.38,0l2.61-1.51c.12-.07.13-.16,0-.22l-2.5-1.45a.43.43,0,0,0-.38,0l-2.62,1.51c-.11.06-.12.16,0,.22Zm-7.64,4.41a.42.42,0,0,0,.38,0l2.61-1.51c.11-.06.12-.16,0-.22l-2.5-1.44a.42.42,0,0,0-.38,0l-2.61,1.51c-.11.06-.12.16,0,.22Zm-2.48,20.06a.4.4,0,0,0-.38,0l-4,2.32c-.12.06-.13.16,0,.22l2.5,1.44a.4.4,0,0,0,.38,0l4-2.32c.11-.06.12-.16,0-.22Zm-3-16.89a.43.43,0,0,0,.38,0l2.61-1.5c.11-.07.12-.17,0-.22l-2.5-1.45a.46.46,0,0,0-.38,0l-2.61,1.51c-.11.07-.12.17,0,.22ZM83,427.74a.42.42,0,0,0,.38,0L86,426.22c.11-.06.12-.16,0-.22l-2.5-1.44a.42.42,0,0,0-.38,0l-2.61,1.51c-.12.06-.13.16,0,.22Zm77.61-26.18a.42.42,0,0,0-.38,0l-6.43,3.72c-.11.06-.12.16,0,.22l2.5,1.44a.42.42,0,0,0,.38,0l6.43-3.72c.11-.06.12-.16,0-.22Zm-8.44,4.87a.43.43,0,0,0-.38,0L149.19,408c-.11.06-.12.16,0,.22l2.5,1.44a.42.42,0,0,0,.38,0l2.62-1.51c.11-.07.12-.16,0-.22Zm-51.57,28.75,2.61-1.51c.11-.07.12-.17,0-.22l-2.5-1.45a.43.43,0,0,0-.38,0l-2.61,1.51c-.11.06-.12.16,0,.22l2.5,1.44A.42.42,0,0,0,100.62,435.18Zm43.93-24.33a.42.42,0,0,0-.38,0l-2.62,1.51c-.11.06-.12.16,0,.22L144,414a.42.42,0,0,0,.38,0l2.61-1.51c.11-.06.12-.16,0-.22Zm19.9-11.5a.46.46,0,0,0-.38,0l-2.61,1.51c-.11.07-.12.17,0,.22l2.5,1.45a.43.43,0,0,0,.38,0l2.61-1.5c.11-.07.12-.17,0-.22Zm6.33-.76-6.08-3.51a.43.43,0,0,0-.38,0l-2.61,1.51c-.11.06-.12.16,0,.21l6.07,3.51a.42.42,0,0,0,.38,0l2.61-1.51C170.86,398.75,170.87,398.65,170.78,398.59Zm-40.51,20.5a.42.42,0,0,0-.38,0L126.67,421c-.11.06-.12.16,0,.22l2.5,1.44a.42.42,0,0,0,.38,0l3.22-1.86c.11-.06.12-.16,0-.22Zm9.65-5.57a.42.42,0,0,0-.38,0l-4,2.32c-.11.07-.12.16,0,.22l2.5,1.44a.4.4,0,0,0,.38,0l4-2.32c.11-.06.12-.16,0-.22Zm-18.5,10.68a.42.42,0,0,0-.38,0L99.52,436.63c-.11.07-.12.17,0,.22l2.5,1.45a.43.43,0,0,0,.38,0l21.52-12.42c.11-.06.12-.16,0-.22ZM98.7,437.32a.42.42,0,0,0-.38,0l-3.22,1.86c-.11.06-.12.16,0,.22l2.5,1.44a.42.42,0,0,0,.38,0l3.21-1.86c.11-.06.13-.16,0-.22Zm27.14-15.68a.43.43,0,0,0-.38,0l-3.21,1.85c-.11.07-.13.17,0,.22l2.5,1.45a.43.43,0,0,0,.38,0l3.22-1.85c.11-.07.12-.17,0-.22ZM94.27,439.87a.42.42,0,0,0-.38,0l-3.22,1.86c-.11.07-.12.16,0,.22l2.5,1.45a.43.43,0,0,0,.38,0l3.22-1.86c.11-.06.12-.16,0-.21Zm40.42-23.33a.4.4,0,0,0-.38,0l-3.22,1.86c-.11.06-.12.16,0,.21l2.5,1.45a.42.42,0,0,0,.38,0l3.22-1.86c.11-.07.12-.16,0-.22Zm13.68-7.9a.42.42,0,0,0-.38,0l-2.62,1.51c-.11.07-.12.16,0,.22l2.5,1.45a.43.43,0,0,0,.38,0l2.61-1.51c.12-.06.13-.16,0-.22Zm8.55-6,2.62-1.51c.11-.07.12-.16,0-.22l-2.5-1.44a.4.4,0,0,0-.38,0L154.07,401c-.11.06-.13.16,0,.22l2.5,1.44A.42.42,0,0,0,156.92,402.67Zm-15.59.75,2.62-1.51c.11-.06.12-.16,0-.22l-2.5-1.44a.4.4,0,0,0-.38,0l-2.62,1.51c-.11.06-.12.16,0,.22l2.5,1.44A.42.42,0,0,0,141.33,403.42Zm-10.15,14.11,7.65-4.41c.11-.07.12-.17,0-.22l-2.5-1.45a.43.43,0,0,0-.38,0l-7.64,4.41c-.12.06-.13.16,0,.22l2.5,1.44A.42.42,0,0,0,131.18,417.53Zm21.54-12.64a.43.43,0,0,0,.38,0l2.62-1.51c.11-.06.12-.16,0-.21l-2.5-1.45a.42.42,0,0,0-.38,0l-2.61,1.51c-.12.07-.13.17,0,.22Zm-3.19-2.08,2.62-1.51c.11-.06.12-.16,0-.22l-2.5-1.44a.42.42,0,0,0-.38,0l-2.62,1.51c-.11.06-.12.16,0,.22l2.5,1.44A.42.42,0,0,0,149.53,402.81Zm-22.17,16.92,2.62-1.5c.11-.07.12-.17,0-.22l-2.5-1.45a.43.43,0,0,0-.38,0l-2.62,1.5c-.11.07-.12.17,0,.22l2.5,1.45A.43.43,0,0,0,127.36,419.73Zm16.92-10a.42.42,0,0,0,.38,0l2.61-1.51c.11-.06.12-.16,0-.22l-2.5-1.44a.42.42,0,0,0-.38,0l-2.61,1.51c-.11.06-.12.16,0,.22Zm-36,21,2.61-1.5c.11-.07.12-.17,0-.22l-2.51-1.45a.4.4,0,0,0-.37,0l-2.62,1.51c-.11.07-.12.17,0,.22l2.5,1.45A.43.43,0,0,0,108.26,430.76Zm3.82-2.2,2.61-1.51c.12-.07.13-.16,0-.22l-2.5-1.44a.4.4,0,0,0-.38,0l-2.62,1.51c-.11.06-.12.16,0,.22l2.5,1.44A.42.42,0,0,0,112.08,428.56ZM104.44,433l2.61-1.51c.11-.06.12-.16,0-.22l-2.51-1.44a.42.42,0,0,0-.38,0l-2.61,1.51c-.11.06-.12.16,0,.22l2.5,1.44A.42.42,0,0,0,104.44,433Zm15.28-8.82,2.62-1.51c.11-.07.12-.16,0-.22l-2.5-1.45a.43.43,0,0,0-.38,0l-2.62,1.51c-.11.06-.12.16,0,.22l2.5,1.44A.42.42,0,0,0,119.72,424.15Zm-3.82,2.2,2.62-1.51c.11-.06.12-.16,0-.22l-2.5-1.44a.42.42,0,0,0-.38,0L113,424.7c-.11.07-.12.16,0,.22l2.5,1.45A.43.43,0,0,0,115.9,426.35Zm7.64-4.41,2.62-1.51c.11-.06.12-.16,0-.22l-2.5-1.44a.42.42,0,0,0-.38,0l-2.62,1.51c-.11.06-.12.16,0,.22l2.5,1.44A.42.42,0,0,0,123.54,421.94Zm20.85-30.69a.42.42,0,0,0,.38,0l2.62-1.51c.11-.06.12-.16,0-.22l-.67-.38a.42.42,0,0,0-.38,0l-2.61,1.51c-.11.06-.12.16,0,.22Zm-19,12a.43.43,0,0,0,.38,0l2.62-1.51c.11-.06.12-.16,0-.21l-2.5-1.45a.42.42,0,0,0-.38,0l-2.62,1.51c-.11.07-.12.17,0,.22Zm7.64-4.42a.4.4,0,0,0,.38,0l2.62-1.51c.11-.06.12-.16,0-.22l-2.5-1.44a.42.42,0,0,0-.38,0l-2.62,1.51c-.11.07-.12.16,0,.22ZM120.74,406a.42.42,0,0,0,.38,0l2.61-1.51c.11-.07.12-.16,0-.22l-2.5-1.45a.43.43,0,0,0-.38,0l-2.61,1.51c-.11.06-.12.16,0,.22Zm8.48-4.9a.42.42,0,0,0,.38,0l2.62-1.51c.11-.07.12-.16,0-.22l-2.5-1.44a.4.4,0,0,0-.38,0l-2.62,1.51c-.11.06-.12.16,0,.22Zm-16.13,9.31a.42.42,0,0,0,.38,0l2.62-1.51c.11-.06.12-.16,0-.22l-2.5-1.44a.42.42,0,0,0-.38,0l-2.61,1.51c-.11.06-.12.16,0,.22Zm3.83-2.2a.43.43,0,0,0,.38,0l2.61-1.51c.11-.06.12-.16,0-.22l-2.5-1.44a.42.42,0,0,0-.38,0l-2.61,1.51c-.11.07-.12.17,0,.22Zm19.83-12.52a.4.4,0,0,0,.38,0l2.62-1.51c.11-.06.12-.16,0-.22l-.67-.38a.42.42,0,0,0-.38,0l-2.61,1.51c-.11.07-.12.16,0,.22Zm11.46-6.61a.43.43,0,0,0,.38,0l2.62-1.51c.11-.06.12-.16,0-.21l-.67-.39a.42.42,0,0,0-.38,0l-2.61,1.51c-.11.07-.12.17,0,.22Zm5.26,3a.42.42,0,0,0,.38,0l2.61-1.51c.11-.07.12-.16,0-.22l-2.5-1.45a.43.43,0,0,0-.38,0L151,390.42c-.11.06-.12.16,0,.22Zm7.28,8.38,2.61-1.51c.11-.06.12-.16,0-.22l-2.5-1.44a.42.42,0,0,0-.38,0l-2.61,1.51c-.11.07-.12.16,0,.22l2.51,1.44A.4.4,0,0,0,160.75,400.46Zm-20.18-7a.42.42,0,0,0,.38,0l2.62-1.51c.11-.07.12-.17,0-.22l-.67-.39a.43.43,0,0,0-.38,0l-2.61,1.51c-.11.06-.12.16,0,.21Zm-31.3,19.13a.42.42,0,0,0,.38,0l2.62-1.51c.11-.07.12-.17,0-.22l-2.5-1.45a.43.43,0,0,0-.38,0l-2.61,1.51c-.12.06-.13.16,0,.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tuch-pad--inject-73"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "120.22 434.33 120.79 434.66 135.88 443.37 162.73 427.87 163.29 427.55 147.63 418.51 120.22 434.33",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.39 428.07 147.63 419.55 121.13 434.86 135.88 443.37 162.39 428.07",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.22,429c-1-.55-1.24-1.45-1.24-3V351.7a5.48,5.48,0,0,1,2.49-4.31l90.86-52.46c1.37-.79,2.37-1.22,3.53-.29s1.16,1.43,1.16,3V371.9a5.51,5.51,0,0,1-2.49,4.31L48.67,428.66C47.3,429.46,46.53,429.68,45.22,429Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,297.65c0-1.58-1.11-2.22-2.49-1.44L48.66,348.67a5.1,5.1,0,0,0-1.76,1.86l-2.2-1.28h0a4.94,4.94,0,0,1,1.76-1.86l90.85-52.46c1.38-.79,2.38-1.23,3.54-.29S142,296.07,142,297.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.49,428.77a2.91,2.91,0,0,1-3.27.21c-.95-.47-1.24-1.45-1.24-3V351.69a5,5,0,0,1,.73-2.44l2.2,1.28h0a5.21,5.21,0,0,0-.73,2.45v74.25C46.18,428.7,47.31,429.46,48.49,428.77Z",
    style: {
      fill: "#263238"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M50,351.54l87.44-50.46c.82-.48,1.49-.09,1.49.86V371.2a3.29,3.29,0,0,1-1.49,2.58L50,424.25c-.82.48-1.49.09-1.49-.86V354.13A3.33,3.33,0,0,1,50,351.54Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50,351.54a3.33,3.33,0,0,0-1.49,2.59v68.11L135,372.35a3.33,3.33,0,0,0,1.49-2.59V301.65Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Spreadsheets--inject-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.68,315.61l-3.58-2.08L55.32,364v56.77a2.67,2.67,0,0,0,1.12,2.46h0l2.27,1.31h0a2.67,2.67,0,0,0,2.7-.26L139.87,379a8.46,8.46,0,0,0,3.81-6.61Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.32,374.18v46.59a2.67,2.67,0,0,0,1.12,2.46h0l2.27,1.31a1.94,1.94,0,0,0,1,.25l-2.1-2.71V375.45Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.71,424.37a3,3,0,0,0,1.48-.46l78.46-45.3a8,8,0,0,0,3.59-6.23v-56L58,365.57v56.52C58,423.51,58.66,424.37,59.71,424.37Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.8,317.14v55.24a7.57,7.57,0,0,1-3.38,5.84L61,423.52a2.55,2.55,0,0,1-1.26.41c-1.11,0-1.23-1.29-1.23-1.84V365.82l84.32-48.68m.88-1.53L57.6,365.31v56.78c0,1.72.86,2.72,2.11,2.72a3.48,3.48,0,0,0,1.7-.52L139.87,379a8.46,8.46,0,0,0,3.81-6.61V315.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.32,308.43a2.63,2.63,0,0,0-2.73.24L59.14,354a8.43,8.43,0,0,0-3.82,6.61V364l2.28,1.31,86.08-49.7v-3.42a2.67,2.67,0,0,0-1.11-2.46C141.93,309.36,140.94,308.81,140.32,308.43Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6,361.89a8.43,8.43,0,0,1,3.81-6.6L139.86,310c2.11-1.22,3.82-.23,3.82,2.2v3.42L57.6,365.31Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6,361.89a8.43,8.43,0,0,1,3.81-6.6L139.86,310c2.11-1.22,3.82-.23,3.82,2.2v3.42L57.6,365.31Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.61,309.75a2.64,2.64,0,0,0-2.75.24l-78.45,45.3a7.76,7.76,0,0,0-2.69,2.84l-2.28-1.31a7.74,7.74,0,0,1,2.7-2.85l78.45-45.3a2.63,2.63,0,0,1,2.73-.24c.62.38,1.61.93,2.26,1.3Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.61,309.75a2.64,2.64,0,0,0-2.75.24l-78.45,45.3a7.76,7.76,0,0,0-2.69,2.84l-2.28-1.31a7.74,7.74,0,0,1,2.7-2.85l78.45-45.3a2.63,2.63,0,0,1,2.73-.24c.62.38,1.61.93,2.26,1.3Z",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.36,318.12a2.91,2.91,0,0,0-1.33,2.3c0,.85.59,1.2,1.33.77a2.93,2.93,0,0,0,1.33-2.31C131.69,318,131.1,317.69,130.36,318.12Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,315.43a2.94,2.94,0,0,0-1.33,2.31c0,.85.59,1.19,1.33.77a2.94,2.94,0,0,0,1.33-2.31C136.35,315.35,135.76,315,135,315.43Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.68,312.75a2.94,2.94,0,0,0-1.33,2.3c0,.85.6,1.2,1.33.77a2.91,2.91,0,0,0,1.33-2.3C141,312.67,140.42,312.32,139.68,312.75Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.6 365.32 57.6 375.45 143.68 325.77 143.68 315.61 57.6 365.32",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.05 365.85 69.87 360.78 69.87 365.83 61.05 370.93 61.05 365.85",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.05 359.5 72.05 361.5 76.45 358.96 76.45 356.96 72.05 359.5",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.05 362.58 72.05 364.58 76.45 362.04 76.45 360.04 72.05 362.58",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.65 355.69 78.65 357.69 83.05 355.15 83.05 353.15 78.65 355.69",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.65 358.77 78.65 360.77 83.05 358.23 83.05 356.23 78.65 358.77",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.24 351.88 85.25 353.88 89.64 351.34 89.64 349.34 85.24 351.88",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.24 354.96 85.25 356.96 89.64 354.42 89.64 352.42 85.24 354.96",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.03 340.45 105.03 342.45 109.43 339.91 109.43 337.92 105.03 340.45",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.03 343.54 105.03 345.54 109.43 343 109.43 341 105.03 343.54",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.63 336.64 111.63 338.64 116.03 336.1 116.03 334.11 111.63 336.64",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.63 339.73 111.63 341.73 116.03 339.19 116.03 337.19 111.63 339.73",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.23 332.83 118.23 334.83 122.63 332.29 122.63 330.3 118.23 332.83",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.23 335.92 118.23 337.92 122.63 335.38 122.63 333.38 118.23 335.92",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.84 348.07 102.84 341.72 102.84 346.8 91.84 353.15 91.84 348.07",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.83 329.03 133.65 323.96 133.65 329.01 124.83 334.11 124.83 329.03",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.82 322.68 135.82 324.68 140.22 322.14 140.22 320.14 135.82 322.68",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.82 325.76 135.82 327.76 140.22 325.22 140.22 323.22 135.82 325.76",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.6 365.32 55.32 364.02 55.32 374.18 57.6 375.45 57.6 365.32",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--spreadsheets--inject-73"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "70.95 374.85 80.81 369.16 80.81 373.71 70.95 379.41 70.95 374.85",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70.95 411.31 80.81 405.62 80.81 410.17 70.95 415.87 70.95 411.31",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.16 377.13 140.02 371.43 140.02 375.98 130.16 381.68 130.16 377.13",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.16 377.13 140.02 371.43 140.02 375.98 130.16 381.68 130.16 377.13",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.81 396.5 90.67 390.81 90.67 395.36 80.81 401.06 80.81 396.5",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.81 396.5 90.67 390.81 90.67 395.36 80.81 401.06 80.81 396.5",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.56 362.31 110.42 356.62 110.42 361.17 100.56 366.87 100.56 362.31",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.56 362.31 110.42 356.62 110.42 361.17 100.56 366.87 100.56 362.31",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,375.78l-.12.07V422l.48-.27,19.74-11.4,9.39-5.42.49-.28,9.37-5.41.5-.29,9.38-5.41.49-.29,9.37-5.41.49-.28,9.39-5.43.49-.27,9.38-5.43.48-.26V330Zm9.75,40-9.39,5.41v-4l9.39-5.41Zm0-4.56-9.39,5.41v-4l9.39-5.41Zm0-4.57-9.39,5.43v-4l9.39-5.41Zm0-4.55-9.39,5.42v-4l9.39-5.41Zm0-4.56-9.39,5.42v-4l9.39-5.42Zm0-4.56-9.39,5.42v-4L70.71,389Zm0-4.56-9.39,5.42v-4l9.39-5.41Zm0-4.56-9.39,5.41v-4l9.39-5.42Zm0-4.56-9.39,5.41v-4l9.39-5.42Zm0-4.56-9.39,5.41v-4l9.39-5.43Zm9.88,35.34-9.39,5.42v-4l9.39-5.41Zm0-4.55-9.39,5.41v-4l9.39-5.42Zm0-4.57-9.39,5.42v-4l9.39-5.42Zm0-4.56-9.39,5.42v-4l9.39-5.41Zm0-4.56-9.39,5.42v-4l9.39-5.41Zm0-4.56-9.39,5.43v-4l9.39-5.41Zm0-4.56L71.2,388.1v-4l9.39-5.42Zm0-4.56-9.39,5.42v-4l9.39-5.43Zm0-4.56L71.2,379v-4l9.39-5.42Zm0-4.55-9.39,5.41v-4L80.59,365Zm9.86,35.34-9.39,5.41v-4l9.39-5.42Zm0-4.57-9.39,5.42v-4l9.39-5.41Zm0-4.56-9.39,5.42v-4l9.39-5.41Zm0-4.56-9.39,5.43v-4l9.39-5.41Zm0-4.56-9.39,5.41v-4l9.39-5.42Zm0-4.56L81.06,387v-4l9.39-5.43Zm0-4.56-9.39,5.42v-4L90.45,373Zm0-4.55-9.39,5.41v-4l9.39-5.43Zm0-4.56-9.39,5.41v-4l9.39-5.43Zm0-4.56-9.39,5.41v-4l9.39-5.41Zm9.86,35.33-9.37,5.42v-4l9.37-5.41Zm0-4.56-9.37,5.42v-4l9.37-5.41Zm0-4.56L90.94,395v-4l9.37-5.41Zm0-4.56-9.37,5.43v-4l9.37-5.42Zm0-4.56-9.37,5.42v-4l9.37-5.42Zm0-4.55-9.37,5.41v-4l9.37-5.43Zm0-4.56-9.37,5.41v-4l9.37-5.43Zm0-4.56-9.37,5.41v-4l9.37-5.41Zm0-4.56-9.37,5.41v-4l9.37-5.41Zm0-4.56L90.94,363v-4l9.37-5.41ZM110.19,393l-9.38,5.42v-4l9.38-5.42Zm0-4.56-9.38,5.43v-4l9.38-5.41Zm0-4.56-9.38,5.43v-4l9.38-5.43Zm0-4.55-9.38,5.41v-4l9.38-5.43Zm0-4.57-9.38,5.42v-4l9.38-5.43Zm0-4.55-9.38,5.41v-4l9.38-5.42Zm0-4.56L100.81,371v-4l9.38-5.41Zm0-4.56-9.38,5.41v-4l9.38-5.41Zm0-4.56-9.38,5.41v-4l9.38-5.42Zm0-4.57-9.38,5.43v-4l9.38-5.42Zm9.86,35.35-9.37,5.42v-4l9.37-5.42Zm0-4.56-9.37,5.41v-4l9.37-5.43Zm0-4.56-9.37,5.41v-4l9.37-5.42Zm0-4.56L110.68,379v-4l9.37-5.42Zm0-4.56-9.37,5.42v-4l9.37-5.42Zm0-4.56-9.37,5.41v-4l9.37-5.41Zm0-4.56-9.37,5.42v-4l9.37-5.42Zm0-4.56-9.37,5.42v-4l9.37-5.41Zm0-4.57-9.37,5.43v-4l9.37-5.42Zm0-4.55-9.37,5.42v-4l9.37-5.41Zm9.88,35.34L120.54,387v-4l9.39-5.42Zm0-4.56-9.39,5.41v-4l9.39-5.42Zm0-4.56-9.39,5.41v-4l9.39-5.42Zm0-4.56-9.39,5.41v-4l9.39-5.42Zm0-4.56-9.39,5.42v-4l9.39-5.41Zm0-4.56-9.39,5.42v-4l9.39-5.41Zm0-4.55-9.39,5.41v-4l9.39-5.42Zm0-4.58-9.39,5.43v-4l9.39-5.42Zm0-4.55-9.39,5.42v-4l9.39-5.41Zm0-4.56-9.39,5.42v-4l9.39-5.41Zm9.87,35.34-9.38,5.41v-4l9.38-5.42Zm0-4.56-9.38,5.41v-4l9.38-5.42Zm0-4.56-9.38,5.42v-4l9.38-5.41Zm0-4.56-9.38,5.42v-4l9.38-5.41Zm0-4.55L130.42,363v-4l9.38-5.42Zm0-4.58-9.38,5.43v-4l9.38-5.42Zm0-4.55-9.38,5.42v-4l9.38-5.41Zm0-4.56-9.38,5.42v-4l9.38-5.42Zm0-4.56-9.38,5.42v-4l9.38-5.41Zm0-4.56-9.38,5.41v-4l9.38-5.43Z",
    style: {
      fill: "#e0e0e0"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Calculator--inject-73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--calculator--inject-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301.14,425.7a2.32,2.32,0,0,0-1.36,1.89c0,.69,0,6.49,0,7.19a2.34,2.34,0,0,0,1.37,1.88l50.1,28.93a7.31,7.31,0,0,0,6.6,0L447.24,414a2.31,2.31,0,0,0,1.37-1.9c0-.69,0-6.45,0-7.13a2.28,2.28,0,0,0-1.36-1.93l-50.11-28.93a7.29,7.29,0,0,0-6.59,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.26,406.81l-89.42,51.62a7.23,7.23,0,0,1-6.59,0l-50.11-28.92c-1.82-1.06-1.82-2.76,0-3.81l89.42-51.63a7.29,7.29,0,0,1,6.59,0L447.26,403C449.08,404.05,449.08,405.76,447.26,406.81Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.81,420.47a.37.37,0,0,0,.23.34l7.36,4.25a2.25,2.25,0,0,0,1.94-.23l6.24-3.61c.41-.24.64-.53.64-.77s0-1.54,0-1.78a.41.41,0,0,0-.23-.35l-7.36-4.25a2.25,2.25,0,0,0-1.94.24l-6.25,3.6c-.41.24-.64.54-.63.78Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.21,418.65s0,0,0,0c0,.24,0,1.64,0,1.78s-.23.53-.64.77l-6.24,3.61a3,3,0,0,1-1.11.35V423.4a3,3,0,0,0,1.11-.36l6.23-3.6C415,419.19,415.22,418.89,415.21,418.65Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.81,418.7a.39.39,0,0,0,.22.33l7.37,4.25a1.42,1.42,0,0,0,.83.12v1.78a1.42,1.42,0,0,1-.83-.12L399,420.81a.38.38,0,0,1-.23-.34Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.63,414.07l7.36,4.25c.42.24.24.74-.41,1.12l-6.24,3.6a2.25,2.25,0,0,1-1.94.24L399,419c-.42-.24-.23-.74.41-1.12l6.25-3.6A2.25,2.25,0,0,1,407.63,414.07Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.66,412.88a.43.43,0,0,0,.23.35l7.36,4.24a2.24,2.24,0,0,0,1.94-.23l6.24-3.61c.42-.24.64-.53.64-.77v-1.78a.39.39,0,0,0-.23-.35l-7.36-4.25a2.25,2.25,0,0,0-1.94.24l-6.24,3.6c-.42.24-.64.54-.64.78S385.66,412.64,385.66,412.88Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.07,411.06v1.8c0,.24-.22.53-.63.77l-6.25,3.61a2.82,2.82,0,0,1-1.11.35v-1.78a2.84,2.84,0,0,0,1.11-.36l6.24-3.6C401.86,411.6,402.08,411.3,402.07,411.06Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.66,411.11a.4.4,0,0,0,.23.33l7.36,4.25a1.42,1.42,0,0,0,.83.12v1.78a1.4,1.4,0,0,1-.82-.12l-7.37-4.24a.43.43,0,0,1-.23-.35C385.66,412.64,385.67,411.29,385.66,411.11Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.48,406.48l7.36,4.25c.43.24.24.74-.41,1.12l-6.24,3.6a2.25,2.25,0,0,1-1.94.24l-7.36-4.25c-.42-.24-.24-.74.41-1.12l6.24-3.6A2.25,2.25,0,0,1,394.48,406.48Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.52,405.29a.41.41,0,0,0,.23.35l7.36,4.25a2.29,2.29,0,0,0,1.94-.24l6.24-3.61c.41-.24.64-.52.64-.77v-1.78a.39.39,0,0,0-.23-.35l-7.36-4.25a2.25,2.25,0,0,0-1.94.24l-6.24,3.6c-.42.25-.65.54-.64.78Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.93,403.47v1.81c0,.23-.22.53-.64.76l-6.24,3.61a2.67,2.67,0,0,1-1.11.35v-1.78a2.84,2.84,0,0,0,1.11-.36l6.24-3.6C388.71,404,388.94,403.72,388.93,403.47Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.52,403.52a.39.39,0,0,0,.23.33l7.36,4.25a1.35,1.35,0,0,0,.83.12V410a1.42,1.42,0,0,1-.83-.12l-7.36-4.24a.41.41,0,0,1-.23-.35Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.34,398.89l7.36,4.25c.42.24.24.74-.41,1.12l-6.24,3.6a2.25,2.25,0,0,1-1.94.24l-7.36-4.25c-.43-.24-.24-.74.41-1.12l6.24-3.6A2.25,2.25,0,0,1,381.34,398.89Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.88,435.68a.4.4,0,0,0,.22.35l7.37,4.25a2.29,2.29,0,0,0,1.94-.24l6.24-3.61c.41-.23.64-.52.64-.76s0-1.55,0-1.79a.4.4,0,0,0-.22-.35l-7.37-4.25a2.29,2.29,0,0,0-1.94.24l-6.24,3.6c-.42.25-.64.54-.63.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.88,433.91a.4.4,0,0,0,.22.34l7.36,4.24a1.38,1.38,0,0,0,.84.12v1.78a1.43,1.43,0,0,1-.83-.11L320.11,436a.39.39,0,0,1-.23-.34C319.87,435.44,319.88,434.09,319.88,433.91Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.28,433.86s0,0,0,0c0,.24,0,1.65,0,1.79s-.23.53-.64.77l-6.24,3.6a2.72,2.72,0,0,1-1.11.35v-1.78a3.12,3.12,0,0,0,1.11-.35l6.23-3.61C336.07,434.4,336.29,434.11,336.28,433.86Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.5,420.48a.42.42,0,0,0,.23.34l7.36,4.25a2.22,2.22,0,0,0,1.94-.24l6.24-3.6c.42-.24.64-.53.64-.77v-1.78a.38.38,0,0,0-.23-.35l-7.36-4.25a2.22,2.22,0,0,0-1.94.24l-6.24,3.6c-.42.24-.64.54-.64.78S372.5,420.24,372.5,420.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.5,418.71a.4.4,0,0,0,.23.33l7.36,4.25a1.35,1.35,0,0,0,.83.11v1.79a1.4,1.4,0,0,1-.82-.12l-7.37-4.25a.43.43,0,0,1-.23-.34Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.91,418.65v1.81c0,.24-.22.53-.63.77l-6.25,3.6a2.84,2.84,0,0,1-1.11.36V423.4a2.67,2.67,0,0,0,1.11-.35l6.24-3.6C388.69,419.2,388.92,418.9,388.91,418.65Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.22,405.3a.4.4,0,0,0,.22.35l7.37,4.24a2.22,2.22,0,0,0,1.93-.23l6.25-3.61c.41-.24.63-.53.63-.77V403.5a.39.39,0,0,0-.23-.35L355,398.9a2.25,2.25,0,0,0-1.94.24l-6.24,3.6c-.42.24-.64.54-.64.78S346.21,405.06,346.22,405.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.21,403.53a.4.4,0,0,0,.23.33l7.36,4.25a1.42,1.42,0,0,0,.83.12V410a1.42,1.42,0,0,1-.83-.12l-7.37-4.25a.4.4,0,0,1-.23-.34C346.21,405.06,346.22,403.71,346.21,403.53Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.62,403.48v0c0,.24,0,1.64,0,1.78s-.23.53-.64.77l-6.24,3.61a2.93,2.93,0,0,1-1.11.35v-1.78a2.84,2.84,0,0,0,1.11-.36l6.24-3.6C362.41,404,362.63,403.73,362.62,403.48Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.36,412.89a.37.37,0,0,0,.23.34l7.36,4.25a2.25,2.25,0,0,0,1.94-.23l6.24-3.61c.41-.24.64-.53.64-.77s0-1.54,0-1.78a.41.41,0,0,0-.23-.35l-7.36-4.25a2.22,2.22,0,0,0-1.94.24l-6.24,3.6c-.42.24-.65.54-.64.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.36,411.12a.39.39,0,0,0,.22.33L367,415.7a1.42,1.42,0,0,0,.83.12v1.78a1.42,1.42,0,0,1-.83-.12l-7.36-4.25a.38.38,0,0,1-.23-.34Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.76,411.07s0,0,0,0v1.78c0,.24-.23.53-.64.77l-6.24,3.61a3,3,0,0,1-1.11.35v-1.78a2.84,2.84,0,0,0,1.11-.36l6.24-3.6C375.55,411.61,375.77,411.31,375.76,411.07Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.35,428.07a.39.39,0,0,0,.23.35l7.36,4.25a2.29,2.29,0,0,0,1.94-.24l6.24-3.61c.41-.23.64-.52.64-.76s0-1.55,0-1.79a.41.41,0,0,0-.23-.35l-7.36-4.25a2.29,2.29,0,0,0-1.94.24L360,425.52c-.41.24-.64.53-.63.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.35,426.3a.4.4,0,0,0,.22.34l7.37,4.24a1.35,1.35,0,0,0,.83.12v1.78a1.43,1.43,0,0,1-.83-.11l-7.36-4.25a.41.41,0,0,1-.23-.34Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.75,426.25v1.81c0,.24-.23.53-.64.77l-6.24,3.6a2.67,2.67,0,0,1-1.11.35V431a3.12,3.12,0,0,0,1.11-.35l6.23-3.61C375.54,426.79,375.76,426.5,375.75,426.25Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.06,412.9a.41.41,0,0,0,.23.34l7.36,4.25a2.25,2.25,0,0,0,1.94-.24l6.24-3.6c.41-.24.64-.53.64-.77v-1.79a.42.42,0,0,0-.23-.35l-7.36-4.25a2.29,2.29,0,0,0-1.94.24l-6.24,3.61c-.42.24-.65.53-.64.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.06,411.13a.4.4,0,0,0,.22.33l7.37,4.25a1.43,1.43,0,0,0,.83.11v1.79a1.51,1.51,0,0,1-.83-.12l-7.36-4.25a.41.41,0,0,1-.23-.34Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.46,411.07v1.81c0,.24-.23.53-.64.77l-6.24,3.6a2.84,2.84,0,0,1-1.11.36v-1.79a2.67,2.67,0,0,0,1.11-.35l6.24-3.61C349.25,411.62,349.48,411.32,349.46,411.07Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.21,420.48a.4.4,0,0,0,.22.35l7.37,4.25a2.23,2.23,0,0,0,1.93-.24l6.25-3.6c.41-.24.63-.53.63-.77v-1.79a.39.39,0,0,0-.23-.35L355,414.08a2.29,2.29,0,0,0-1.94.24l-6.24,3.61c-.42.24-.64.53-.64.78S346.2,420.24,346.21,420.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.2,418.72a.41.41,0,0,0,.23.33l7.36,4.24a1.35,1.35,0,0,0,.83.12v1.79a1.51,1.51,0,0,1-.83-.12l-7.37-4.25a.43.43,0,0,1-.23-.34C346.2,420.25,346.21,418.89,346.2,418.72Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.61,418.66v1.81c0,.24-.22.53-.63.77l-6.25,3.6a2.85,2.85,0,0,1-1.1.36v-1.79a2.82,2.82,0,0,0,1.11-.35l6.24-3.61C362.4,419.21,362.62,418.91,362.61,418.66Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.19,435.67a.41.41,0,0,0,.23.35l7.36,4.24a2.25,2.25,0,0,0,1.94-.23l6.24-3.61c.41-.24.64-.53.64-.77v-1.78a.41.41,0,0,0-.23-.35L355,429.27a2.25,2.25,0,0,0-1.94.24l-6.24,3.6c-.42.24-.65.54-.64.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.19,433.9a.39.39,0,0,0,.22.33l7.37,4.25a1.42,1.42,0,0,0,.83.12v1.78a1.42,1.42,0,0,1-.83-.12L346.42,436a.38.38,0,0,1-.23-.34Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.6,433.85v1.8c0,.24-.22.53-.64.77L355.72,440a2.82,2.82,0,0,1-1.11.35V438.6a2.84,2.84,0,0,0,1.11-.36l6.24-3.6C362.38,434.39,362.61,434.09,362.6,433.85Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.9,420.49a.41.41,0,0,0,.23.35l7.36,4.25a2.29,2.29,0,0,0,1.94-.24l6.24-3.61c.42-.23.64-.52.64-.77v-1.78a.39.39,0,0,0-.23-.35l-7.36-4.25a2.25,2.25,0,0,0-1.94.24l-6.24,3.6c-.42.25-.65.54-.64.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.9,418.72a.39.39,0,0,0,.23.33l7.36,4.25a1.35,1.35,0,0,0,.83.12v1.78a1.42,1.42,0,0,1-.83-.12l-7.36-4.24a.43.43,0,0,1-.23-.35Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.31,418.67v1.81c0,.24-.22.53-.64.76l-6.24,3.61a2.67,2.67,0,0,1-1.11.35v-1.78a2.84,2.84,0,0,0,1.11-.36l6.24-3.6C336.09,419.21,336.32,418.92,336.31,418.67Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.05,428.08a.4.4,0,0,0,.22.35l7.37,4.24a2.25,2.25,0,0,0,1.94-.23l6.24-3.61c.41-.24.63-.52.64-.77s0-1.54,0-1.78a.4.4,0,0,0-.22-.35l-7.37-4.25a2.25,2.25,0,0,0-1.94.24l-6.24,3.6c-.42.24-.64.54-.64.78S333.05,427.84,333.05,428.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333,426.31a.42.42,0,0,0,.23.33l7.36,4.25a1.46,1.46,0,0,0,.84.12v1.78a1.42,1.42,0,0,1-.83-.12l-7.36-4.24a.39.39,0,0,1-.23-.35C333,427.84,333.05,426.49,333,426.31Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.45,426.26v0c0,.24,0,1.65,0,1.79a1.1,1.1,0,0,1-.64.76l-6.24,3.61a2.76,2.76,0,0,1-1.11.35V431a3,3,0,0,0,1.11-.36l6.23-3.6C349.24,426.8,349.46,426.51,349.45,426.26Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.38,397.7a.4.4,0,0,0,.22.35L367,402.3a2.29,2.29,0,0,0,1.94-.24l6.24-3.61c.41-.23.63-.52.63-.76V395.9a.4.4,0,0,0-.22-.35l-7.37-4.25a2.25,2.25,0,0,0-1.94.24l-6.24,3.6c-.42.25-.64.54-.64.78S359.37,397.46,359.38,397.7Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.78,395.88v0c0,.24,0,1.65,0,1.79s-.23.53-.64.76l-6.24,3.61a2.76,2.76,0,0,1-1.11.35v-1.78a2.84,2.84,0,0,0,1.11-.36l6.24-3.6C375.57,396.42,375.79,396.13,375.78,395.88Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.37,395.93a.39.39,0,0,0,.23.33l7.36,4.25a1.35,1.35,0,0,0,.83.12v1.78a1.35,1.35,0,0,1-.83-.12l-7.37-4.24a.43.43,0,0,1-.23-.35C359.37,397.46,359.38,396.11,359.37,395.93Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.19,391.3l7.37,4.25c.42.24.23.75-.42,1.12l-6.24,3.6a2.22,2.22,0,0,1-1.94.24l-7.36-4.25c-.42-.24-.24-.74.41-1.12l6.24-3.6A2.25,2.25,0,0,1,368.19,391.3Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.65,428.07a.38.38,0,0,0,.23.34l7.36,4.25a2.25,2.25,0,0,0,1.94-.24l6.24-3.6c.41-.24.64-.53.64-.77s0-1.54,0-1.78a.37.37,0,0,0-.22-.35l-7.36-4.25a2.24,2.24,0,0,0-1.94.23l-6.25,3.61c-.41.24-.64.54-.63.78Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.05,426.24v0c0,.25,0,1.65,0,1.79s-.23.53-.64.77l-6.24,3.6a2.84,2.84,0,0,1-1.11.36V431a2.76,2.76,0,0,0,1.11-.35l6.23-3.61C401.84,426.79,402.06,426.49,402.05,426.24Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.65,426.3a.39.39,0,0,0,.22.33l7.37,4.25a1.43,1.43,0,0,0,.83.11v1.79a1.42,1.42,0,0,1-.83-.12l-7.36-4.25a.41.41,0,0,1-.23-.34Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.47,421.67l7.36,4.25c.42.24.24.74-.41,1.11l-6.24,3.61a2.29,2.29,0,0,1-1.94.24l-7.37-4.25c-.42-.24-.23-.75.41-1.12l6.25-3.61A2.24,2.24,0,0,1,394.47,421.67Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.49,435.67a.39.39,0,0,0,.23.34l7.36,4.25A2.25,2.25,0,0,0,382,440l6.24-3.6c.41-.24.64-.53.64-.77s0-1.54,0-1.79a.39.39,0,0,0-.22-.35l-7.36-4.25a2.28,2.28,0,0,0-1.94.24l-6.25,3.61c-.41.24-.64.53-.63.78Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.89,433.84v0c0,.24,0,1.65,0,1.79s-.23.53-.64.77L382,440a2.84,2.84,0,0,1-1.11.36v-1.79a2.76,2.76,0,0,0,1.11-.35l6.23-3.61C388.68,434.39,388.9,434.09,388.89,433.84Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.49,433.9a.4.4,0,0,0,.22.33l7.37,4.24a1.35,1.35,0,0,0,.83.12v1.79a1.42,1.42,0,0,1-.83-.12L372.72,436a.41.41,0,0,1-.23-.34Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.31,429.26l7.36,4.25c.42.25.24.75-.41,1.12L382,438.24a2.29,2.29,0,0,1-1.94.24l-7.37-4.25c-.42-.25-.23-.75.41-1.12l6.25-3.61A2.28,2.28,0,0,1,381.31,429.26Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.33,443.26a.39.39,0,0,0,.23.35l7.36,4.25a2.29,2.29,0,0,0,1.94-.24L375.1,444c.41-.23.64-.52.64-.76s0-1.55,0-1.79a.38.38,0,0,0-.22-.35l-7.36-4.25a2.28,2.28,0,0,0-1.94.24L360,440.7c-.41.25-.64.54-.63.79Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.73,441.44v0c0,.24,0,1.65,0,1.79s-.23.53-.64.77l-6.24,3.6a2.67,2.67,0,0,1-1.11.35v-1.78a3.12,3.12,0,0,0,1.11-.35l6.23-3.61C375.52,442,375.74,441.69,375.73,441.44Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.33,441.49a.4.4,0,0,0,.22.34l7.37,4.24a1.35,1.35,0,0,0,.83.12V448a1.43,1.43,0,0,1-.83-.11l-7.36-4.25a.41.41,0,0,1-.23-.34Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.15,436.86l7.36,4.25c.42.24.24.75-.41,1.12l-6.24,3.61a2.25,2.25,0,0,1-1.94.23l-7.37-4.25c-.42-.24-.23-.74.41-1.11l6.25-3.61A2.28,2.28,0,0,1,368.15,436.86Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.74,428.09a.4.4,0,0,0,.22.35l7.37,4.25a2.29,2.29,0,0,0,1.94-.24l6.24-3.6c.41-.24.63-.53.63-.77v-1.79a.4.4,0,0,0-.22-.35l-7.37-4.25a2.29,2.29,0,0,0-1.94.24l-6.24,3.61c-.42.24-.64.53-.64.78S306.73,427.85,306.74,428.09Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.14,426.27v0c0,.24,0,1.65,0,1.79s-.23.53-.64.77l-6.24,3.6a3,3,0,0,1-1.11.36V431a2.82,2.82,0,0,0,1.11-.35l6.24-3.61C322.93,426.82,323.15,426.52,323.14,426.27Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.73,426.33a.41.41,0,0,0,.23.33l7.36,4.24a1.35,1.35,0,0,0,.83.12v1.79a1.51,1.51,0,0,1-.83-.12L307,428.44a.4.4,0,0,1-.22-.34C306.73,427.86,306.74,426.5,306.73,426.33Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.55,421.69l7.37,4.25c.42.25.23.75-.42,1.12l-6.24,3.61a2.25,2.25,0,0,1-1.94.23L307,426.66c-.42-.25-.24-.75.41-1.12l6.24-3.61A2.29,2.29,0,0,1,315.55,421.69Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333,443.27a.43.43,0,0,0,.23.35l7.36,4.25a2.29,2.29,0,0,0,1.94-.24L348.8,444c.41-.23.63-.52.63-.76v-1.79a.39.39,0,0,0-.23-.35l-7.36-4.25a2.25,2.25,0,0,0-1.94.24l-6.24,3.6c-.42.25-.64.54-.64.78S333,443,333,443.27Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.43,441.45v1.81c0,.24-.22.53-.63.76l-6.25,3.61a2.67,2.67,0,0,1-1.11.35V446.2a2.84,2.84,0,0,0,1.11-.36l6.24-3.6C349.22,442,349.44,441.7,349.43,441.45Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333,441.5a.39.39,0,0,0,.23.33l7.36,4.25a1.35,1.35,0,0,0,.83.12V448a1.4,1.4,0,0,1-.82-.12l-7.37-4.24a.43.43,0,0,1-.23-.35C333,443,333,441.68,333,441.5Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.84,436.87l7.36,4.25c.43.24.24.74-.41,1.12l-6.24,3.6a2.22,2.22,0,0,1-1.94.24l-7.36-4.25c-.42-.24-.24-.74.41-1.12l6.24-3.6A2.25,2.25,0,0,1,341.84,436.87Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.17,450.86a.39.39,0,0,0,.23.35l7.36,4.25a2.29,2.29,0,0,0,1.94-.24l6.24-3.61c.41-.24.64-.52.64-.77s0-1.54,0-1.78a.38.38,0,0,0-.22-.35L355,444.46a2.25,2.25,0,0,0-1.94.24l-6.25,3.6c-.41.24-.64.54-.63.78Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.57,449s0,0,0,0c0,.24,0,1.65,0,1.79s-.23.53-.64.76l-6.24,3.61a2.67,2.67,0,0,1-1.11.35v-1.78a3,3,0,0,0,1.11-.36l6.23-3.6C362.36,449.58,362.58,449.29,362.57,449Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.17,449.09a.38.38,0,0,0,.22.33l7.37,4.25a1.42,1.42,0,0,0,.83.12v1.78a1.42,1.42,0,0,1-.83-.12l-7.36-4.24a.41.41,0,0,1-.23-.35Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355,444.46l7.36,4.25c.42.24.24.74-.41,1.12l-6.24,3.6a2.25,2.25,0,0,1-1.94.24l-7.37-4.25c-.42-.24-.23-.74.41-1.12l6.25-3.6A2.25,2.25,0,0,1,355,444.46Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.89,404.19l.08,0,3.8-1.13-1.28-.74a.05.05,0,0,1,0-.07.13.13,0,0,1,.07-.08l.61-.35a.23.23,0,0,1,.14,0,.18.18,0,0,1,.13,0l2,1.18s.05,0,0,.07a.13.13,0,0,1-.07.08l-.53.31a1.92,1.92,0,0,1-.36.13l-3.82,1.13-.14,0a.23.23,0,0,1-.12,0l-.6-.35s0,0,0-.07S351.85,404.21,351.89,404.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.17,409.94a2.46,2.46,0,0,1,1.27-.31,2.73,2.73,0,0,1,.64.07,2.1,2.1,0,0,1,.55.21,1.08,1.08,0,0,1,.37.32.62.62,0,0,1,.13.37.64.64,0,0,1-.14.38,1.11,1.11,0,0,1-.41.35,2.06,2.06,0,0,1-.48.21,2.28,2.28,0,0,1-.52.1.61.61,0,0,1-.15.34,1.3,1.3,0,0,1-.39.31,2,2,0,0,1-.6.24,3.07,3.07,0,0,1-.67.08,2.84,2.84,0,0,1-.66-.09,2.2,2.2,0,0,1-.59-.23,1.26,1.26,0,0,1-.4-.34.61.61,0,0,1-.15-.38.67.67,0,0,1,.13-.39,1.34,1.34,0,0,1,.41-.35,2.11,2.11,0,0,1,.54-.22,2.91,2.91,0,0,1,.58-.09,1.19,1.19,0,0,1,.18-.3A1.55,1.55,0,0,1,367.17,409.94Zm-.88,1.35c-.11.07-.16.14-.16.23s.09.18.25.27a.85.85,0,0,0,.47.14.63.63,0,0,0,.39-.09.26.26,0,0,0,.16-.22c0-.09-.09-.18-.25-.28a.94.94,0,0,0-.46-.14A.82.82,0,0,0,366.29,411.29Zm1.69-.9c-.11.07-.17.14-.17.23s.06.16.19.24a.87.87,0,0,0,.41.11.81.81,0,0,0,.39-.1.27.27,0,0,0,.17-.22c0-.09-.07-.17-.19-.24a.78.78,0,0,0-.42-.11A.79.79,0,0,0,368,410.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.07,417.62a2.66,2.66,0,0,1,.7-.29,3.76,3.76,0,0,1,.73-.1,3,3,0,0,1,.68.08,2.12,2.12,0,0,1,.57.21,1.17,1.17,0,0,1,.37.32.61.61,0,0,1,.12.4.69.69,0,0,1-.17.42,1.46,1.46,0,0,1-.49.4,1.66,1.66,0,0,1-.33.16,2.24,2.24,0,0,1-.34.11l-.33.08-.33.06-2.31.4h-.12a.19.19,0,0,1-.13,0l-.68-.4s0,0,0,0a.12.12,0,0,1,.07-.07l.05,0h0l1.58-.28a.9.9,0,0,1-.25-.31.59.59,0,0,1,0-.37.73.73,0,0,1,.19-.37A1.42,1.42,0,0,1,380.07,417.62Zm1.72,1a.51.51,0,0,0,.17-.15.22.22,0,0,0,0-.29.28.28,0,0,0-.14-.12.58.58,0,0,0-.21-.08,1,1,0,0,0-.25,0l-.26,0-.25.1a.63.63,0,0,0-.17.15.3.3,0,0,0-.05.15.23.23,0,0,0,0,.14.33.33,0,0,0,.14.12.66.66,0,0,0,.21.08,1,1,0,0,0,.25,0,.78.78,0,0,0,.26,0A1.06,1.06,0,0,0,381.79,418.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.48,412.38a.05.05,0,0,1,0-.07s0-.06.07-.08l.58-.34-1.34-.78a.05.05,0,0,1,0-.07.13.13,0,0,1,.07-.08l.61-.35a.73.73,0,0,1,.3-.11l3.43-.51h.16a.3.3,0,0,1,.11,0l.64.37s0,0,0,.07a.16.16,0,0,1-.08.09l-2.19,1.26.37.21a.07.07,0,0,1,0,.08s0,.06-.07.08l-.61.35a.29.29,0,0,1-.14,0,.16.16,0,0,1-.12,0l-.37-.21-.59.34-.14,0a.27.27,0,0,1-.13,0Zm1.56-1,1-.61-1.68.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.18,418.89a1,1,0,0,0,0,.1.43.43,0,0,0,0,.11.28.28,0,0,0,0,.12.43.43,0,0,0,.14.12l.2.08.24,0a1.15,1.15,0,0,0,.26,0,1.3,1.3,0,0,0,.25-.1c.13-.08.2-.16.21-.25a.3.3,0,0,0-.19-.25.59.59,0,0,0-.14-.06l-.15,0-.13,0-.09,0-.66-.38a.06.06,0,0,1,0-.08s0-.06.08-.08l2.16-1.1a.28.28,0,0,1,.15,0,.23.23,0,0,1,.12,0l1.84,1.06a.07.07,0,0,1,0,.08.17.17,0,0,1-.07.08l-.61.35a.33.33,0,0,1-.14,0,.18.18,0,0,1-.13,0l-1.24-.72-.54.28a.86.86,0,0,1,.27.05.82.82,0,0,1,.26.1,1.19,1.19,0,0,1,.37.32.55.55,0,0,1,.1.36.69.69,0,0,1-.18.39,1.7,1.7,0,0,1-.49.38,3.08,3.08,0,0,1-.7.3,3.47,3.47,0,0,1-.71.1,2.84,2.84,0,0,1-.66-.07,2.34,2.34,0,0,1-.58-.23,1.1,1.1,0,0,1-.42-.36.57.57,0,0,1-.12-.38.56.56,0,0,1,.14-.36,1.17,1.17,0,0,1,.37-.32.2.2,0,0,1,.11,0,.19.19,0,0,1,.11,0l.54.32c.05,0,.07.05.07.08S353.19,418.88,353.18,418.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.25,427.37a2.84,2.84,0,0,1-1.44.38,2.61,2.61,0,0,1-.69-.07,2,2,0,0,1-.58-.22,1,1,0,0,1-.39-.34.64.64,0,0,1,0-.82,1.66,1.66,0,0,1,.5-.41,2.81,2.81,0,0,1,.35-.17l.35-.11.34-.07.31-.06,2.29-.38h.12a.19.19,0,0,1,.13,0l.68.4s0,0,0,.05a.12.12,0,0,1-.07.07l-.05,0h0l-1.56.26a1.07,1.07,0,0,1,.28.33.67.67,0,0,1,0,.37.8.8,0,0,1-.19.38A1.81,1.81,0,0,1,368.25,427.37Zm-1.77-1a.71.71,0,0,0-.18.15.27.27,0,0,0-.05.16.24.24,0,0,0,.06.15.33.33,0,0,0,.14.12.66.66,0,0,0,.21.08,1.09,1.09,0,0,0,.26,0,.93.93,0,0,0,.27,0,.82.82,0,0,0,.26-.1.47.47,0,0,0,.18-.15.29.29,0,0,0,.06-.16.24.24,0,0,0-.06-.15.58.58,0,0,0-.14-.12,1,1,0,0,0-.21-.08,1.09,1.09,0,0,0-.26,0,.63.63,0,0,0-.27,0A.79.79,0,0,0,366.48,426.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,417.79a.15.15,0,0,1,.09-.08l.15,0,1.86,0h.17a.29.29,0,0,1,.16,0l.52.3s0,0,0,.07,0,.06-.07.08l-3.69,2.13a.34.34,0,0,1-.14,0l-.13,0-.56-.33a.08.08,0,0,1,0-.07.15.15,0,0,1,.08-.08l2.49-1.45h-1a.21.21,0,0,1-.12,0s0-.05,0-.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.12,426.58l-.35.17a2.11,2.11,0,0,1-.38.12l-.45.08-.54,0h-1.2l1.07.62s.05,0,0,.08a.17.17,0,0,1-.07.08l-.61.35a.33.33,0,0,1-.14,0,.24.24,0,0,1-.13,0l-2.26-1.31a.07.07,0,0,1,0-.07.13.13,0,0,1,.08-.08l.49-.29a1,1,0,0,1,.21-.08.69.69,0,0,1,.25,0l2.5,0a1.78,1.78,0,0,0,.46-.05,1,1,0,0,0,.28-.12l.1-.07a.31.31,0,0,0,.09-.11.2.2,0,0,0,0-.13.27.27,0,0,0-.14-.14.49.49,0,0,0-.25-.08h-.24l-.2.05-.13,0a.4.4,0,0,1-.18,0,.33.33,0,0,1-.13,0l-.52-.31s0,0,0-.05,0-.05.06-.07a2.53,2.53,0,0,1,.55-.23,2.34,2.34,0,0,1,.65-.12,2.66,2.66,0,0,1,.69,0,1.89,1.89,0,0,1,.64.23,1,1,0,0,1,.38.35.58.58,0,0,1,.07.38.91.91,0,0,1-.21.38A1.68,1.68,0,0,1,343.12,426.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.44,433.3a.08.08,0,0,1,0,.07.22.22,0,0,1-.08.09l-.6.34a.25.25,0,0,1-.15.05l-.14,0-1.21.1a.64.64,0,0,1,.16.54,1,1,0,0,1-.51.54,2.57,2.57,0,0,1-1.31.36,2.5,2.5,0,0,1-1.26-.35,1.4,1.4,0,0,1-.44-.37.64.64,0,0,1-.15-.38.66.66,0,0,1,.11-.35,1.21,1.21,0,0,1,.33-.3.2.2,0,0,1,.11,0,.18.18,0,0,1,.11,0l.54.31a.12.12,0,0,1,.08.11.53.53,0,0,0,0,.13.22.22,0,0,0,0,.15q0,.09.21.18a1.16,1.16,0,0,0,.43.15.82.82,0,0,0,.43-.09c.13-.08.18-.16.15-.25a.5.5,0,0,0-.25-.25l-.35-.2a.07.07,0,0,1,0-.08s0-.05.08-.08l.49-.28a.34.34,0,0,1,.14-.05l.15,0,1.07-.09-1.12-.65a.07.07,0,0,1,0-.07.15.15,0,0,1,.08-.08l.6-.35a.37.37,0,0,1,.15,0,.16.16,0,0,1,.12,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.15,432.71a1,1,0,0,1,.43.39.54.54,0,0,1,.05.41,1,1,0,0,1-.27.42,2.89,2.89,0,0,1-.5.39l-.51.3-.51.29a5.15,5.15,0,0,1-.68.29,3.08,3.08,0,0,1-.72.15,2.48,2.48,0,0,1-.72,0,2.15,2.15,0,0,1-.68-.25,1,1,0,0,1-.43-.39.56.56,0,0,1,0-.42,1,1,0,0,1,.26-.41,2.63,2.63,0,0,1,.51-.39c.15-.1.31-.2.49-.3l.52-.29a4.09,4.09,0,0,1,.68-.29,3.72,3.72,0,0,1,.72-.16,2.86,2.86,0,0,1,.72,0A1.86,1.86,0,0,1,330.15,432.71Zm-2.07,1.73c.33-.18.65-.37.95-.56a2.49,2.49,0,0,0,.24-.17.61.61,0,0,0,.13-.16.22.22,0,0,0,0-.16.4.4,0,0,0-.16-.16,1,1,0,0,0-.27-.09h-.27a1.57,1.57,0,0,0-.29.08,1.85,1.85,0,0,0-.29.13c-.33.18-.65.36-1,.56a2.5,2.5,0,0,0-.24.16.64.64,0,0,0-.13.17.22.22,0,0,0,0,.16.39.39,0,0,0,.16.15,1,1,0,0,0,.27.1,1.31,1.31,0,0,0,.28,0,1.47,1.47,0,0,0,.28-.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.78,395.43a.2.2,0,0,1,0-.08l.54-.78-1.89,1.09a.26.26,0,0,1-.15,0,.16.16,0,0,1-.12,0l-.56-.32s-.05,0,0-.07a.18.18,0,0,1,.07-.09l3.69-2.13.15,0a.22.22,0,0,1,.12,0l.5.29c.06,0,.08.07.07.11l0,.08-.89,1.32,2.28-.51.14,0a.42.42,0,0,1,.2,0l.49.29s.05,0,0,.07a.16.16,0,0,1-.08.09l-3.68,2.13-.15,0a.22.22,0,0,1-.12,0l-.57-.33a.05.05,0,0,1,0-.07.13.13,0,0,1,.07-.08l1.89-1.09-1.34.31-.15,0a.33.33,0,0,1-.15,0l-.28-.16A.08.08,0,0,1,364.78,395.43Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.27,396.33l-.21.11-.28.16-.27.16-.2.12a1.93,1.93,0,0,0-.21.17.47.47,0,0,0-.12.18.21.21,0,0,0,0,.17.47.47,0,0,0,.19.18,1.08,1.08,0,0,0,.28.11,1.27,1.27,0,0,0,.27,0l.24,0,.19-.06.18,0a.19.19,0,0,1,.14,0l.56.33a.06.06,0,0,1,0,.06.14.14,0,0,1-.07.06,2.52,2.52,0,0,1-.65.26,3,3,0,0,1-.73.09,2.89,2.89,0,0,1-.72-.07,2.12,2.12,0,0,1-.64-.24,1.07,1.07,0,0,1-.42-.39.6.6,0,0,1-.08-.43.83.83,0,0,1,.23-.43,2,2,0,0,1,.49-.41l.49-.29.53-.3a3.56,3.56,0,0,1,.69-.28,3.46,3.46,0,0,1,.76-.13,2.66,2.66,0,0,1,.75,0,2.31,2.31,0,0,1,.68.25,1.24,1.24,0,0,1,.41.37.63.63,0,0,1,.12.41.78.78,0,0,1-.16.42,1.39,1.39,0,0,1-.44.38l-.12,0-.1,0-.56-.32c-.05,0-.07-.06-.07-.08a.26.26,0,0,1,.09-.1,1.25,1.25,0,0,0,.09-.12.25.25,0,0,0,.06-.14.34.34,0,0,0,0-.15.58.58,0,0,0-.2-.16.73.73,0,0,0-.3-.11,1.06,1.06,0,0,0-.31,0l-.3.06Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378,403a.25.25,0,0,1,0-.09l.54-.78-1.9,1.09a.29.29,0,0,1-.14.05l-.13,0-.56-.33s0,0,0-.07a.13.13,0,0,1,.07-.08l3.69-2.13a.34.34,0,0,1,.14-.05l.13,0,.5.29c.06,0,.08.07.06.11a.46.46,0,0,1,0,.09l-.89,1.31,2.28-.51.14,0a.3.3,0,0,1,.19,0l.5.29a.08.08,0,0,1,0,.08s0,.05-.08.08l-3.69,2.13a.33.33,0,0,1-.14,0,.19.19,0,0,1-.13,0l-.56-.32a.07.07,0,0,1,0-.08s0-.06.07-.08l1.89-1.09-1.34.31-.16,0a.17.17,0,0,1-.14,0l-.28-.16S377.94,403.07,378,403Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.54,403.39a1.57,1.57,0,0,1,.43.34.61.61,0,0,1,.14.36.59.59,0,0,1-.17.37,1.76,1.76,0,0,1-.5.38,2.7,2.7,0,0,1-.84.34,2.23,2.23,0,0,1-.81,0L382,406.3a.1.1,0,0,1,0,0,.21.21,0,0,1-.11,0,.18.18,0,0,1-.11,0l-.58-.33c-.06,0-.08-.07-.07-.1a1,1,0,0,1,0-.1l.75-1-.39-.22-1.22.7a.26.26,0,0,1-.15,0,.16.16,0,0,1-.12,0l-.57-.32s0,0,0-.07a.18.18,0,0,1,.07-.09l3.69-2.13.15,0a.22.22,0,0,1,.12,0Zm-2.21.72.48.28a.89.89,0,0,0,.39.12.8.8,0,0,0,.45-.12c.16-.1.23-.18.21-.26a.35.35,0,0,0-.2-.23l-.49-.28Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.59,410.92a.19.19,0,0,1,0-.09l.54-.78-1.89,1.09a.34.34,0,0,1-.14.05.23.23,0,0,1-.13,0l-.56-.32a.08.08,0,0,1,0-.07.22.22,0,0,1,.08-.09l3.69-2.13.14,0a.25.25,0,0,1,.13,0l.49.29c.06,0,.08.07.07.11a.19.19,0,0,1,0,.08l-.88,1.32,2.27-.51.15,0a.31.31,0,0,1,.19,0l.5.29s0,0,0,.07,0,.06-.07.09l-3.69,2.13-.14,0a.24.24,0,0,1-.13,0l-.56-.33a.06.06,0,0,1,0-.07.13.13,0,0,1,.08-.08l1.89-1.09-1.35.31-.15,0a.33.33,0,0,1-.15,0l-.27-.16A.08.08,0,0,1,391.59,410.92Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.24,412.14a.09.09,0,0,1,0-.08.15.15,0,0,1,.08-.08l.57-.33a.38.38,0,0,1,.15,0l.13,0,1.34.78a.06.06,0,0,1,0,.08.13.13,0,0,1-.07.08l-.58.33a.34.34,0,0,1-.14.05.23.23,0,0,1-.13,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.41,418.31a.2.2,0,0,1,0-.08l.54-.78-1.9,1.09a.21.21,0,0,1-.14,0,.16.16,0,0,1-.12,0l-.57-.32s0,0,0-.07a.18.18,0,0,1,.07-.09L406,416a.33.33,0,0,1,.14,0,.24.24,0,0,1,.13,0l.5.29c.06,0,.08.07.06.11a.22.22,0,0,1,0,.08l-.89,1.32,2.28-.52.14,0a.38.38,0,0,1,.19,0l.5.29s.05,0,0,.07a.13.13,0,0,1-.08.08l-3.69,2.13a.34.34,0,0,1-.14.05.27.27,0,0,1-.13,0l-.56-.33s0,0,0-.07,0-.06.07-.08l1.89-1.09-1.34.31-.16,0a.32.32,0,0,1-.14,0l-.28-.16A.08.08,0,0,1,404.41,418.31Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.4,420.31l-.94.55a.33.33,0,0,1-.14,0,.24.24,0,0,1-.13,0l-.54-.31a.06.06,0,0,1,0-.08s0-.05.07-.08l.94-.54-.66-.39a.07.07,0,0,1,0-.07.15.15,0,0,1,.08-.08l.57-.33a.38.38,0,0,1,.15-.05l.12,0,.67.39.94-.55a.33.33,0,0,1,.14,0,.24.24,0,0,1,.13,0l.54.31a.09.09,0,0,1,0,.08s0,.05-.08.08l-.94.54.66.38a.07.07,0,0,1,0,.08s0,.05-.07.08l-.58.33a.23.23,0,0,1-.14,0,.18.18,0,0,1-.13,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.18,425.78a.06.06,0,0,1,0-.08.17.17,0,0,1,.07-.08l.58-.33a.23.23,0,0,1,.14,0,.17.17,0,0,1,.13,0l2.55,1.47s0,0,0,.07,0,.06-.07.08l-.58.34a.33.33,0,0,1-.14,0,.25.25,0,0,1-.13,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.92,425.58a1.14,1.14,0,0,1-1,.09c-.24-.14-.17-.4.14-.58a1.14,1.14,0,0,1,1-.08C396.29,425.15,396.23,425.4,395.92,425.58Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.66,427.46c.32-.18.38-.43.14-.57a1.12,1.12,0,0,0-1,.08c-.32.18-.38.44-.15.57A1.1,1.1,0,0,0,392.66,427.46Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.16,433.56l.19-.74a.18.18,0,0,1,.07-.09l.15,0,.89-.07a.16.16,0,0,1,.12,0s.05,0,0,.07l-.19.75,1.29-.11.12,0a.06.06,0,0,1,0,.08l-.13.51s0,.06-.07.08a.34.34,0,0,1-.14,0l-1.29.1-.18.74a.16.16,0,0,1-.08.09l-.14,0-.89.07a.19.19,0,0,1-.13,0s0,0,0-.07l.18-.74-1.29.1a.17.17,0,0,1-.13,0s0,0,0-.07l.12-.51s0-.06.08-.09a.33.33,0,0,1,.14,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.83,441a.07.07,0,0,1,0-.07.15.15,0,0,1,.08-.08l.57-.33a.38.38,0,0,1,.15-.05.22.22,0,0,1,.12,0l2.55,1.47a.07.07,0,0,1,0,.08.13.13,0,0,1-.08.08l-.57.33a.33.33,0,0,1-.15.05l-.12,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.88,424.53c.06,0,.08.07.07.11a.41.41,0,0,1-.07.11l-2.66,2.62-.07.06a.21.21,0,0,1-.12,0,.16.16,0,0,1-.1,0l-.54-.32c-.06,0-.08-.06-.07-.09a.09.09,0,0,1,.05-.08l.35-.35-1.14-.66-.59.21-.14,0a.26.26,0,0,1-.17-.05l-.54-.31a0,0,0,0,1,0-.06s0,0,.06-.06l.1,0,4.53-1.54.19,0a.38.38,0,0,1,.19,0Zm-3.19,1,.69.4,1-1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.47,426.63l-.22.11-.27.16-.27.16-.2.12a1.28,1.28,0,0,0-.22.17.36.36,0,0,0-.11.17.23.23,0,0,0,0,.18.46.46,0,0,0,.19.17,1,1,0,0,0,.29.12l.27,0a.85.85,0,0,0,.23,0l.2-.06.18-.05a.24.24,0,0,1,.13,0l.56.32s0,0,0,.06,0,0-.06.07a2.68,2.68,0,0,1-.65.26,3,3,0,0,1-.73.09,3.38,3.38,0,0,1-.72-.07,2.12,2.12,0,0,1-.64-.24A1.11,1.11,0,0,1,314,428a.66.66,0,0,1-.08-.43,1,1,0,0,1,.23-.44,2.31,2.31,0,0,1,.5-.4l.49-.3.52-.29a3.3,3.3,0,0,1,.7-.28,3.38,3.38,0,0,1,.76-.14,3.16,3.16,0,0,1,.75,0,2.16,2.16,0,0,1,.67.25,1.28,1.28,0,0,1,.42.36.84.84,0,0,1,.12.42.81.81,0,0,1-.16.42,1.44,1.44,0,0,1-.45.38.2.2,0,0,1-.11,0,.19.19,0,0,1-.11,0l-.56-.33c-.05,0-.07-.05-.06-.07a.48.48,0,0,1,.08-.11.52.52,0,0,0,.1-.11.35.35,0,0,0,.06-.14.23.23,0,0,0-.05-.15.54.54,0,0,0-.19-.17,1.21,1.21,0,0,0-.3-.11,1.58,1.58,0,0,0-.31,0l-.3.07Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.28,440.63s0,0,0-.07a.18.18,0,0,1,.07-.09l.58-.33a.33.33,0,0,1,.14,0,.17.17,0,0,1,.13,0l2.43,1.4a.07.07,0,0,1,0,.08.13.13,0,0,1-.08.08L343,442a.34.34,0,0,1-.14.05l-.13,0Zm-1.4.81a.08.08,0,0,1,0-.07.15.15,0,0,1,.08-.08l.57-.34a.37.37,0,0,1,.15,0,.22.22,0,0,1,.12,0l2.44,1.41a.05.05,0,0,1,0,.07s0,.06-.07.08l-.58.33a.34.34,0,0,1-.14.05l-.13,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.33,449.55l-.94.55-.14,0a.24.24,0,0,1-.13,0l-.54-.31a.09.09,0,0,1,0-.08.15.15,0,0,1,.08-.08l.94-.54-.66-.39s0,0,0-.07a.13.13,0,0,1,.07-.08l.58-.34.14,0a.24.24,0,0,1,.13,0l.66.39.95-.55a.33.33,0,0,1,.14,0,.18.18,0,0,1,.13,0l.54.31s0,0,0,.07a.18.18,0,0,1-.07.09l-.94.54.66.38s0,0,0,.07a.15.15,0,0,1-.07.09l-.58.33a.33.33,0,0,1-.14,0,.17.17,0,0,1-.13,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.52,459.22a6.63,6.63,0,0,0,3.32-.79l89.42-51.62a2.39,2.39,0,0,0,1.37-1.85c0,.79,0,6.42,0,7.1a2.31,2.31,0,0,1-1.37,1.9l-89.41,51.62a6.64,6.64,0,0,1-3.31.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.78,427.59v0a2.28,2.28,0,0,0,1.37,2l50.1,28.92a6.62,6.62,0,0,0,3.27.79v7.15a6.67,6.67,0,0,1-3.29-.79l-50.1-28.92a2.34,2.34,0,0,1-1.37-1.88C299.75,434.08,299.77,428.28,299.78,427.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.88,377.43h0a1.77,1.77,0,0,1,.82.2l45.78,26.43a.5.5,0,0,1,0,.95l-18.55,10.71a1.84,1.84,0,0,1-1.65,0l-26.37-15.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.51,388.34l18.54-10.71a1.73,1.73,0,0,1,.83-.2l0,23.05-18.68-10.77-.72-.42A.5.5,0,0,1,374.51,388.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.23,389.71l17.83-10.29a1.78,1.78,0,0,1,1.65,0l45,26-17.82,10.29a1.84,1.84,0,0,1-1.65,0Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.23,389.71l17.83-10.29a1.78,1.78,0,0,1,1.65,0l45,26-17.82,10.29a1.84,1.84,0,0,1-1.65,0Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M389,391.3l-1.6-.93a.86.86,0,0,1-.51-1,1.94,1.94,0,0,1,1-1.15,1.33,1.33,0,0,1,.5-.15.81.81,0,0,1,.44.07c.11.07.16.15.13.26a.53.53,0,0,1-.26.28,1,1,0,0,0-.53.58.45.45,0,0,0,.26.51l1.61.92a1.47,1.47,0,0,0,.88.15,2.38,2.38,0,0,0,1-.3l1.36-.79a2.61,2.61,0,0,1-1.1-.29l-1.61-.93a.88.88,0,0,1-.51-1,2.06,2.06,0,0,1,1.05-1.15l1.07-.61a4.69,4.69,0,0,1,2-.61,3,3,0,0,1,1.77.3l1.6.92a.89.89,0,0,1,.52,1,2,2,0,0,1-1.05,1.14L392.72,391a4.68,4.68,0,0,1-2,.6A3,3,0,0,1,389,391.3Zm7.24-3.24a1,1,0,0,0,.52-.57.44.44,0,0,0-.26-.52l-1.6-.92a1.52,1.52,0,0,0-.89-.15,2.38,2.38,0,0,0-1,.3l-1.07.62a1,1,0,0,0-.52.57.44.44,0,0,0,.25.51l1.61.93a1.49,1.49,0,0,0,.88.15,2.38,2.38,0,0,0,1-.3Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M398.6,390.37c-.07.05-.11.09-.12.15s0,.09.06.12l2.21,1.28a.87.87,0,0,1,.5,1,2,2,0,0,1-1,1.14l-1.07.62a4.83,4.83,0,0,1-2,.61,3,3,0,0,1-1.76-.3l-1.61-.93a.85.85,0,0,1-.5-1,1.94,1.94,0,0,1,1-1.15,1.08,1.08,0,0,1,.5-.15.83.83,0,0,1,.44.07.23.23,0,0,1,.13.26.51.51,0,0,1-.27.28,1,1,0,0,0-.52.58.43.43,0,0,0,.26.51l1.6.92a1.49,1.49,0,0,0,.88.15,2.38,2.38,0,0,0,1-.3l1.07-.62a1,1,0,0,0,.52-.57.43.43,0,0,0-.26-.51l-2.4-1.39a.43.43,0,0,1-.26-.51,1,1,0,0,1,.52-.58l2.68-1.54a1.08,1.08,0,0,1,.5-.15.76.76,0,0,1,.44.07l4,2.32a.21.21,0,0,1,.13.25c0,.11-.11.2-.26.29a1.28,1.28,0,0,1-.49.15.74.74,0,0,1-.44-.08l-3.41-2a.38.38,0,0,0-.22,0,.57.57,0,0,0-.26.08Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M401.82,398.72l-1.61-.93a.87.87,0,0,1-.51-1,2,2,0,0,1,1.05-1.15l4.28-2.47a4.69,4.69,0,0,1,2-.61,3,3,0,0,1,1.76.3l1.61.93a.85.85,0,0,1,.5,1,1.94,1.94,0,0,1-1,1.15l-4.28,2.47a4.93,4.93,0,0,1-2,.61A3,3,0,0,1,401.82,398.72Zm-.54-1.54,1.61.92a1.18,1.18,0,0,0,.51.15l2.34-4.58-4.19,2.42a1,1,0,0,0-.52.58A.44.44,0,0,0,401.28,397.18Zm8-2.79-1.6-.92a1.28,1.28,0,0,0-.52-.15l-2.34,4.58,4.2-2.42a1,1,0,0,0,.52-.58A.43.43,0,0,0,409.31,394.39Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M407.84,402.2l-2.41-1.39c-.11-.07-.16-.15-.13-.26a.46.46,0,0,1,.26-.28,1,1,0,0,1,.5-.15.68.68,0,0,1,.44.07l.8.46,5.36-3.09a1,1,0,0,0,.52-.57.44.44,0,0,0-.24-.51h0a.23.23,0,0,1-.13-.26.49.49,0,0,1,.26-.28,1.08,1.08,0,0,1,.5-.15.68.68,0,0,1,.44.07h0a.85.85,0,0,1,.51,1,2,2,0,0,1-1,1.14l-5.36,3.09.81.47a.21.21,0,0,1,.12.26.49.49,0,0,1-.26.28,1,1,0,0,1-.5.15A.78.78,0,0,1,407.84,402.2Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M413.06,405.21l-1.6-.92a.86.86,0,0,1-.51-1,2,2,0,0,1,1-1.15l4.29-2.47a4.68,4.68,0,0,1,2-.6,3,3,0,0,1,1.77.29l1.6.93a.86.86,0,0,1,.51,1,2,2,0,0,1-1,1.14l-4.29,2.48a4.68,4.68,0,0,1-2,.6A3,3,0,0,1,413.06,405.21Zm-.53-1.54,1.6.93a1.4,1.4,0,0,0,.52.14l2.34-4.57-4.19,2.42a1,1,0,0,0-.53.57A.45.45,0,0,0,412.53,403.67Zm8-2.78L419,400a1.06,1.06,0,0,0-.51-.14l-2.34,4.57,4.19-2.42a1,1,0,0,0,.53-.57A.44.44,0,0,0,420.56,400.89Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M421.14,409.69a.77.77,0,0,1-.45-.07.22.22,0,0,1-.13-.25.53.53,0,0,1,.27-.29l3-1.72a2.61,2.61,0,0,1-1.1-.29l-1.6-.93a.85.85,0,0,1-.51-1,2,2,0,0,1,1-1.14l2.68-1.55a1.28,1.28,0,0,1,.49-.15.81.81,0,0,1,.44.07c.11.07.16.15.13.26a.5.5,0,0,1-.26.29l-2.67,1.54a1,1,0,0,0-.53.58.43.43,0,0,0,.26.5l1.6.93a1.52,1.52,0,0,0,.89.15,2.38,2.38,0,0,0,1-.3l2.68-1.55a1.28,1.28,0,0,1,.49-.15.75.75,0,0,1,.44.07.23.23,0,0,1,.13.26.54.54,0,0,1-.26.29l-7.5,4.32A1,1,0,0,1,421.14,409.69Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--magnifying-glass--inject-73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Glass--inject-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.08,156.91v21.43c0,11.63,7.68,23.26,23.06,32.13,30.74,17.75,80.58,17.75,111.32,0,15.38-8.87,23.06-20.5,23.06-32.13V156.91h0c0-11.63-7.68-23.26-23.06-32.14-30.74-17.75-80.58-17.75-111.32,0-15.38,8.88-23.06,20.51-23.06,32.14Zm149.83,0c0,9.31-6.84,18.38-19.25,25.55-13.73,7.92-32.15,12.29-51.86,12.29s-38.13-4.37-51.86-12.29c-12.41-7.17-19.25-16.24-19.25-25.55s6.84-18.38,19.25-25.54c13.73-7.93,32.15-12.3,51.86-12.3s38.13,4.37,51.86,12.3C317.07,138.53,323.91,147.61,323.91,156.91Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.44,180.34c-1.22,7.36-4.47,12.91-17.54,23.12-18.48,14.43-65.28,20.33-92.45,11.36-25.61-8.46-33.78-25-33.78-36.33l.06-6.66c-3.95-4.72-6-9.78-6-14.92s2.19-10.45,6.34-15.27l.09-9.38h-1.46c-8.39,7.47-12.58,16.06-12.58,24.65v21.43c0,11.63,7.68,23.26,23.06,32.13,30.74,17.75,80.58,17.75,111.32,0C323,202.11,330.61,191.29,331.44,180.34Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.47,124.77c-30.74-17.75-80.59-17.75-111.33,0s-30.74,46.53,0,64.28,80.59,17.75,111.33,0S339.21,142.52,308.47,124.77Zm-3.81,57.69c-13.73,7.92-32.14,12.29-51.85,12.29s-38.13-4.37-51.86-12.29c-12.42-7.17-19.25-16.24-19.25-25.55s6.83-18.38,19.25-25.54c13.73-7.93,32.14-12.3,51.86-12.3s38.12,4.37,51.85,12.3c12.42,7.16,19.25,16.24,19.25,25.54S317.08,175.29,304.66,182.46Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.47,124.77c-30.74-17.75-80.59-17.75-111.33,0s-30.74,46.53,0,64.28,80.59,17.75,111.33,0S339.21,142.52,308.47,124.77Zm-3.81,57.69c-13.73,7.92-32.14,12.29-51.85,12.29s-38.13-4.37-51.86-12.29c-12.42-7.17-19.25-16.24-19.25-25.55s6.83-18.38,19.25-25.54c13.73-7.93,32.14-12.3,51.86-12.3s38.12,4.37,51.85,12.3c12.42,7.16,19.25,16.24,19.25,25.54S317.08,175.29,304.66,182.46Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.92,156.91a21.09,21.09,0,0,1-3.08,10.72c-3.12-5.41-8.61-10.48-16.18-14.83-13.72-7.93-32.14-12.3-51.86-12.3s-38.13,4.37-51.85,12.3c-7.56,4.35-13.06,9.42-16.2,14.83a21.26,21.26,0,0,1-3.06-10.72c0-9.3,6.84-18.38,19.26-25.55,13.72-7.92,32.15-12.29,51.85-12.29s38.14,4.37,51.86,12.29C317.08,138.53,323.92,147.61,323.92,156.91Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,131.36c-12.42,7.17-19.26,16.25-19.26,25.55a21.26,21.26,0,0,0,3.06,10.72c3.14-5.41,8.64-10.48,16.2-14.83a76.31,76.31,0,0,1,10-4.79c-3,1.16-12.21,4.12-8.86-4.66,4-10.43,23.47-21.72,37.79-23.6v0C225.11,121.21,211.61,125.21,201,131.36Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.66,141.07c-13.73-7.93-32.14-12.3-51.85-12.3s-38.13,4.37-51.86,12.3c-10.25,5.91-16.68,13.12-18.62,20.69,1.94,7.57,8.37,14.78,18.62,20.7,13.73,7.92,32.14,12.29,51.86,12.29s38.12-4.37,51.85-12.29c10.25-5.92,16.68-13.13,18.62-20.7C321.34,154.19,314.91,147,304.66,141.07Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.71,203.63a10.49,10.49,0,0,1,4.71-8.23,3.35,3.35,0,0,1,3.33-.35h0l22.76,13h0a3.35,3.35,0,0,1,1.39,3.05,10.48,10.48,0,0,1-4.71,8.23,3.34,3.34,0,0,1-3.35.35h0l-22.76-13h0A3.3,3.3,0,0,1,307.71,203.63Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.13,206.69a3.3,3.3,0,0,1-1.42-3.06,9,9,0,0,1,.81-3.55l29.35,16.79a8.92,8.92,0,0,1-2.64,2.47,3.34,3.34,0,0,1-3.35.35l-22.76-13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401,239.13h0l-59.13-31h0l-.06,0h0c-1.11-.6-2.62-.49-4.28.48a13.64,13.64,0,0,0-6.13,10.7c0,2,.71,3.35,1.83,4L389.75,259l0,0a11.27,11.27,0,0,0,5.79,1.59A11.42,11.42,0,0,0,401,239.13Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.23,239.26a5.54,5.54,0,0,1-3.12,10.12,5.46,5.46,0,0,1-2.55-.62h0l-62.12-36a12.84,12.84,0,0,0-2.05,6.49c0,2,.71,3.35,1.83,4L389.75,259l0,0a11.41,11.41,0,1,0,11.46-19.74Z",
    style: {
      opacity: 0.2
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage6);
export default __webpack_public_path__ + "static/media/image_6.28937a462e1aa59f0d9325123155dc85.svg";
export { ForwardRef as ReactComponent };